
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("12t1c", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");


var $culkJ = parcelRequire("culkJ");


var $3v0xY = parcelRequire("3v0xY");


var $aXWIB = parcelRequire("aXWIB");

const $614604228efdb790$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.jira",
        defaultMessage: "Jira"
    }
});


const $e306a0f1948559b4$var$icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.JiraIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $e306a0f1948559b4$export$b34e755010aed2b2 = (fallbackUrl, options = {})=>(0, $3v0xY.useAppGlobalShortcutLinkItem)($e306a0f1948559b4$var$icon, (0, $614604228efdb790$export$defe85febe8b728c).label, fallbackUrl, {
        apsKey: (0, $culkJ.Products).JIRA_SOFTWARE,
        analyticsName: (0, $culkJ.Products).JIRA_SOFTWARE,
        ...options
    });
module.exports["useJira"] = $e306a0f1948559b4$export$b34e755010aed2b2;

});

parcelRegister("ikOWI", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $4IT4p = parcelRequire("4IT4p");




const $65ddfdee4001ff48$export$a5c3144306783a42 = /*#__PURE__*/ (0, $42omo.createContext)({
    impressedProducts: {
        JIRA_SOFTWARE: false,
        CONFLUENCE: false
    }
});



var $87q77 = parcelRequire("87q77");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $jSnXV = parcelRequire("jSnXV");











const $b2406d6da031c213$export$437ae3f50102760d = (0, $42omo.createContext)({
    status: 'idle'
});
const $b2406d6da031c213$export$66a70772711988d1 = (0, $42omo.createContext)(()=>{});
const $b2406d6da031c213$export$69c89392124bbb84 = ()=>(0, $42omo.useContext)($b2406d6da031c213$export$437ae3f50102760d);
const $b2406d6da031c213$export$5c3e277aaa23ea00 = ()=>(0, $42omo.useContext)($b2406d6da031c213$export$66a70772711988d1);


/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $5nBzc = parcelRequire("5nBzc");


var $dh538 = parcelRequire("dh538");


var $iXCQx = parcelRequire("iXCQx");




const $8640c6d7c63a6659$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    invitedLozenge: {
        id: "cross-join-nudges.invited-app-shortcuts.invited-lozenge",
        defaultMessage: "Invited"
    },
    popupMainTextWithCollaborators: {
        id: "cross-join-nudges.invited-app-shortcuts.popup-main-text-with-collaborators",
        defaultMessage: "You're invited to join your team"
    },
    popupMainTextWithoutCollaborators: {
        id: "cross-join-nudges.invited-app-shortcuts.popup-main-text-without-collaborators",
        defaultMessage: "Don't lose access, accept invite now"
    },
    popupAcceptInviteButton: {
        id: "cross-join-nudges.invited-app-shortcuts.popup-accept-invite-button",
        defaultMessage: "Accept invite"
    },
    popupCollaboratorsTooltip: {
        id: "cross-join-nudges.invited-app-shortcuts.popup-collaborators-tooltip",
        defaultMessage: "{numberOfCollaborators} more {numberOfCollaborators, plural, one {teammate} other {teammates}} are using {app}"
    },
    jira: {
        id: "cross-join-nudges.invited-app-shortcuts.jira",
        defaultMessage: "Jira"
    },
    confluence: {
        id: "cross-join-nudges.invited-app-shortcuts.confluence",
        defaultMessage: "Confluence"
    }
});









const $51b65974b4fc3d58$var$styles = {
    container: "_1e0c11p5 _yv0e5bpd _4cvr1h6o _1bsb1osq",
    lozengeContainer: "_1e0c1txw _1bahesu3 _4cvr1h6o _1ul9idpf"
};

const $51b65974b4fc3d58$export$f60dc2630a14000a = ({ label: label, apsKey: apsKey })=>{
    const { impressedProducts: impressedProducts } = (0, $42omo.useContext)((0, $65ddfdee4001ff48$export$a5c3144306783a42));
    const hasAlreadySeenThisInvitedAppShortcut = impressedProducts[apsKey];
    const [AnimatedLozengeComponent, setAnimatedLozengeComponent] = (0, $42omo.useState)(null);
    const { fireViewedAnimatedLozenge: fireViewedAnimatedLozenge } = (0, $87q77.useInvitedAppAnalytics)();
    (0, $42omo.useEffect)(()=>{
        // Keep SSR and initial hydration light by rendering static Lozenge first.
        if (hasAlreadySeenThisInvitedAppShortcut) return;
         // Load animation code only for users who can actually see the animated treatment.
        (parcelRequire("9JGX1")).then((module)=>{
            setAnimatedLozengeComponent(module.default);
        });
    }, [
        hasAlreadySeenThisInvitedAppShortcut
    ]);
    (0, $42omo.useEffect)(()=>{
        if (AnimatedLozengeComponent && (0, $dh538.fg)('puma-1895-fire-viewed-animated-lozenge')) fireViewedAnimatedLozenge({
            app: (0, $4IT4p.getAppKeyByApsKey)(apsKey)
        });
    }, [
        AnimatedLozengeComponent,
        fireViewedAnimatedLozenge,
        apsKey
    ]);
    const LozengeComponent = !hasAlreadySeenThisInvitedAppShortcut && AnimatedLozengeComponent ? AnimatedLozengeComponent : (0, $5nBzc.default);
    const shouldRenderLozenge = hasAlreadySeenThisInvitedAppShortcut || AnimatedLozengeComponent !== null;
    return /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $51b65974b4fc3d58$var$styles.container
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $iXCQx.default), null, label), /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            $51b65974b4fc3d58$var$styles.lozengeContainer
        ])
    }, shouldRenderLozenge ? /*#__PURE__*/ $42omo.createElement(LozengeComponent, {
        appearance: "inprogress"
    }, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $8640c6d7c63a6659$export$defe85febe8b728c).invitedLozenge)) : null));
};


/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $2Pg7f = parcelRequire("2Pg7f");


var $2Nwuj = parcelRequire("2Nwuj");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");











/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $3gadb = parcelRequire("3gadb");

var $afneb = parcelRequire("afneb");








const $b05af80e5a47c692$var$styles = {
    root: "_2rkofajl _11c8wadc _vchhusvi _p12f1mjv _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna"
}; /**
    * As truncate is deprecated, we need to use a custom tooltip component to ensure the tooltip can show the message in one line.
    */ 
const $b05af80e5a47c692$var$CustomTooltip = /*#__PURE__*/ (0, $42omo.forwardRef)(function CustomTooltip({ children: children, className: className, ...rest }, ref) {
    return /*#__PURE__*/ $42omo.createElement((0, $afneb.default), {
        ...rest,
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $gMc0m.default)([
            $b05af80e5a47c692$var$styles.root,
            className
        ]),
        ref: ref,
        testId: "invited-app-collaborators-tooltip"
    }, children);
});
const $b05af80e5a47c692$export$cb6b49c74b6579bc = ({ children: children, currentApsKey: currentApsKey, currentAppCollaborators: currentAppCollaborators })=>{
    const { fireViewedMoreCollaboratorsTooltip: fireViewedMoreCollaboratorsTooltip } = (0, $87q77.useInvitedAppAnalytics)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const appMessage = (0, $42omo.useMemo)(()=>{
        switch(currentApsKey){
            case 'JIRA_SOFTWARE':
                return (0, $8640c6d7c63a6659$export$defe85febe8b728c).jira;
            case 'CONFLUENCE':
                return (0, $8640c6d7c63a6659$export$defe85febe8b728c).confluence;
        }
    }, [
        currentApsKey
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
        position: "right",
        component: $b05af80e5a47c692$var$CustomTooltip,
        onShow: ()=>fireViewedMoreCollaboratorsTooltip({
                app: (0, $4IT4p.getAppKeyByApsKey)(currentApsKey),
                collaborators: currentAppCollaborators.length
            }),
        content: /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $8640c6d7c63a6659$export$defe85febe8b728c).popupCollaboratorsTooltip,
            values: {
                numberOfCollaborators: currentAppCollaborators.length - 1,
                app: formatMessage(appMessage)
            }
        })
    }, children);
};



const $b694d0a41d5f2588$var$InvitedAppPopup = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8cLXS")).then((module)=>({
            default: module.InvitedAppPopup
        })));
/**
 * Renders the avatar group + tooltip for the given collaborators.
 * Returns `null` when there are no collaborators to show (loading / error /
 * idle / empty all collapse to this branch).
 */ const $b694d0a41d5f2588$var$PopupCollaboratorsBody = ({ collaborators: collaborators, currentApsKey: currentApsKey })=>{
    if (collaborators.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        grow: "hug"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
        data: collaborators.map((collaborator)=>({
                ...collaborator,
                appearance: 'circle',
                size: 'medium'
            })),
        maxCount: 2,
        overrides: {
            MoreIndicator: {
                render: (Component, props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b05af80e5a47c692$export$cb6b49c74b6579bc), {
                        currentApsKey: currentApsKey,
                        currentAppCollaborators: collaborators
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                        ...props,
                        isActive: false,
                        onClick: ()=>{}
                    }))
            }
        }
    }));
};
/**
 * Resolves the collaborator slice for a given `CollaboratorsSource`.
 * - `kind: 'static'` — synchronous read from the prop.
 * - `kind: 'lazy'`   — reads `useInvitedAppCollaboratorsLazy()` and slices
 *   by `app`. Loading / error / idle / missing-slice collapse to `[]`.
 */ const $b694d0a41d5f2588$var$useResolveCollaborators = (collaboratorsSource)=>{
    // Called unconditionally to keep hook order stable across variants. In
    // experiment mode the provider is not mounted, so this reads the default
    // `{ status: 'idle' }` — no re-renders since its identity is fixed at
    // module load.
    const lazyState = (0, $b2406d6da031c213$export$69c89392124bbb84)();
    if (collaboratorsSource.kind === 'static') return collaboratorsSource.collaborators;
    if (lazyState.status !== 'ready') return [];
    return lazyState.collaboratorsByApp[collaboratorsSource.app] ?? [];
}; /** Resolves collaborators + count + `hasCollaborators` for the popup. */ 
const $b694d0a41d5f2588$var$useCollaboratorsInfo = (collaboratorsSource)=>{
    const collaborators = $b694d0a41d5f2588$var$useResolveCollaborators(collaboratorsSource);
    return {
        collaborators: collaborators,
        collaboratorsCount: collaborators.length,
        hasCollaborators: collaborators.length > 0
    };
};
const $b694d0a41d5f2588$export$dcca2f78da63545d = ({ collaboratorsSource: collaboratorsSource, currentApsKey: currentApsKey, currentShortcutLink: currentShortcutLink, onAcceptInvite: onAcceptInvite, onMouseEnterPopup: onMouseEnterPopup, onMouseLeavePopup: onMouseLeavePopup, trigger: trigger })=>{
    const { fireLinkClickedAcceptInvite: fireLinkClickedAcceptInvite } = (0, $87q77.useInvitedAppAnalytics)();
    const { collaborators: collaborators, collaboratorsCount: collaboratorsCount, hasCollaborators: hasCollaborators } = $b694d0a41d5f2588$var$useCollaboratorsInfo(collaboratorsSource);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b694d0a41d5f2588$var$InvitedAppPopup, {
        trigger: trigger,
        onMouseEnterPopup: onMouseEnterPopup,
        onMouseLeavePopup: onMouseLeavePopup,
        currentApsKey: currentApsKey,
        hasCollaborators: hasCollaborators,
        collaboratorsCount: collaboratorsCount
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        alignBlock: "start",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, hasCollaborators ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $8640c6d7c63a6659$export$defe85febe8b728c).popupMainTextWithCollaborators) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $8640c6d7c63a6659$export$defe85febe8b728c).popupMainTextWithoutCollaborators)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: currentShortcutLink,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: ()=>{
            const app = (0, $4IT4p.getAppKeyByApsKey)(currentApsKey);
            fireLinkClickedAcceptInvite({
                app: app
            });
            onAcceptInvite(app);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $8640c6d7c63a6659$export$defe85febe8b728c).popupAcceptInviteButton)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b694d0a41d5f2588$var$PopupCollaboratorsBody, {
        collaborators: collaborators,
        currentApsKey: currentApsKey
    }))));
};


const $07978535ab26aba6$var$DEFAULT_HOVER_DELAY_MS = 300;
const $07978535ab26aba6$var$DEFAULT_PREFETCH_DEBOUNCE_MS = 100;
const $07978535ab26aba6$export$80ba7e5efcca528b = ({ shortcutsConfig: shortcutsConfig, resolverResult: resolverResult, hoverDelayTimeMs: hoverDelayTimeMs = $07978535ab26aba6$var$DEFAULT_HOVER_DELAY_MS, prefetchDebounceMs: prefetchDebounceMs = $07978535ab26aba6$var$DEFAULT_PREFETCH_DEBOUNCE_MS, excludeLastFromRefs: excludeLastFromRefs = 0, children: children })=>{
    const { fireViewedInvitedAppShortcuts: fireViewedInvitedAppShortcuts } = (0, $87q77.useInvitedAppAnalytics)();
    const prefetchAll = (0, $b2406d6da031c213$export$5c3e277aaa23ea00)();
    const [isPopupShown, setIsPopupShown] = (0, $42omo.useState)(false);
    const closePopupTimerRef = (0, $42omo.useRef)(null);
    const jiraShortcutRef = (0, $42omo.useRef)(null);
    const confluenceShortcutRef = (0, $42omo.useRef)(null);
    const unbindFunctionsRef = (0, $42omo.useRef)(new Map());
    const [currentShortcutRef, setCurrentShortcutRef] = (0, $42omo.useState)();
    const shortcutRefs = (0, $42omo.useMemo)(()=>({
            JIRA_SOFTWARE: jiraShortcutRef,
            CONFLUENCE: confluenceShortcutRef
        }), []);
    const clearClosePopupTimer = (0, $42omo.useCallback)(()=>{
        if (closePopupTimerRef.current) {
            clearTimeout(closePopupTimerRef.current);
            closePopupTimerRef.current = null;
        }
    }, []);
    const hidePopup = (0, $42omo.useCallback)(()=>{
        setIsPopupShown(false);
        setCurrentShortcutRef(undefined);
    }, []);
    const showPopup = (0, $42omo.useCallback)(()=>{
        setIsPopupShown(true);
    }, []);
    const startClosePopupTimer = (0, $42omo.useCallback)(()=>{
        clearClosePopupTimer();
        closePopupTimerRef.current = setTimeout(hidePopup, hoverDelayTimeMs);
    }, [
        clearClosePopupTimer,
        hidePopup,
        hoverDelayTimeMs
    ]); // Debounced singleton prefetch — quick cursor sweeps don't fire the
    // request; an already in-flight HTTP request is never cancelled.
    const debouncedPrefetchAll = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>prefetchAll(), prefetchDebounceMs, {
            leading: false,
            trailing: true
        }), [
        prefetchAll,
        prefetchDebounceMs
    ]);
    (0, $42omo.useEffect)(()=>()=>debouncedPrefetchAll.cancel(), [
        debouncedPrefetchAll
    ]);
    const handleMouseOverWithRef = (0, $42omo.useCallback)((targetRef)=>()=>{
            clearClosePopupTimer();
            setCurrentShortcutRef(targetRef);
            showPopup();
            debouncedPrefetchAll();
        }, [
        clearClosePopupTimer,
        showPopup,
        debouncedPrefetchAll
    ]); // Direct handler (no factory) — it doesn't capture per-ref state, so a
    // single stable function can be re-used across both `mouseleave` and
    // `blur` bindings without allocating duplicates per ref.
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        debouncedPrefetchAll.cancel();
        startClosePopupTimer();
    }, [
        startClosePopupTimer,
        debouncedPrefetchAll
    ]);
    const setShortcutRef = (0, $42omo.useCallback)((targetRef)=>(node)=>{
            const existing = unbindFunctionsRef.current.get(targetRef);
            if (existing) {
                existing();
                unbindFunctionsRef.current.delete(targetRef);
            } // oxlint-disable-next-line no-param-reassign
            targetRef.current = node;
            if (node) {
                const mouseoverListener = handleMouseOverWithRef(targetRef);
                const focusListener = handleMouseOverWithRef(targetRef);
                const unbind = (0, $fFa3V.bindAll)(node, [
                    {
                        type: 'mouseover',
                        listener: mouseoverListener
                    },
                    {
                        type: 'focus',
                        listener: focusListener
                    },
                    {
                        type: 'mouseleave',
                        listener: handleMouseLeave
                    },
                    {
                        type: 'blur',
                        listener: handleMouseLeave
                    }
                ]);
                unbindFunctionsRef.current.set(targetRef, unbind);
            }
        }, [
        handleMouseOverWithRef,
        handleMouseLeave
    ]);
    const handleOnMouseEnterPopup = (0, $42omo.useCallback)(()=>{
        clearClosePopupTimer();
        if (currentShortcutRef?.current) {
            const { parentElement: parentElement } = currentShortcutRef.current;
            if (parentElement) parentElement.style.backgroundColor = "var(--ds-surface-hovered, #F0F1F2)";
        }
        showPopup();
    }, [
        clearClosePopupTimer,
        showPopup,
        currentShortcutRef
    ]);
    const handleOnMouseLeavePopup = (0, $42omo.useCallback)(()=>{
        if (currentShortcutRef?.current) {
            const { parentElement: parentElement } = currentShortcutRef.current;
            if (parentElement) parentElement.style.backgroundColor = '';
        }
        startClosePopupTimer();
    }, [
        currentShortcutRef,
        startClosePopupTimer
    ]);
    const referrableShortcuts = (0, $42omo.useMemo)(()=>{
        const entries = Object.entries(shortcutsConfig);
        const max = Math.min(entries.length, Object.values(resolverResult.invitedApps ?? {}).filter((app)=>app?.eligible).length);
        const refsLimit = max - excludeLastFromRefs;
        let createdRefsCount = 0;
        return entries.reduce((acc, [key, shortcut])=>{
            if (createdRefsCount < refsLimit && shortcut.type === 'link' && shortcut.apsKey && resolverResult.invitedApps?.[(0, $4IT4p.getAppKeyByApsKey)(shortcut.apsKey)]?.eligible) {
                const apsKey = shortcut.apsKey;
                const targetRef = shortcutRefs[apsKey];
                acc[key] = {
                    ...shortcut,
                    ref: targetRef ? setShortcutRef(targetRef) : undefined,
                    labelElem: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $51b65974b4fc3d58$export$f60dc2630a14000a), {
                        apsKey: apsKey,
                        label: shortcut.label
                    })
                }; // oxlint-disable-next-line no-plusplus
                createdRefsCount++;
            } else acc[key] = shortcut;
            return acc;
        }, {});
    }, [
        shortcutsConfig,
        resolverResult.invitedApps,
        excludeLastFromRefs,
        shortcutRefs,
        setShortcutRef
    ]);
    const currentApsKey = (0, $42omo.useMemo)(()=>{
        const entry = Object.entries(shortcutRefs).find(([, ref])=>ref === currentShortcutRef);
        return entry ? entry[0] : undefined;
    }, [
        currentShortcutRef,
        shortcutRefs
    ]);
    const currentApp = currentApsKey ? (0, $4IT4p.getAppKeyByApsKey)(currentApsKey) : undefined;
    const collaboratorsSource = (0, $42omo.useMemo)(()=>currentApp ? {
            kind: 'lazy',
            app: currentApp
        } : undefined, [
        currentApp
    ]);
    const handleAcceptInvite = (0, $42omo.useCallback)((app)=>resolverResult?.registerActivation(app), [
        resolverResult
    ]);
    const currentShortcutLink = (0, $42omo.useMemo)(()=>currentShortcutRef?.current?.href, [
        currentShortcutRef
    ]);
    (0, $42omo.useEffect)(()=>()=>{
            unbindFunctionsRef.current.forEach((unbind)=>unbind());
            unbindFunctionsRef.current.clear();
            clearClosePopupTimer();
        }, [
        clearClosePopupTimer
    ]);
    (0, $42omo.useEffect)(()=>{
        // Collect target-app keys for shortcuts we attached a ref to. Mirrors
        // the Inner reducer pattern; analytics signature expects target-app
        // keys (e.g. `confluence` / `jira`) not aps keys.
        const invitedAppShortcutKeys = Object.values(referrableShortcuts).reduce((acc, shortcut)=>{
            if (shortcut.type === 'link' && (0, $4IT4p.isAllowedApsKey)(shortcut.apsKey) && !!shortcut.ref) acc.push((0, $4IT4p.getAppKeyByApsKey)(shortcut.apsKey));
            return acc;
        }, []);
        if (invitedAppShortcutKeys.length > 0) // Productionisation mode: Post Office owns impressions, so the
        // "first impressed" list is always empty — pass `[]` to keep the
        // analytics signature intact.
        fireViewedInvitedAppShortcuts(invitedAppShortcutKeys, []);
    }, [
        referrableShortcuts,
        fireViewedInvitedAppShortcuts
    ]); // Productionisation mode: impressions are owned by Post Office. The
    // productionisation hook never sets `firstImpressionAt`, so the legacy
    // `impressedProducts` flags are always `false` here by construction.
    const contextValue = (0, $42omo.useMemo)(()=>({
            impressedProducts: {
                JIRA_SOFTWARE: false,
                CONFLUENCE: false
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $65ddfdee4001ff48$export$a5c3144306783a42).Provider, {
        value: contextValue
    }, children({
        referrableShortcuts: referrableShortcuts
    }), isPopupShown && currentShortcutRef && currentShortcutLink && currentApsKey && collaboratorsSource && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b694d0a41d5f2588$export$dcca2f78da63545d), {
        trigger: currentShortcutRef,
        onMouseEnterPopup: handleOnMouseEnterPopup,
        onMouseLeavePopup: handleOnMouseLeavePopup,
        currentApsKey: currentApsKey,
        collaboratorsSource: collaboratorsSource,
        currentShortcutLink: currentShortcutLink,
        onAcceptInvite: handleAcceptInvite
    }));
};






var $3Zy9L = parcelRequire("3Zy9L");





/**
 * Narrows a BFF `CollaboratorProduct` to the subset accepted by
 * `InvitedAppShortcutAllowedTargetAppKey`. Both describe `'jira' | 'confluence'`
 * today; this isolates the cast so the call site stays cast-free, and any
 * future BFF-only product is filtered out at runtime.
 */ const $39fa399d8ae20fc4$var$isAllowedTargetApp = (product, allowed)=>allowed.includes(product);
const $39fa399d8ae20fc4$export$86a637885215f4b1 = ({ cloudId: cloudId, userId: userId, eligibleApps: eligibleApps, sourceApp: sourceApp, children: children })=>{
    const analytics = (0, $87q77.useInvitedAppAnalytics)();
    const [state, setState] = (0, $42omo.useState)(()=>eligibleApps.length === 0 ? {
            status: 'ready',
            collaboratorsByApp: {}
        } : {
            status: 'idle'
        });
    // Singleton guard. Cleared on `.catch` for retry; kept after `.then`
    // so a successful fetch is never re-issued.
    const inFlightRef = (0, $42omo.useRef)(null);
    // Prevents state updates after unmount.
    const isMountedRef = (0, $42omo.useRef)(true);
    (0, $42omo.useEffect)(()=>()=>{
            isMountedRef.current = false;
        }, []);
    // Latest-props ref keeps `prefetchAll` identity-stable so an unmemoised
    // `eligibleApps` array doesn't invalidate hover handlers downstream.
    const depsRef = (0, $42omo.useRef)({
        analytics: analytics,
        cloudId: cloudId,
        eligibleApps: eligibleApps,
        sourceApp: sourceApp,
        userId: userId
    });
    depsRef.current = {
        analytics: analytics,
        cloudId: cloudId,
        eligibleApps: eligibleApps,
        sourceApp: sourceApp,
        userId: userId
    };
    const prefetchAll = (0, $42omo.useCallback)(()=>{
        if (inFlightRef.current !== null) return;
        const { analytics: analytics, cloudId: cloudId, eligibleApps: eligibleApps, sourceApp: sourceApp, userId: userId } = depsRef.current;
        if (eligibleApps.length === 0) // Nothing to fetch; provider is already in the `ready` empty state.
        return;
        setState({
            status: 'loading'
        });
        // Cross-validated against `InvitedAppShortcutAllowedTargetAppKey` inside
        // the response loop via `isAllowedTargetApp`. Any future BFF-only
        // product will be filtered out, never indexed into `collaboratorsByApp`.
        const products = eligibleApps;
        // Guard against a synchronous throw before the Promise is created —
        // otherwise `setState('loading')` would leave the provider stuck.
        let pending;
        try {
            pending = (0, $3Zy9L.getCollaboratorsInProducts)({
                cloudId: cloudId,
                userId: userId,
                products: products
            });
        } catch (error) {
            inFlightRef.current = null;
            if (!isMountedRef.current) return;
            setState({
                status: 'error',
                error: error
            });
            analytics.fireFetchCollaboratorsAccessFailed({
                sourceApp: sourceApp,
                targetApps: eligibleApps,
                error: error instanceof Error ? error.message : 'unknown'
            });
            return;
        }
        inFlightRef.current = pending.then((rows)=>{
            if (!isMountedRef.current) return;
            const collaboratorsByApp = {};
            for (const { collaborator: collaborator, products: collaboratorProducts } of rows)for (const product of collaboratorProducts){
                if (!$39fa399d8ae20fc4$var$isAllowedTargetApp(product, eligibleApps)) continue;
                // `product` is narrowed to `InvitedAppShortcutAllowedTargetAppKey`.
                const slice = collaboratorsByApp[product] ?? [];
                slice.push({
                    key: collaborator.id,
                    name: collaborator.name,
                    src: collaborator.avatar
                });
                collaboratorsByApp[product] = slice;
            }
            setState({
                status: 'ready',
                collaboratorsByApp: collaboratorsByApp
            });
            analytics.fireFetchCollaboratorsAccessSucceeded({
                sourceApp: sourceApp,
                targetApps: eligibleApps,
                collaborators: rows.length
            });
        }).catch((error)=>{
            // Allow caller-driven retry on the next hover when the fetch
            // failed (network blip, 5xx, etc.). Successful fetches keep
            // the ref set so they are not re-issued.
            inFlightRef.current = null;
            if (!isMountedRef.current) return;
            setState({
                status: 'error',
                error: error
            });
            analytics.fireFetchCollaboratorsAccessFailed({
                sourceApp: sourceApp,
                targetApps: eligibleApps,
                // Normalize to avoid leaking raw server error detail into analytics.
                error: error instanceof Error ? error.message : 'unknown'
            });
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b2406d6da031c213$export$66a70772711988d1).Provider, {
        value: prefetchAll
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b2406d6da031c213$export$437ae3f50102760d).Provider, {
        value: state
    }, children));
};




class $eb94a7a15b9af3a3$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error, _errorInfo) {
        this.props.fireInvitedAppShortcutsContainerRenderFailed({
            error: error.message,
            errorStack: error.stack,
            targetApps: Object.values(this.props.shortcutsConfig).map((shortcut)=>shortcut.analyticsName).filter(Boolean)
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback({
            referrableShortcuts: this.props.shortcutsConfig
        });
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
const $eb94a7a15b9af3a3$var$InvitedAppShortcutsContainerExperiment = ({ shortcutsConfig: shortcutsConfig, resolverResult: resolverResult, hoverDelayTimeMs: hoverDelayTimeMs = 300, excludeLastFromRefs: excludeLastFromRefs = 0, children: children })=>{
    const { fireViewedInvitedAppShortcuts: fireViewedInvitedAppShortcuts } = (0, $87q77.useInvitedAppAnalytics)(); // the popup shown state
    const [isPopupShown, setIsPopupShown] = (0, $42omo.useState)(false);
    const closePopupTimerRef = (0, $42omo.useRef)(null); // refs for the shortcut items
    const jiraShortcutRef = (0, $42omo.useRef)(null);
    const confluenceShortcutRef = (0, $42omo.useRef)(null); // Store unbind functions for cleanup
    const unbindFunctionsRef = (0, $42omo.useRef)(new Map()); // Ref for the current shortcut item
    // the current shortcut item is unset when the popup is hidden after a delay
    const [currentShortcutRef, setCurrentShortcutRef] = (0, $42omo.useState)(); // map of the shortcut items to their refs
    const shortcutRefs = (0, $42omo.useMemo)(()=>({
            JIRA_SOFTWARE: jiraShortcutRef,
            CONFLUENCE: confluenceShortcutRef
        }), // Refs are stable, no dependencies needed
    []);
    const showPopup = (0, $42omo.useCallback)(()=>{
        setIsPopupShown(true);
    }, [
        setIsPopupShown
    ]);
    const hidePopup = (0, $42omo.useCallback)(()=>{
        setIsPopupShown(false);
        setCurrentShortcutRef(undefined);
    }, [
        setIsPopupShown,
        setCurrentShortcutRef
    ]);
    const clearClosePopupTimer = (0, $42omo.useCallback)(()=>{
        if (closePopupTimerRef.current) {
            clearTimeout(closePopupTimerRef.current);
            closePopupTimerRef.current = null;
        }
    }, []);
    const startClosePopupTimer = (0, $42omo.useCallback)(()=>{
        clearClosePopupTimer();
        closePopupTimerRef.current = setTimeout(()=>{
            hidePopup();
        }, hoverDelayTimeMs);
    }, [
        clearClosePopupTimer,
        hoverDelayTimeMs,
        hidePopup
    ]); /**
                                                            * @param targetRef - the ref to the shortcut item
                                                            * @returns a handler for the mouse over event on the shortcut item
                                                            */ 
    const handleMouseOverWithRef = (0, $42omo.useCallback)((targetRef)=>()=>{
            // clear the close popup timer to avoid closing the popup
            // when moving the mouse from the popup to the shortcut item
            clearClosePopupTimer();
            setCurrentShortcutRef(targetRef);
            showPopup();
        }, [
        clearClosePopupTimer,
        showPopup
    ]); /**
                                          * @param targetRef - the ref to the shortcut item
                                          * @returns a handler for the mouse leave event on the shortcut item
                                          */ 
    const handleMouseLeaveWithRef = (0, $42omo.useCallback)(()=>()=>{
            if (currentShortcutRef?.current) currentShortcutRef.current.style.backgroundColor = '';
            startClosePopupTimer();
        }, [
        currentShortcutRef,
        startClosePopupTimer
    ]); /**
                                                   * @param targetRef - the ref to the shortcut item
                                                   * @returns a callback ref for a shortcut item
                                                   */ 
    const createShortcutRef = (0, $42omo.useCallback)((targetRef)=>(node)=>{
            // Cleanup previous element if it exists
            const existingUnbind = unbindFunctionsRef.current.get(targetRef);
            if (existingUnbind) {
                existingUnbind();
                unbindFunctionsRef.current.delete(targetRef);
            } // Store the new element
            // oxlint-disable-next-line no-param-reassign
            targetRef.current = node; // Attach listeners to new element
            if (node) {
                const mouseoverListener = handleMouseOverWithRef(targetRef);
                const focusListener = handleMouseOverWithRef(targetRef);
                const mouseleaveListener = handleMouseLeaveWithRef();
                const blurListener = handleMouseLeaveWithRef(); // Use bind-event-listener to bind all events and get an unbind function
                const unbind = (0, $fFa3V.bindAll)(node, [
                    {
                        type: 'mouseover',
                        listener: mouseoverListener
                    },
                    {
                        type: 'focus',
                        listener: focusListener
                    },
                    {
                        type: 'mouseleave',
                        listener: mouseleaveListener
                    },
                    {
                        type: 'blur',
                        listener: blurListener
                    }
                ]); // Store the unbind function for cleanup
                unbindFunctionsRef.current.set(targetRef, unbind);
            }
        }, [
        handleMouseOverWithRef,
        handleMouseLeaveWithRef
    ]); /**
                                                          * Handles the popup shown event
                                                          * @returns a handler for the popup shown event
                                                          */ 
    const handleOnMouseEnterPopup = (0, $42omo.useCallback)(()=>{
        // clear the close popup timer to avoid closing the popup too early
        clearClosePopupTimer();
        if (currentShortcutRef?.current) {
            // Get the parent element of the shortcut item
            const { parentElement: parentElement } = currentShortcutRef.current;
            if (parentElement) // reference the background color variable from the design system
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/4ff76dcfb3ce12b4344e5345be748ce472ac56e7/platform/packages/design-system/navigation-system/src/ui/menu-item/menu-item.tsx#lines-166
            parentElement.style.backgroundColor = "var(--ds-surface-hovered, #F0F1F2)";
        } // ensure the popup is shown when mouse leaves the shortcut item and over the popup
        showPopup();
    }, [
        clearClosePopupTimer,
        showPopup,
        currentShortcutRef
    ]); /**
                                                              * Handles the popup closed event
                                                              * @returns a handler for the popup closed event
                                                              */ 
    const handleOnMouseLeavePopup = (0, $42omo.useCallback)(()=>{
        if (currentShortcutRef?.current) {
            // Get the parent element of the shortcut item
            const { parentElement: parentElement } = currentShortcutRef.current;
            if (parentElement) parentElement.style.backgroundColor = '';
        }
        startClosePopupTimer();
    }, [
        currentShortcutRef,
        startClosePopupTimer
    ]);
    const referrableShortcuts = (0, $42omo.useMemo)(()=>{
        const entries = Object.entries(shortcutsConfig);
        const max = Math.min(entries.length, Object.values(resolverResult.invitedApps ?? {}).filter((app)=>app?.eligible).length);
        const refsLimit = max - excludeLastFromRefs;
        let createdRefsCount = 0;
        return entries.reduce((acc, [key, shortcut])=>{
            // only add ref to shortcuts that are within the refs limit
            // and if it is a link and the aps key is allowed
            if (createdRefsCount < refsLimit && shortcut.type === 'link' && shortcut.apsKey && resolverResult.invitedApps?.[(0, $4IT4p.getAppKeyByApsKey)(shortcut.apsKey)]?.eligible) {
                const apsKey = shortcut.apsKey;
                const app = (0, $4IT4p.getAppKeyByApsKey)(apsKey);
                const targetRef = shortcutRefs[apsKey];
                const originalOnClick = shortcut.onClick;
                acc[key] = {
                    ...shortcut,
                    onClick: (evt)=>{
                        resolverResult.registerActivation(app);
                        return originalOnClick?.(evt);
                    },
                    ref: targetRef ? createShortcutRef(targetRef) : undefined,
                    labelElem: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $51b65974b4fc3d58$export$f60dc2630a14000a), {
                        apsKey: apsKey,
                        label: shortcut.label
                    })
                }; // oxlint-disable-next-line no-plusplus
                createdRefsCount++;
            } else acc[key] = shortcut;
            return acc;
        }, {});
    }, [
        shortcutsConfig,
        resolverResult,
        createShortcutRef,
        shortcutRefs,
        excludeLastFromRefs
    ]);
    (0, $42omo.useEffect)(()=>{
        const currentUnbindFunctions = unbindFunctionsRef.current;
        const currentShortcutRefs = shortcutRefs;
        return ()=>{
            // Clean up all event listeners using the stored unbind functions
            Object.values(currentShortcutRefs).forEach((ref)=>{
                const unbind = currentUnbindFunctions.get(ref);
                if (unbind) {
                    unbind();
                    currentUnbindFunctions.delete(ref);
                }
            });
            clearClosePopupTimer();
        };
    }, [
        clearClosePopupTimer,
        shortcutRefs
    ]);
    const currentApsKey = (0, $42omo.useMemo)(()=>Object.keys(shortcutRefs).find((apsKey)=>currentShortcutRef?.current === shortcutRefs[apsKey]?.current), [
        shortcutRefs,
        currentShortcutRef
    ]);
    const currentAppKey = currentApsKey && (0, $4IT4p.getAppKeyByApsKey)(currentApsKey);
    const currentAppResolved = currentAppKey && resolverResult.invitedApps?.[currentAppKey];
    const currentAppCollaborators = (0, $42omo.useMemo)(()=>currentAppResolved?.collaborators?.map((collab)=>({
                name: '',
                src: collab?.avatar
            })) ?? [], [
        currentAppResolved?.collaborators
    ]); // Stable identity for the popup's discriminated union prop so the popup
    // boundary stays memo-friendly (avoids re-renders on unrelated container
    // updates). PUMA-1997 will introduce a `kind: 'lazy'` branch here.
    const collaboratorsSource = (0, $42omo.useMemo)(()=>({
            kind: 'static',
            collaborators: currentAppCollaborators
        }), [
        currentAppCollaborators
    ]); // Stable callback for the popup's accept-invite click. Re-created only
    // when `resolverResult` identity changes.
    const handleAcceptInvite = (0, $42omo.useCallback)((app)=>resolverResult?.registerActivation(app), [
        resolverResult
    ]);
    const currentShortcutLink = (0, $42omo.useMemo)(()=>currentShortcutRef?.current?.href, [
        currentShortcutRef
    ]);
    (0, $42omo.useEffect)(()=>{
        // These are the app keys for which we'll be displaying our treatment
        const invitedAppShortcutKeys = Object.values(referrableShortcuts).reduce((acc, shortcut)=>{
            if (shortcut.type === 'link' && (0, $4IT4p.isAllowedApsKey)(shortcut.apsKey) && !!shortcut.ref) acc.push((0, $4IT4p.getAppKeyByApsKey)(shortcut.apsKey));
            return acc;
        }, []);
        resolverResult.registerImpression({
            products: invitedAppShortcutKeys
        }); // Fire an analytics event when the user views the invited app shortcuts
        if (invitedAppShortcutKeys.length > 0) {
            const firstImpressedApps = invitedAppShortcutKeys.filter((app)=>!resolverResult.invitedApps?.[app]?.firstImpressionAt);
            fireViewedInvitedAppShortcuts(invitedAppShortcutKeys, firstImpressedApps);
        }
    }, [
        referrableShortcuts,
        resolverResult,
        fireViewedInvitedAppShortcuts
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $65ddfdee4001ff48$export$a5c3144306783a42).Provider, {
        value: (0, $42omo.useMemo)(()=>({
                impressedProducts: {
                    JIRA_SOFTWARE: $eb94a7a15b9af3a3$var$isAppImpressed(resolverResult.invitedApps?.jira),
                    CONFLUENCE: $eb94a7a15b9af3a3$var$isAppImpressed(resolverResult.invitedApps?.confluence)
                }
            }), [
            resolverResult.invitedApps
        ])
    }, children({
        referrableShortcuts: referrableShortcuts
    }), isPopupShown && currentShortcutRef && currentShortcutLink && currentApsKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b694d0a41d5f2588$export$dcca2f78da63545d), {
        trigger: currentShortcutRef,
        onMouseEnterPopup: handleOnMouseEnterPopup,
        onMouseLeavePopup: handleOnMouseLeavePopup,
        currentApsKey: currentApsKey,
        collaboratorsSource: collaboratorsSource,
        currentShortcutLink: currentShortcutLink,
        onAcceptInvite: handleAcceptInvite
    }));
};
const $eb94a7a15b9af3a3$export$a06354f64c80dd3d = (props)=>{
    const { fireInvitedAppShortcutsContainerRenderFailed: fireInvitedAppShortcutsContainerRenderFailed } = (0, $87q77.useInvitedAppAnalytics)(); // Branch first on the discriminant so each branch destructures with
    // full type narrowing (no `as` cast, no IIFE).
    if (props.mode === 'productionisation') {
        const { mode: _mode, cloudId: cloudId, userId: userId, recommendedApps: recommendedApps, sourceApp: sourceApp, ...inner } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eb94a7a15b9af3a3$var$ErrorBoundary, {
            fallback: inner.children,
            shortcutsConfig: inner.shortcutsConfig,
            fireInvitedAppShortcutsContainerRenderFailed: fireInvitedAppShortcutsContainerRenderFailed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39fa399d8ae20fc4$export$86a637885215f4b1), {
            cloudId: cloudId,
            userId: userId,
            eligibleApps: recommendedApps,
            sourceApp: sourceApp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $07978535ab26aba6$export$80ba7e5efcca528b), inner)));
    }
    const { mode: _mode, ...inner } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eb94a7a15b9af3a3$var$ErrorBoundary, {
        fallback: inner.children,
        shortcutsConfig: inner.shortcutsConfig,
        fireInvitedAppShortcutsContainerRenderFailed: fireInvitedAppShortcutsContainerRenderFailed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($eb94a7a15b9af3a3$var$InvitedAppShortcutsContainerExperiment, inner));
};
const $eb94a7a15b9af3a3$var$isAppImpressed = (appDetails)=>!!appDetails?.firstImpressionAt;
module.exports["InvitedAppShortcutsContainer"] = $eb94a7a15b9af3a3$export$a06354f64c80dd3d;

});

parcelRegister("4IT4p", function(module, exports) {

var $1mG05 = parcelRequire("1mG05");

const $511e8e2f0dc221c0$export$f45e7800f1f61594 = (apsKey)=>{
    if (!apsKey) return false;
    return (0, $1mG05.INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS).includes(apsKey);
};
const $511e8e2f0dc221c0$export$ab70dfefed87a731 = (targetApp)=>{
    if (!targetApp) return false;
    return (0, $1mG05.INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS).includes(targetApp);
};
const $511e8e2f0dc221c0$export$b8c071b2cc567f75 = (apsKey)=>{
    switch(apsKey){
        case 'JIRA_SOFTWARE':
            return 'jira';
        case 'CONFLUENCE':
            return 'confluence';
        default:
            // This should never happen, throw it just in case if we add a new APS key without adding a new app key
            throw new Error(`Invalid APS key: ${apsKey}`);
    }
};
module.exports["isAllowedApsKey"] = $511e8e2f0dc221c0$export$f45e7800f1f61594;
module.exports["getAppKeyByApsKey"] = $511e8e2f0dc221c0$export$b8c071b2cc567f75;

});

parcelRegister("87q77", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3pfAb = parcelRequire("3pfAb");


var $inPa6 = parcelRequire("inPa6");


var $c4TO3 = parcelRequire("c4TO3");

const $8e76a58f4a588ff2$export$85183a312807388d = (0, $3pfAb.FabricChannel).growth;
const $8e76a58f4a588ff2$export$43a7f5e28cb0f314 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isViewedInvitedAppShortcutsFired = (0, $42omo.useRef)(false);
    return (0, $42omo.useMemo)(()=>({
            /**
			 * Fire an analytics event when the user views the invited app shortcuts.
			 */ fireViewedInvitedAppShortcuts: (apps, firstImpressedApps)=>{
                if (isViewedInvitedAppShortcutsFired.current) return;
                createAnalyticsEvent({
                    eventType: 'screen',
                    name: 'invitedAppShortcuts',
                    attributes: {
                        apps: apps,
                        firstImpressedApps: firstImpressedApps
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
                isViewedInvitedAppShortcutsFired.current = true;
            },
            fireViewedInvitedAppShortcutPopup: ({ app: app, collaborators: collaborators })=>{
                createAnalyticsEvent({
                    eventType: 'screen',
                    name: 'invitedAppShortcutPopup',
                    attributes: {
                        app: app,
                        collaborators: collaborators
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            fireLinkClickedAcceptInvite: ({ app: app })=>{
                createAnalyticsEvent({
                    eventType: 'ui',
                    action: 'clicked',
                    actionSubject: 'link',
                    actionSubjectId: 'acceptInvite',
                    attributes: {
                        app: app
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            fireViewedMoreCollaboratorsTooltip: ({ app: app, collaborators: collaborators })=>{
                createAnalyticsEvent({
                    eventType: 'screen',
                    name: 'moreCollaboratorsTooltip',
                    attributes: {
                        app: app,
                        collaborators: collaborators
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            /**
			 * Fire an analytics event when eligibility for invited app shortcuts is checked.
			 *
			 * This event is deduplicated across sessions using a hashed key stored in local storage.
			 * If the combination of userId, cloudId, and ineligibilityReason has not changed since the
			 * last time the event was fired, subsequent calls are suppressed — even after page reloads.
			 *
			 * @param ineligibilityReason - the reason the user is ineligible
			 * @param userId - the current user's ID
			 * @param cloudId - the current cloud/site ID
			 */ fireInvitedAppShortcutsEligibilityChecked: async ({ ineligibilityReason: ineligibilityReason, userId: userId, cloudId: cloudId })=>{
                const rawCacheKey = `${userId ?? ''}:${cloudId ?? ''}:${ineligibilityReason}`;
                if (await $8e76a58f4a588ff2$var$hasAlreadyBeenFired($8e76a58f4a588ff2$var$ELIGIBILITY_CHECKED_STORAGE_KEY, rawCacheKey)) return;
                createAnalyticsEvent({
                    eventType: 'track',
                    action: 'checked',
                    actionSubject: 'eligibility',
                    attributes: {
                        flagKey: 'twcg-460-personalised-invite-notifications-m2',
                        ineligibilityReason: ineligibilityReason
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
                await $8e76a58f4a588ff2$var$markAsFired($8e76a58f4a588ff2$var$ELIGIBILITY_CHECKED_STORAGE_KEY, rawCacheKey);
            },
            /**
			 * Fire an analytics event when the feature is exposed.
			 *
			 * This event is deduplicated across sessions using a hashed key stored in local storage.
			 * If the combination of userId, cloudId, and isEnabled has not changed since the last time
			 * the event was fired, subsequent calls are suppressed — even after page reloads.
			 *
			 * When the event fires, the eligibility-checked storage key is also cleared so that
			 * eligibility is re-evaluated after the user enters the experiment.
			 *
			 * @param isEnabled - the experiment's isEnabled value
			 * @param userId - the current user's ID
			 * @param cloudId - the current cloud/site ID
			 */ fireFeatureExposed: async ({ isEnabled: isEnabled, userId: userId, cloudId: cloudId, mode: mode })=>{
                // Include the current date (YYYY-MM-DD) so the event fires at most once per day
                const today = new Date().toISOString().split('T')[0];
                const rawCacheKey = `${userId ?? ''}:${cloudId ?? ''}:${String(isEnabled)}:${today}`;
                if (await $8e76a58f4a588ff2$var$hasAlreadyBeenFired($8e76a58f4a588ff2$var$FEATURE_EXPOSED_STORAGE_KEY, rawCacheKey)) return;
                createAnalyticsEvent({
                    eventType: 'track',
                    action: 'exposed',
                    actionSubject: 'feature',
                    attributes: {
                        featureKey: mode === 'experiment' ? 'twcg-460-personalised-invite-notifications-m2' : 'twcg-460-preload-grs-invited-app-shortcuts',
                        cohort: isEnabled ? 'variant' : 'control',
                        mode: mode
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
                await $8e76a58f4a588ff2$var$markAsFired($8e76a58f4a588ff2$var$FEATURE_EXPOSED_STORAGE_KEY, rawCacheKey);
                // Clear the eligibility checked flag since the feature is now exposed,
                // so that the next eligibility check will fire.
                $8e76a58f4a588ff2$var$clearStorageKey($8e76a58f4a588ff2$var$ELIGIBILITY_CHECKED_STORAGE_KEY);
            },
            fireFetchInvitedAppShortcutsTraitsSucceeded: ({ sourceApp: sourceApp, targetApps: targetApps })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'succeeded',
                    actionSubject: 'fetchInvitedAppShortcutsTraits',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            fireFetchInvitedAppShortcutsTraitsFailed: ({ sourceApp: sourceApp, targetApps: targetApps })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'fetchInvitedAppShortcutsTraits',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            fireFetchCollaboratorsAccessSucceeded: ({ sourceApp: sourceApp, targetApps: targetApps, collaborators: collaborators })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'succeeded',
                    actionSubject: 'fetchCollaboratorsAccess',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps,
                        collaborators: collaborators
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            fireFetchCollaboratorsAccessFailed: ({ sourceApp: sourceApp, targetApps: targetApps, error: error })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'fetchCollaboratorsAccess',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps,
                        error: error
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            fireEligibilityUpdateSucceeded: ({ sourceApp: sourceApp, targetApps: targetApps })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'succeeded',
                    actionSubject: 'eligibilityUpdate',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            fireEligibilityUpdateFailed: ({ sourceApp: sourceApp, targetApps: targetApps, error: error })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'eligibilityUpdate',
                    attributes: {
                        sourceApp: sourceApp,
                        targetApps: targetApps,
                        error: error
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            fireInvitedAppShortcutsContainerRenderFailed: ({ targetApps: targetApps, error: error, errorStack: errorStack })=>{
                createAnalyticsEvent({
                    eventType: 'operational',
                    action: 'failed',
                    actionSubject: 'invitedAppShortcutsContainerRender',
                    attributes: {
                        targetApps: targetApps,
                        error: error,
                        errorStack: errorStack
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            fireAppAccessRemoved: ({ targetApps: targetApps })=>{
                createAnalyticsEvent({
                    eventType: 'track',
                    action: 'removed',
                    actionSubject: 'appAccess',
                    attributes: {
                        targetApps: targetApps
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            },
            fireViewedAnimatedLozenge: ({ app: app })=>{
                createAnalyticsEvent({
                    eventType: 'screen',
                    name: 'animatedLozenge',
                    attributes: {
                        app: app
                    }
                }).fire($8e76a58f4a588ff2$export$85183a312807388d);
            }
        }), [
        createAnalyticsEvent
    ]);
};
// ── Cross-session analytics dedup helpers ──────────────────────────────────────
//
// These helpers store a hashed fingerprint in local storage so that analytics
// events are only fired once per unique combination of parameters — even across
// page reloads. Each event type has its own storage key so they can be checked
// and cleared independently.
const $8e76a58f4a588ff2$var$ELIGIBILITY_CHECKED_STORAGE_KEY = 'invitedAppShortcuts.eligibilityChecked';
const $8e76a58f4a588ff2$var$FEATURE_EXPOSED_STORAGE_KEY = 'invitedAppShortcuts.featureExposed';
// In-memory cache of the latest hash written per analytics storage key.
// This preserves dedupe within the current page session even if localStorage fails.
const $8e76a58f4a588ff2$var$firedHashByStorageKey = new Map();
// Circuit breaker for browser storage writes.
// Once a storage write throws (e.g. quota exceeded), we stop touching localStorage
// and fall back to in-memory dedupe only to avoid repeated runtime errors.
let $8e76a58f4a588ff2$var$shouldUseLocalStorage = true;
/**
 * Produces a non-reversible hash of the given raw string so we never store
 * plain-text identifiers in local storage.
 *
 * Prefers SHA-256 via the Web Crypto API when available, otherwise falls back
 * to a synchronous FNV-1a 32-bit hash for environments where the Web Crypto API
 * is not supported.
 *
 * @param raw - the raw string to hash
 * @returns a hex-encoded hash string
 */ async function $8e76a58f4a588ff2$var$hashString(raw) {
    // Primary path: SHA-256 via the Web Crypto API.
    // crypto.subtle is available in all modern browsers but requires a secure context (HTTPS).
    // It may be unavailable in:
    //   - Non-HTTPS pages (e.g. http://localhost without a secure context flag)
    //   - SSR / Node environments where the Web Crypto API is not globally available
    //   - Very old browsers (pre-Chrome 37, pre-Firefox 34, pre-Safari 11)
    if (typeof crypto !== 'undefined' && crypto.subtle) try {
        const data = new TextEncoder().encode(raw);
        const hashBuffer = await crypto.subtle.digest('SHA-256', data);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        return hashArray.map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch  {
    // Fall through to the fallback hash
    }
    // Fallback: FNV-1a 32-bit hash.
    // Not cryptographically secure, but sufficient to avoid storing plain-text
    // identifiers in local storage. This path is only reached when the Web Crypto
    // API is unavailable (see conditions above) or throws unexpectedly.
    let hash = 0x811c9dc5;
    for(let i = 0; i < raw.length; i++){
        hash ^= raw.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193);
    }
    return (hash >>> 0).toString(16);
}
/**
 * Checks whether an analytics event has already been fired for the given
 * parameters by comparing a hashed fingerprint stored under `storageKey`.
 *
 * @param storageKey - the local storage key to read from
 * @param raw - the raw string representing the current parameter combination
 * @returns `true` if the stored hash matches, meaning the event should be suppressed.
 *          Returns `false` on any storage error.
 */ async function $8e76a58f4a588ff2$var$hasAlreadyBeenFired(storageKey, raw) {
    try {
        const hashed = await $8e76a58f4a588ff2$var$hashString(raw);
        if ($8e76a58f4a588ff2$var$firedHashByStorageKey.get(storageKey) === hashed) return true;
        if (!$8e76a58f4a588ff2$var$shouldUseLocalStorage) return false;
        const stored = (0, $c4TO3.AtlBrowserStorageLocal).getItem(storageKey);
        return stored === hashed;
    } catch  {
        return false;
    }
}
/**
 * Persists a hashed fingerprint so that future calls to {@link hasAlreadyBeenFired}
 * with the same `storageKey` and `raw` value will return `true`.
 *
 * Storage errors (e.g. private browsing, quota exceeded) are silently ignored.
 *
 * @param storageKey - the local storage key to write to
 * @param raw - the raw string representing the current parameter combination
 */ async function $8e76a58f4a588ff2$var$markAsFired(storageKey, raw) {
    try {
        const hashed = await $8e76a58f4a588ff2$var$hashString(raw);
        // Always keep an in-memory copy so we can still dedupe within a page session
        // even when browser storage is unavailable or full.
        $8e76a58f4a588ff2$var$firedHashByStorageKey.set(storageKey, hashed);
        if (!$8e76a58f4a588ff2$var$shouldUseLocalStorage) return;
        await (0, $c4TO3.AtlBrowserStorageLocal).setItem(storageKey, hashed);
    } catch  {
        // Storage quota/state can change at runtime (e.g. low storage, private mode).
        // Disable future localStorage writes to avoid repeated runtime errors.
        $8e76a58f4a588ff2$var$shouldUseLocalStorage = false;
    // Silently ignore storage errors (e.g. private browsing, quota exceeded)
    }
}
/**
 * Removes the stored fingerprint for the given storage key, allowing the
 * corresponding event to fire again regardless of previous parameters.
 *
 * @param storageKey - the local storage key to clear
 */ function $8e76a58f4a588ff2$var$clearStorageKey(storageKey) {
    try {
        $8e76a58f4a588ff2$var$firedHashByStorageKey.delete(storageKey);
        if (!$8e76a58f4a588ff2$var$shouldUseLocalStorage) return;
        (0, $c4TO3.AtlBrowserStorageLocal).removeItem(storageKey);
    } catch  {
    // Silently ignore storage errors
    }
}
module.exports["useInvitedAppAnalytics"] = $8e76a58f4a588ff2$export$43a7f5e28cb0f314;

});

parcelRegister("9JGX1", function(module, exports) {

let $7169a22c82ac8ba8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7169a22c82ac8ba8$var$load("K17KJ").then(()=>parcelRequire('5p9uM'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("8cLXS", function(module, exports) {

let $5f94a68b2c60fe41$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5f94a68b2c60fe41$var$load("3FGsv").then(()=>parcelRequire('7Wunc'));

});

parcelRegister("8dN99", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $8tdj3 = parcelRequire("8tdj3");


var $lAFHW = parcelRequire("lAFHW");


var $9x2sR = parcelRequire("9x2sR");


var $9wGTI = parcelRequire("9wGTI");








var $inPa6 = parcelRequire("inPa6");


var $7aRa9 = parcelRequire("7aRa9");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");


var $63PsI = parcelRequire("63PsI");


var $1NBp8 = parcelRequire("1NBp8");


var $1kHsc = parcelRequire("1kHsc");


const $244d7de71b5a933d$var$lazyOnClick = async (args)=>{
    const { companyHubItemCallback: companyHubItemCallback } = await (parcelRequire("1pi2u"));
    await companyHubItemCallback(args);
};
const $244d7de71b5a933d$export$40e9528e11a75d6b = (0, $7aRa9.withFlags)(/*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { children: children, flags: flags, navVersion: navVersion } = t0;
    const companyHubName = (0, $63PsI.useCompanyHubName)();
    const { match: match, push: push } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const routeName = match?.name;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== experienceTracker || $[2] !== flags || $[3] !== navVersion || $[4] !== push || $[5] !== routeName) {
        t1 = async ()=>{
            $244d7de71b5a933d$var$lazyOnClick({
                createAnalyticsEvent: createAnalyticsEvent,
                experienceTracker: experienceTracker,
                flags: flags,
                isFirstTimeVisit: false,
                push: push,
                routeName: routeName,
                navVersion: navVersion
            });
        };
        $[0] = createAnalyticsEvent;
        $[1] = experienceTracker;
        $[2] = flags;
        $[3] = navVersion;
        $[4] = push;
        $[5] = routeName;
        $[6] = t1;
    } else t1 = $[6];
    const onClick = t1;
    let t2;
    if ($[7] !== children || $[8] !== companyHubName || $[9] !== onClick || $[10] !== routeName || $[11] !== spaceKey) {
        const isSelected = routeName === (0, $1NBp8.COMPANY_HUB).name || routeName !== (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name && routeName !== (0, $1NBp8.COMPANY_HUB_ANALYTICS).name && routeName !== (0, $1NBp8.COMPANY_HUB_SETTINGS).name && (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
        t2 = children({
            companyHubName: companyHubName,
            isSelected: isSelected,
            namedRoute: (0, $1NBp8.COMPANY_HUB),
            onClick: onClick
        });
        $[7] = children;
        $[8] = companyHubName;
        $[9] = onClick;
        $[10] = routeName;
        $[11] = spaceKey;
        $[12] = t2;
    } else t2 = $[12];
    return t2;
}));


const $e47020b4a0088e3d$var$DEFAULT_COMPANY_HUB_NAME = 'Company Hub';
const $e47020b4a0088e3d$var$i18n = (0, $aXWIB.defineMessages)({
    CompanyHubName: {
        id: "side-navigation.custom.company-hub.shortcut-name",
        defaultMessage: "Company Hub"
    }
});
const $e47020b4a0088e3d$export$7d5e579a7612f1c2 = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    let isHidden;
    let onClick;
    let rest;
    if ($[0] !== t0) {
        ({ isHidden: isHidden, onClick: onClick, ...rest } = t0);
        $[0] = t0;
        $[1] = isHidden;
        $[2] = onClick;
        $[3] = rest;
    } else {
        isHidden = $[1];
        onClick = $[2];
        rest = $[3];
    }
    if (isHidden) return null;
    let t1;
    if ($[4] !== onClick || $[5] !== rest) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $244d7de71b5a933d$export$40e9528e11a75d6b), {
            navVersion: "4"
        }, (t2)=>{
            const { companyHubName: companyHubName, isSelected: isSelected, namedRoute: namedRoute, onClick: onAbstractCompanyHubItemClick } = t2;
            const elemBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.HubIcon), {
                size: "xsmall"
            });
            const elemAfter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                label: "",
                spacing: "spacious",
                size: "small"
            });
            const onMenuLinkItemClick = ()=>{
                onClick?.();
                onAbstractCompanyHubItemClick();
            };
            const isDefaultCompanyHubName = companyHubName === $e47020b4a0088e3d$var$DEFAULT_COMPANY_HUB_NAME;
            if ((0, $9wGTI.fg)("navx-global-side-nav-confluence")) {
                const { peekingId: _peekingId, setPeekingId: _setPeekingId, draggableRef: draggableRef, ...dndProps } = rest;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
                    ref: draggableRef,
                    elemAfter: elemAfter,
                    elemBefore: elemBefore,
                    href: namedRoute?.toUrl() || "#",
                    isSelected: isSelected,
                    onClick: onMenuLinkItemClick,
                    target: "_blank",
                    ...dndProps
                }, isDefaultCompanyHubName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e47020b4a0088e3d$var$i18n.CompanyHubName) : companyHubName);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
                elemAfter: elemAfter,
                elemBefore: elemBefore,
                href: namedRoute?.toUrl() || "#",
                isSelected: isSelected,
                onClick: onMenuLinkItemClick,
                target: "_blank"
            }, isDefaultCompanyHubName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e47020b4a0088e3d$var$i18n.CompanyHubName) : companyHubName);
        });
        $[4] = onClick;
        $[5] = rest;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
module.exports["CompanyHubItem"] = $e47020b4a0088e3d$export$7d5e579a7612f1c2;

});

parcelRegister("1pi2u", function(module, exports) {

let $10661e6feea9c578$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $10661e6feea9c578$var$load("aGsq7").then(()=>parcelRequire('eXmLL'));

});

parcelRegister("fPgmM", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ajypD = parcelRequire("ajypD");

var $hEbxW = parcelRequire("hEbxW");

var $eGd7K = parcelRequire("eGd7K");

var $7L5zP = parcelRequire("7L5zP");

/**
 * This config setup allows us to debug/QA the experience by adjusting
 * some settings via localStorage overrides.
 *
 * Otherwise, we'd have to wait for days to observe cache expiry/refresh behavior,
 * and in-source-product minimum activity times.
 */ const $b7046f0a38984949$export$44487a86467333c3 = ()=>$b7046f0a38984949$var$CONSTANTS_AS_DEBUGGABLE_GETTERS;
const $b7046f0a38984949$var$timespan = ({ days: days = 0, minutes: minutes = 0, seconds: seconds = 0 })=>((days * 1440 + minutes) * 60 + seconds) * 1000;
const $b7046f0a38984949$var$CONSTANTS = {
    TIME_IN_SOURCE_PRODUCT_BEFORE_ELIGIBLE: $b7046f0a38984949$var$timespan({
        days: 3
    }),
    /**
   * When the customer visits after this time since we last wrote data to the cache,
   * we'll refresh the cache: refetch the required data.
   */ CACHE_TIME_UNTIL_REFRESH: $b7046f0a38984949$var$timespan({
        days: 7
    }),
    /**
   * When the customer visits after this time since we last wrote data to the cache,
   * we'll consider the cache expired and invalid, and not eligible to see the experiment
   * (the user will not see the treatment on that visit).
   * We will refresh the cache at that time, but even if that comes back as eligible,
   * it will only affect future visits.
   */ CACHE_TIME_UNTIL_EXPIRY: $b7046f0a38984949$var$timespan({
        days: 10
    })
};
const $b7046f0a38984949$var$CONSTANTS_AS_DEBUGGABLE_GETTERS = {
    get TIME_IN_SOURCE_PRODUCT_BEFORE_ELIGIBLE () {
        return $b7046f0a38984949$var$getDebuggableTiming('TIME_IN_SOURCE_PRODUCT_BEFORE_ELIGIBLE');
    },
    get CACHE_TIME_UNTIL_REFRESH () {
        return $b7046f0a38984949$var$getDebuggableTiming('CACHE_TIME_UNTIL_REFRESH');
    },
    get CACHE_TIME_UNTIL_EXPIRY () {
        return $b7046f0a38984949$var$getDebuggableTiming('CACHE_TIME_UNTIL_EXPIRY');
    }
};
function $b7046f0a38984949$var$getDebuggableTiming(key) {
    if (typeof localStorage !== 'undefined' && localStorage) {
        const debugLocalStorageKey = `invitedAppShortcutsDebug_${key}_seconds`;
        const overrideValue = parseInt(localStorage[debugLocalStorageKey], 10);
        if (typeof overrideValue === 'number' && overrideValue >= 0) return $b7046f0a38984949$var$timespan({
            seconds: overrideValue
        });
    }
    return $b7046f0a38984949$var$CONSTANTS[key];
}


const $3438e954aa0087f3$var$cacheKey = 'invitedAppShortcuts';
const $3438e954aa0087f3$var$localStorageCacheDebugKey = `${$3438e954aa0087f3$var$cacheKey}Debug`;
class $3438e954aa0087f3$export$7bddb475c47d45d {
    async write(state) {
        if ($3438e954aa0087f3$var$cacheDebugMode() === 'local-storage') {
            localStorage[$3438e954aa0087f3$var$cacheKey] = JSON.stringify(state);
            return true;
        }
        const result = await this.setCookie($3438e954aa0087f3$var$cacheKey, JSON.stringify(state), {
            expires: new Date(Date.now() + (0, $b7046f0a38984949$export$44487a86467333c3)().CACHE_TIME_UNTIL_EXPIRY),
            sameSite: 'strict'
        });
        return result === true || result === (0, $7L5zP.Status).SUCCESS;
    }
    read({ ssr: ssr }) {
        const throwOnError = ssr;
        if ($3438e954aa0087f3$var$cacheDebugMode() === 'local-storage') {
            if (localStorage?.[$3438e954aa0087f3$var$cacheKey]) return this.parseCachedState({
                rawValue: localStorage[$3438e954aa0087f3$var$cacheKey],
                throwOnError: throwOnError
            });
        } else {
            const cookieValueString = this.getCookie($3438e954aa0087f3$var$cacheKey, ssr);
            if (cookieValueString) return this.parseCachedState({
                rawValue: cookieValueString,
                throwOnError: throwOnError
            });
        }
        return null;
    }
    parseCachedState({ rawValue: rawValue, throwOnError: throwOnError }) {
        // Reuse parsed state for identical cookie/localStorage payloads during the same render lifecycle.
        if (this.lastParsedRawValue === rawValue) return this.lastParsedState;
        try {
            const decoded = $3438e954aa0087f3$var$isUrlEncodedJson(rawValue) ? decodeURIComponent(rawValue) : rawValue;
            const parsed = JSON.parse(decoded) || null;
            this.lastParsedRawValue = rawValue;
            this.lastParsedState = parsed;
            return parsed;
        } catch (error) {
            if (throwOnError) throw error;
            // Subsequent client reads: swallow parse errors for robustness; treat as cache miss.
            this.lastParsedRawValue = rawValue;
            this.lastParsedState = null;
            return null;
        }
    }
    constructor({ getCookie: getCookie = (0, $hEbxW.getCookie), setCookie: setCookie = (0, $eGd7K.setCookie) } = {}){
        this.getCookie = void 0;
        this.setCookie = void 0;
        this.lastParsedRawValue = null;
        this.lastParsedState = null;
        this.getCookie = getCookie;
        this.setCookie = setCookie;
    }
}
const $3438e954aa0087f3$var$isUrlEncodedJson = (json)=>json && (json.startsWith(`{%22`) || // `{"` with only `"` encoded -- this was value was observed in Confluence
    json.startsWith(`%7B%22`)); // `{"` encoded
const $3438e954aa0087f3$var$cacheDebugMode = ()=>{
    const debugMode = typeof localStorage !== 'undefined' && localStorage && // Extra safety while we're in the debug-only phase,
    // before we've switched to the proper browser controls (to be removed when that happens).
    // Requires manually setting localStorage.invitedAppShortcutsDebug = "true" in the console
    // to allow our code to write anything into the local storage cache.
    localStorage[$3438e954aa0087f3$var$localStorageCacheDebugKey];
    if (debugMode === 'cookie-delete') {
        localStorage[$3438e954aa0087f3$var$localStorageCacheDebugKey] = null;
        (0, $ajypD.deleteCookie)($3438e954aa0087f3$var$cacheKey);
    } else if (debugMode && ![
        'null',
        'false'
    ].includes(debugMode)) return 'local-storage';
    return null;
};





var $1mG05 = parcelRequire("1mG05");


var $3Zy9L = parcelRequire("3Zy9L");


var $87q77 = parcelRequire("87q77");




const $74915a9b8039531c$export$12e73c04b5fd5da2 = new Set([
    ...(0, $1mG05.INVITED_APP_SHORTCUTS_ALLOWED_SOURCE_APPS),
    ...(0, $1mG05.INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS)
]);
const $74915a9b8039531c$export$130cf0f0f2a54797 = {
    EXPERIMENT_OFF: 'EXPERIMENT_OFF',
    ERROR: 'ERROR',
    CACHE_EMPTY: 'CACHE_EMPTY',
    CACHE_EMPTY_USER_MISMATCH: 'CACHE_EMPTY_USER_MISMATCH',
    CACHE_EXPIRED: 'CACHE_EXPIRED',
    NO_TARGET_PRODUCTS: 'NO_TARGET_PRODUCTS',
    NO_ACCESS_TO_TARGET_PRODUCTS: 'NO_ACCESS_TO_TARGET_PRODUCTS',
    TARGET_PRODUCTS_NOT_VISIBLE: 'TARGET_PRODUCTS_NOT_VISIBLE',
    TARGET_PRODUCTS_ALL_ACTIVE: 'TARGET_PRODUCTS_ALL_ACTIVE',
    SOURCE_PRODUCT_TOO_NEW: 'SOURCE_PRODUCT_TOO_NEW',
    /**
   * Returned in `mode: 'productionisation'` when the caller passes an
   * empty `recommendedApps` array — no target product was recommended.
   */ NO_RECOMMENDED_APPS: 'NO_RECOMMENDED_APPS'
};
const $74915a9b8039531c$export$fd93bc3ed8f14580 = 'updateId';
const $74915a9b8039531c$export$110c7428ebac4f9a = 5000;
const $74915a9b8039531c$export$ebd0d23278a50416 = {
    NOT_CHECKED: undefined,
    INACTIVE: null
};



var $c6GJD = parcelRequire("c6GJD");

const $a834e0c1c192b1ad$export$9db1624a8af791a4 = (experimentName, experimentParam, defaultValue, options = {})=>{
    // If client is not initialized, we return the default value
    if (!(0, $c6GJD.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $c6GJD.default).getExperimentValue(experimentName, experimentParam, defaultValue, options);
    return experimentValue;
};






var $4IT4p = parcelRequire("4IT4p");


/** Serializes every `enqueueUpdate` globally; `lastCommittedStateByCache` still scopes `prev` per cache instance. */ const $bc7598b146379920$var$queue = [];
/**
 * Last state successfully persisted per cache, from this module's queue only.
 * `cache.read()` can lag behind `cache.write()` (e.g. async cookies), so sequential
 * updaters must not rely on read() alone for `prev`.
 *
 * Updated only after `cache.write` resolves **true** (confirmed persist). Not updated
 * when the updater returns null/`prev`, when `write` resolves false, on throw from the
 * updater or `write`, or in `catch` below — so failed updates do not advance the chain.
 */ const $bc7598b146379920$var$lastCommittedStateByCache = new WeakMap();
const $bc7598b146379920$export$3f9c9dc8b61499e9 = (cache, updater)=>{
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    const processUpdate = async ()=>{
        const prev = $bc7598b146379920$var$lastCommittedStateByCache.get(cache) ?? cache.read({
            ssr: false
        }) ?? {};
        try {
            const result = updater(prev);
            if (result === null || result === prev) resolve(prev);
            else {
                const writeSucceeded = await cache.write(result);
                if (writeSucceeded) {
                    $bc7598b146379920$var$lastCommittedStateByCache.set(cache, result);
                    resolve(result);
                } else // Do not set lastCommittedStateByCache — storage may not match `result`.
                resolve(prev);
            }
        } catch (error) {
            // Do not update lastCommittedStateByCache; queue still advances below.
            reject(error);
        }
        $bc7598b146379920$var$queue.shift(); // Remove the processed update
        if ($bc7598b146379920$var$queue.length > 0) {
            const nextProcessUpdate = $bc7598b146379920$var$queue[0];
            nextProcessUpdate(); // Start the next update, keep it in the queue (blocking) until processed
        }
    };
    $bc7598b146379920$var$queue.push(processUpdate);
    if ($bc7598b146379920$var$queue.length === 1) processUpdate();
    return promise;
};



const $58987587447d73e1$export$2331136d2a146e0b = ({ sourceProduct: sourceProduct, targetProducts: targetProducts, userId: userId, cache: cache })=>{
    if (targetProducts.length === 0) return {
        eligibility: $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).NO_TARGET_PRODUCTS)
    };
    const cached = cache.read({
        ssr: true
    });
    if (userId && cached && cached.uid && userId !== cached.uid) {
        // Extra protection: clear cache asynchronously in the background, ignoring errors.
        // The hook will then fill the cache for the correct, current user.
        Promise.resolve().then(()=>(0, $bc7598b146379920$export$3f9c9dc8b61499e9)(cache, ()=>({
                    uid: cached.uid
                }))).catch(()=>{});
        return {
            eligibility: $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EMPTY_USER_MISMATCH)
        };
    }
    if (!(cached && cached.apps)) return {
        eligibility: $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EMPTY)
    };
    const resolvedDetails = $58987587447d73e1$export$6d313cb53294e81({
        sourceProduct: sourceProduct,
        targetProducts: targetProducts
    }, cached);
    return {
        eligibility: resolvedDetails,
        state: cached
    };
};
const $58987587447d73e1$export$6d313cb53294e81 = ({ sourceProduct: sourceProduct, targetProducts: targetProducts, timestamp: timestamp = Date.now() }, cachedState)=>{
    if (targetProducts.length === 0) return $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).NO_TARGET_PRODUCTS);
    let invitedApps = {};
    let hasAccessToAtLeastOneTarget = null;
    let atLeastOneTargetVisible = null;
    let atLeastOneTargetInactive = false;
    const ignoreVisibility = $58987587447d73e1$var$shouldIgnoreVisibility({
        sourceProduct: sourceProduct
    });
    for (const targetProduct of targetProducts){
        const cachedApp = cachedState.apps?.[targetProduct];
        if (!cachedApp) continue;
        if (cachedApp.access != null) hasAccessToAtLeastOneTarget = hasAccessToAtLeastOneTarget || cachedApp.access;
        if (cachedApp.visible != null) atLeastOneTargetVisible = atLeastOneTargetVisible || cachedApp.visible;
        if (cachedApp.access && (cachedApp.visible || ignoreVisibility) && cachedApp.firstActive === (0, $74915a9b8039531c$export$ebd0d23278a50416).INACTIVE) {
            atLeastOneTargetInactive = true;
            invitedApps[targetProduct] = {
                eligible: true,
                collaborators: Array.from({
                    length: cachedApp.collaboratorCount ?? 0
                }).map((_, index)=>cachedApp.collaboratorDetails?.[index] ?? null),
                firstImpressionAt: cachedApp?.firstImpressionAt ?? null
            };
        }
    }
    if (hasAccessToAtLeastOneTarget === null || !ignoreVisibility && atLeastOneTargetVisible === null) return $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EMPTY);
    if (!hasAccessToAtLeastOneTarget) return $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).NO_ACCESS_TO_TARGET_PRODUCTS);
    if (!atLeastOneTargetVisible && !ignoreVisibility) return $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).TARGET_PRODUCTS_NOT_VISIBLE);
    if (!cachedState.firstActiveUpdatedTimestamp) return $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EMPTY);
    if (!(timestamp <= cachedState.firstActiveUpdatedTimestamp + (0, $b7046f0a38984949$export$44487a86467333c3)().CACHE_TIME_UNTIL_EXPIRY)) return $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EXPIRED);
    if (sourceProduct !== 'home') {
        const firstActiveInSourceProduct = cachedState.apps?.[sourceProduct]?.firstActive;
        if (!firstActiveInSourceProduct) return $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EMPTY);
        if (timestamp - firstActiveInSourceProduct < (0, $b7046f0a38984949$export$44487a86467333c3)().TIME_IN_SOURCE_PRODUCT_BEFORE_ELIGIBLE) return $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).SOURCE_PRODUCT_TOO_NEW);
    }
    if (!atLeastOneTargetInactive) return $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).TARGET_PRODUCTS_ALL_ACTIVE);
    return {
        ineligibilityReason: null,
        invitedApps: invitedApps
    };
};
const $58987587447d73e1$export$2f93f852bd951b = ({ recommendedApps: recommendedApps })=>{
    if (recommendedApps.length === 0) return {
        eligibility: $58987587447d73e1$export$16cb62545527283a((0, $74915a9b8039531c$export$130cf0f0f2a54797).NO_RECOMMENDED_APPS)
    };
    const invitedApps = {};
    for (const app of recommendedApps)invitedApps[app] = {
        eligible: true
    };
    return {
        eligibility: {
            ineligibilityReason: null,
            invitedApps: invitedApps
        }
    };
};
const $58987587447d73e1$export$16cb62545527283a = (reason)=>({
        ineligibilityReason: reason
    });
const $58987587447d73e1$export$fe1089e917806f3c = (cachedState)=>!cachedState?.firstActiveUpdatedTimestamp || Date.now() > cachedState.firstActiveUpdatedTimestamp + (0, $b7046f0a38984949$export$44487a86467333c3)().CACHE_TIME_UNTIL_REFRESH;
const $58987587447d73e1$export$b97783bc9c26cb8b = async ({ access: accessMap, visibility: visibilityMap, traits: traits, userId: userId, cache: cache })=>(0, $bc7598b146379920$export$3f9c9dc8b61499e9)(cache, (prev)=>{
        const draft = {
            ...prev,
            uid: userId,
            apps: {
                ...prev?.apps
            }
        };
        const traitsByName = $58987587447d73e1$var$groupTraitsByName(traits);
        for (const product of (0, $74915a9b8039531c$export$12e73c04b5fd5da2)){
            const appAccess = accessMap[product];
            const appVisibility = visibilityMap[product];
            const traitValue = $58987587447d73e1$var$getProductFirstActiveTraitValue(product, traitsByName);
            if (traitValue !== $58987587447d73e1$var$FIRST_ACTIVE_NOT_APPLICABLE) {
                const firstActive = traitValue ? $58987587447d73e1$export$bca6124add6e242(traitValue) : null;
                const draftApp = {
                    ...draft.apps[product]
                };
                if (firstActive) draftApp.firstActive = firstActive;
                else if (appAccess === true) draftApp.firstActive = (0, $74915a9b8039531c$export$ebd0d23278a50416).INACTIVE;
                if (appAccess !== undefined) draftApp.access = appAccess;
                if (appVisibility !== undefined) draftApp.visible = appVisibility;
                draft.apps[product] = draftApp;
            }
        }
        draft.firstActiveUpdatedTimestamp = Date.now();
        return draft;
    });
const $58987587447d73e1$var$FIRST_ACTIVE_NOT_APPLICABLE = Symbol('FIRST_ACTIVE_NOT_APPLICABLE');
const $58987587447d73e1$var$getProductFirstActiveTraitValue = (product, traitsByName)=>{
    switch(product){
        case 'jira':
            return traitsByName['jira_first_active'] || traitsByName['jira-software_first_active'];
        case 'confluence':
            return traitsByName['confluence_first_active'];
        case 'home':
            return $58987587447d73e1$var$FIRST_ACTIVE_NOT_APPLICABLE;
        default:
            product;
    }
};
const $58987587447d73e1$var$shouldIgnoreVisibility = ({ sourceProduct: sourceProduct })=>sourceProduct === 'confluence';
const $58987587447d73e1$export$8788f7a1e6d8fdb0 = ({ sourceProduct: sourceProduct, targetProducts: targetProducts, dynamicEligibility: dynamicEligibility })=>!!dynamicEligibility && targetProducts.some((product)=>dynamicEligibility.access[product] === true && (dynamicEligibility.visibility[product] === true || $58987587447d73e1$var$shouldIgnoreVisibility({
            sourceProduct: sourceProduct
        })));
const $58987587447d73e1$export$8ec65f29d950d5d3 = ({ getFilteredProductLinks: getFilteredProductLinks, limitToOnlyApsKeys: limitToOnlyApsKeys = [
    ...(0, $1mG05.INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS)
] })=>{
    const access = {};
    let atLeastOneComplete = false;
    for (const apsKey of limitToOnlyApsKeys){
        const app = (0, $4IT4p.getAppKeyByApsKey)(apsKey);
        const { links: links, status: status } = getFilteredProductLinks(apsKey);
        if (status === 'complete') {
            atLeastOneComplete = true;
            const hasAccess = links.length > 0;
            access[app] = hasAccess;
        }
    }
    return atLeastOneComplete ? access : undefined;
};
const $58987587447d73e1$var$menuIdToApsKey = {
    // Jira to Confluence
    'jira.sidebar.globalApp.confluence': 'CONFLUENCE',
    // Confluence to Jira
    jiraShortcut: 'JIRA_SOFTWARE'
};
const $58987587447d73e1$export$ef01d2a4fe4032bb = ({ shortcuts: shortcuts, limitToOnlyApsKeys: limitToOnlyApsKeys = [
    ...(0, $1mG05.INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS)
] })=>{
    const access = Object.values(shortcuts).reduce((acc, shortcut)=>{
        if (shortcut.type === 'link' && shortcut.apsKey) {
            const { apsKey: apsKey, url: url } = shortcut;
            // if the url is valid then we assume the user has access to the product
            if (url && limitToOnlyApsKeys.includes(apsKey)) try {
                const appKey = (0, $4IT4p.getAppKeyByApsKey)(apsKey);
                acc[appKey] = true;
            // eslint-disable-next-line no-unused-vars
            } catch (_) {
            // if fails to get the app key then it's not an allowed app, skip it
            }
        }
        return acc;
    }, {});
    return $58987587447d73e1$var$applyDefaultsForApsKeys(access, limitToOnlyApsKeys, false);
};
const $58987587447d73e1$var$applyDefaultsForApsKeys = (appMap, apsKeys, defaultValue)=>{
    const result = {
        ...appMap
    };
    for (let apsKey of apsKeys){
        const app = (0, $4IT4p.getAppKeyByApsKey)(apsKey);
        if (result[app] === undefined) result[app] = defaultValue;
    }
    return result;
};
const $58987587447d73e1$export$a8f7dcbfec997a77 = ({ visibleMenuIds: visibleMenuIds, limitToOnlyApsKeys: apsKeys = [
    ...(0, $1mG05.INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS)
] })=>{
    const visibleApsKeys = new Set(visibleMenuIds.map((menuId)=>$58987587447d73e1$var$menuIdToApsKey[menuId]).filter(Boolean));
    const visibilityMap = {};
    for (const apsKey of apsKeys){
        const appKey = (0, $4IT4p.getAppKeyByApsKey)(apsKey);
        visibilityMap[appKey] = visibleApsKeys.has(apsKey);
    }
    return visibilityMap;
};
const $58987587447d73e1$export$1c471c34a84a4f55 = async ({ access: accessMap, visibility: visibilityMap, cache: cache })=>(0, $bc7598b146379920$export$3f9c9dc8b61499e9)(cache, (prev)=>{
        let updated = false;
        const draft = {
            ...prev,
            apps: {
                ...prev?.apps
            }
        };
        for (const app of (0, $74915a9b8039531c$export$12e73c04b5fd5da2)){
            const appAccess = accessMap[app];
            const appVisibility = visibilityMap[app];
            const prevApp = draft.apps[app] ?? {};
            if (appAccess !== undefined && appAccess !== prevApp.access || appVisibility !== undefined && appVisibility !== prevApp.visible) {
                const draftApp = {
                    ...prevApp
                };
                if (appAccess !== undefined) draftApp.access = appAccess;
                if (appVisibility !== undefined) draftApp.visible = appVisibility;
                draft.apps[app] = draftApp;
                updated = true;
            }
        }
        return updated ? draft : null;
    });
const $58987587447d73e1$export$e238a4387f5f61d6 = async ({ productsSeen: productsSeen, seenTimestamp: seenTimestamp = Date.now(), cache: cache })=>(0, $bc7598b146379920$export$3f9c9dc8b61499e9)(cache, (prev)=>{
        const draft = {
            ...prev,
            apps: {
                ...prev?.apps
            }
        };
        let updated = false;
        for (const product of productsSeen){
            const prevApp = draft.apps[product];
            if (!prevApp?.firstImpressionAt) {
                updated = true;
                draft.apps[product] = {
                    ...prevApp,
                    firstImpressionAt: seenTimestamp
                };
            }
        }
        return updated ? draft : null;
    });
const $58987587447d73e1$export$a3cc74cdee943c7f = async ({ cache: cache, product: product, timestamp: timestamp = Date.now() })=>(0, $bc7598b146379920$export$3f9c9dc8b61499e9)(cache, (prev)=>{
        const draft = {
            ...prev,
            apps: {
                ...prev?.apps
            }
        };
        draft.apps[product] = {
            ...draft.apps[product],
            firstActive: timestamp
        };
        return draft;
    });
const $58987587447d73e1$export$606587d4eb77e23d = async ({ products: products, collaboratorsWithProducts: collaboratorsWithProducts, cache: cache })=>(0, $bc7598b146379920$export$3f9c9dc8b61499e9)(cache, (prev)=>{
        const collaboratorsByProduct = $58987587447d73e1$var$groupCollaboratorsByProduct(collaboratorsWithProducts);
        const draft = {
            ...prev,
            apps: {
                ...prev?.apps
            }
        };
        for (const product of products){
            const collabs = collaboratorsByProduct[product] ?? [];
            draft.apps[product] = {
                ...draft.apps[product],
                // We display:
                // - 1x avatar for 1 collaborator
                // - 2x avatars for exactly 2 collaborators
                // - 1x avatar + number of remaining collaborators for 3+
                // So store exactly as much detailed data as we need to display:
                collaboratorDetails: collabs.slice(0, collabs.length === 2 ? 2 : 1).map((c)=>({
                        avatar: c.avatar
                    })),
                collaboratorCount: collabs.length
            };
        }
        return draft;
    });
const $58987587447d73e1$export$a0ae147fc3589eac = async ({ productLinks: productLinks, cache: cache })=>(0, $bc7598b146379920$export$3f9c9dc8b61499e9)(cache, (prev)=>{
        if (Object.keys(productLinks).length === 0) return null;
        const draft = {
            ...prev,
            apps: {
                ...prev?.apps
            }
        };
        let updated = false;
        for (const product of (0, $1mG05.INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS)){
            const links = productLinks[product];
            if (!links) continue;
            const prevLinks = draft.apps[product]?.productLinks;
            if (!$58987587447d73e1$var$areProductLinksEqual(prevLinks, links)) {
                draft.apps[product] = {
                    ...draft.apps[product],
                    productLinks: links
                };
                updated = true;
            }
        }
        return updated ? draft : null;
    });
const $58987587447d73e1$var$areProductLinksEqual = (prevLinks, nextLinks)=>{
    if (!prevLinks) return false;
    if (prevLinks.length !== nextLinks.length) return false;
    const prevUrls = new Set(prevLinks.map((link)=>link?.url ?? ''));
    const nextUrls = new Set(nextLinks.map((link)=>link?.url ?? ''));
    if (prevUrls.size !== nextUrls.size) return false;
    for (const url of prevUrls){
        if (!nextUrls.has(url)) return false;
    }
    return true;
};
/**
 * Get the cached apps from the cache
 * @param cache - The cache to get the apps from
 * @returns The cached apps, or an empty object if the cache is empty or the cookie value is malformed/truncated
 */ const $58987587447d73e1$var$getCachedApps = ({ cache: cache })=>{
    try {
        const cachedState = cache.read({
            ssr: true
        });
        return cachedState?.apps ?? {};
    } catch  {
        // During SSR, if the cookie value is malformed/truncated, JSON.parse will throw.
        // Catch the error and treat it as a cache miss, returning an empty product links map.
        return {};
    }
};
const $58987587447d73e1$export$b58ff4178d893ad6 = ({ cache: cache })=>{
    const apps = $58987587447d73e1$var$getCachedApps({
        cache: cache
    });
    if (Object.keys(apps).length === 0) return {};
    const cachedProductLinks = {};
    for (const product of (0, $1mG05.INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS)){
        const productLinks = apps?.[product]?.productLinks;
        if (productLinks) cachedProductLinks[product] = productLinks;
    }
    return cachedProductLinks;
};
const $58987587447d73e1$var$groupCollaboratorsByProduct = (collaboratorsWithProducts)=>{
    const result = {};
    for (const cwp of collaboratorsWithProducts)for (const product of cwp.products){
        if (!result[product]) result[product] = [];
        result[product].push(cwp.collaborator);
    }
    return result;
};
const $58987587447d73e1$var$groupTraitsByName = (traits)=>{
    const traitsByName = {};
    for (const trait of traits)traitsByName[trait.name] = trait.value;
    return traitsByName;
};
const $58987587447d73e1$export$bca6124add6e242 = (traitValue)=>typeof traitValue === 'string' && +new Date(traitValue) || null;






const $77489821c279a9fb$export$55467fcd9e2bb73a = ()=>{
    const canWriteRef = (0, $42omo.useRef)(null);
    return (0, $42omo.useCallback)(async ({ cache: cache })=>{
        if (canWriteRef.current === null) canWriteRef.current = $77489821c279a9fb$var$canWriteToCache({
            cache: cache
        });
        return await canWriteRef.current;
    }, []);
};
/**
 * This implementation does retries.
 *
 * Needed because the browser control library's async `setCookie()` function
 * has a bug/limitation when it doesn't correctly wait for the product context
 * to init. If we call the function "too early", it says the cookie is blocked
 * and doesn't do the write, even though once the product context loads,
 * the write would succeed.
 */ const $77489821c279a9fb$var$canWriteToCache = async ({ maxRetries: maxRetries = 2, retry: retry = 0, retryDelay: retryDelay = 1000, cache: cache })=>{
    try {
        const initialRead = cache.read({
            ssr: false
        });
        const writtenId = (initialRead?.[0, $74915a9b8039531c$export$fd93bc3ed8f14580] ?? 0) + 1;
        const writeResult = await cache.write({
            ...initialRead,
            [(0, $74915a9b8039531c$export$fd93bc3ed8f14580)]: writtenId
        });
        const wroteSuccessfully = writeResult === true && cache.read({
            ssr: false
        })?.[0, $74915a9b8039531c$export$fd93bc3ed8f14580] === writtenId;
        if (!wroteSuccessfully && retry < maxRetries) {
            await new Promise((resolve)=>setTimeout(resolve, retryDelay));
            return await $77489821c279a9fb$var$canWriteToCache({
                retry: retry + 1,
                maxRetries: maxRetries,
                retryDelay: retryDelay,
                cache: cache
            });
        }
        return wroteSuccessfully;
    } catch  {
        return false;
    }
};


const $e0f55f0500dfbf3c$export$c2e2a02c27ed0bc1 = (input)=>{
    const { enabled: enabled, sourceProduct: sourceProduct, targetProducts: targetProducts, cloudId: cloudId, userId: userId, cache: cache, onCacheNeedsRefresh: onCacheNeedsRefresh } = input;
    const mode = input.mode ?? 'experiment';
    // Productionisation-only field; safe to read because the discriminated union
    // guarantees it is present when `mode === 'productionisation'` and `enabled`.
    const recommendedApps = enabled && input.mode === 'productionisation' ? input.recommendedApps : [];
    // Experiment-only fields; ignored in productionisation mode.
    const traitsArg = enabled && input.mode !== 'productionisation' ? input.traits : undefined;
    const fetchTraits = enabled && input.mode !== 'productionisation' ? input.fetchTraits : undefined;
    const fetchTraitsPolicy = enabled && input.mode !== 'productionisation' ? input.fetchTraitsPolicy : undefined;
    // In productionisation mode, reads and state changes are suppressed
    // (eligibility is delegated to `InvitedAppShortcutsRecommendationsProvider`).
    // Cache writes still flow through; see the JSDoc on `UseInvitedAppShortcutsMode`.
    const isProductionisation = enabled && mode === 'productionisation';
    // This implementation prioritizes performance: avoiding re-renders and state updates.
    // That's why it doesn't have dynamic React state at all.
    const analytics = (0, $87q77.useInvitedAppAnalytics)();
    const canWriteToCache = (0, $77489821c279a9fb$export$55467fcd9e2bb73a)();
    /**
   * Stores traits fetch status.
   *
   * Resolved from props: either directly from `traits` or from `fetchTraits`.
   */ const traitsDeferredRef = (0, $42omo.useRef)(// Memoize initial ref value to compute it only once:
    (0, $42omo.useMemo)(()=>{
        let resolve;
        const promise = new Promise((res)=>{
            resolve = res;
        });
        return {
            promise: promise,
            resolve: resolve,
            status: 'initial'
        };
    }, []));
    /**
   * A lock preventing duplicate cache refreshes.
   */ const isCacheRefreshLockedRef = (0, $42omo.useRef)(false);
    const lostAccessTimeoutRef = (0, $42omo.useRef)(null);
    /**
   * Main read used to resolve the returned eligibility.
   *
   * Read only once, and then stable (non-reactive), ensured by useState with a functional initializer.
   *
   * In `mode: 'productionisation'`, eligibility is derived from the
   * caller-supplied `recommendedApps` (typically produced by
   * `InvitedAppShortcutsRecommendationsProvider`). The cookie cache is not
   * consulted; consumers see a populated `invitedApps` map directly.
   *
   * In `mode: 'experiment'`, eligibility is read from the cookie cache as before.
   */ const [cached] = (0, $42omo.useState)(()=>{
        if (!enabled) return {
            eligibility: (0, $58987587447d73e1$export$16cb62545527283a)((0, $74915a9b8039531c$export$130cf0f0f2a54797).EXPERIMENT_OFF)
        };
        if (mode === 'productionisation') return (0, $58987587447d73e1$export$2f93f852bd951b)({
            recommendedApps: recommendedApps
        });
        try {
            return (0, $58987587447d73e1$export$2331136d2a146e0b)({
                sourceProduct: sourceProduct,
                targetProducts: targetProducts,
                cache: cache,
                userId: userId
            });
        // eslint-disable-next-line no-unused-vars
        } catch (_ignoredError) {
            return {
                eligibility: (0, $58987587447d73e1$export$16cb62545527283a)((0, $74915a9b8039531c$export$130cf0f0f2a54797).ERROR)
            };
        }
    });
    /**
   * Synchronize traits state with the supplied traits arg.
   *
   * This arg is passed by Confluence, based on a Confluence GraphQL query. The query
   * is initially skipped. It stops being skipped when our hook calls `onCacheNeedsRefresh`,
   * which it does only when it decides that the cache needs a refresh.
   *
   * Skipped in `mode: 'productionisation'` — traits feed the legacy
   * eligibility resolver, which is not run in that mode.
   *
   * This effect should be removed when tidying up the A/A test for productionisation
   */ (0, $42omo.useEffect)(()=>{
        if (enabled && !isProductionisation && traitsArg && traitsDeferredRef.current.status === 'initial') {
            traitsDeferredRef.current.resolve(traitsArg);
            traitsDeferredRef.current.status = 'fulfilled';
        }
    }, [
        enabled,
        isProductionisation,
        traitsArg
    ]);
    /**
   * Fire analytics when the user is ineligible
   *
   * Skipped in `mode: 'productionisation'` because we did not check
   * eligibility ourselves — firing this event would be misleading.
   *
   * This effect should be removed when tidying up the A/A test for productionisation
   */ (0, $42omo.useEffect)(()=>{
        if (enabled && !isProductionisation && cached.eligibility.ineligibilityReason) analytics.fireInvitedAppShortcutsEligibilityChecked({
            ineligibilityReason: cached.eligibility.ineligibilityReason,
            userId: userId,
            cloudId: cloudId
        });
    }, [
        enabled,
        isProductionisation,
        cached.eligibility.ineligibilityReason,
        analytics,
        userId,
        cloudId
    ]);
    /**
   * Clear lost access analytics timeout on unmount
   */ (0, $42omo.useEffect)(()=>()=>{
            if (lostAccessTimeoutRef.current) clearTimeout(lostAccessTimeoutRef.current);
        }, []);
    return (0, $42omo.useMemo)(()=>{
        const updateFromDynamicEligibility = async ({ access: access, visibility: visibility })=>{
            if (!enabled || !userId) return;
            await (0, $58987587447d73e1$export$1c471c34a84a4f55)({
                access: access ?? {},
                visibility: visibility,
                cache: cache
            });
            if (access === undefined) return;
            maybeFireLostAccessAnalytics(access);
            await $e0f55f0500dfbf3c$var$maybeRefreshEligibility({
                access: access,
                visibility: visibility,
                cache: cache,
                sourceProduct: sourceProduct,
                targetProducts: targetProducts,
                traitsDeferred: traitsDeferredRef.current,
                obtainRefreshLock: obtainRefreshLock,
                userId: userId,
                cloudId: cloudId,
                cached: cached,
                canWriteToCache: canWriteToCache,
                onCacheNeedsRefresh: onCacheNeedsRefresh,
                fetchTraits: fetchTraits,
                fetchTraitsPolicy: fetchTraitsPolicy,
                analytics: analytics
            });
        };
        /*
     * Fire telemetry in the rare case when we returned cached eligibility,
     * but then we learn that user lost access to the eligible target product(s).
     *
     * Do it after a timeout because we might receive multiple dynamic eligibility
     * updates, and initial ones might happen when not all of the data is loaded,
     * which could be indistinguishable from "no access" and lead to false positives.
     * If, during the timeout delay, we get an update indicating that the user has access
     * after all, we clear the timeout.
     */ const maybeFireLostAccessAnalytics = (access)=>{
            const lostAccess = lostAccessToAnyEligibleTargetProduct(access);
            if (lostAccess && lostAccessTimeoutRef.current === null) lostAccessTimeoutRef.current = setTimeout(()=>{
                analytics.fireAppAccessRemoved({
                    targetApps: getEligibleInvitedApps().filter((app)=>access[app] === false)
                });
            }, (0, $74915a9b8039531c$export$110c7428ebac4f9a));
            else if (!lostAccess && lostAccessTimeoutRef.current) clearTimeout(lostAccessTimeoutRef.current);
        };
        const lostAccessToAnyEligibleTargetProduct = (access)=>{
            const eligibleInvitedApps = getEligibleInvitedApps();
            return eligibleInvitedApps.some((app)=>access[app] === false);
        };
        /**
     * One-way lock only (no ability to unlock) because we want to make sure we only
     * do a deep cache refresh once.
     */ const obtainRefreshLock = ()=>{
            if (isCacheRefreshLockedRef.current) return false;
            isCacheRefreshLockedRef.current = true;
            return true;
        };
        const getEligibleInvitedApps = ()=>Object.keys(cached.eligibility.invitedApps || {}).filter((appName)=>cached.eligibility.invitedApps?.[appName]?.eligible);
        return {
            ...cached.eligibility,
            /**
       * Call this function when BFF yields a new version of the `getFilteredProductLinks` function.
       *
       * It will update our eligibility cache based on app access info from the BFF,
       * using that filter function.
       *
       * Depending on where you're calling the hook from (legacy GAS Nav or new GSN Nav), and the data available,
       * call EITHER `updateFromAppAccessFilter` OR `updateFromHydratedShortcuts`.
       *
       * This function should be removed when tidying up the A/A test for productionisation
       */ updateFromAppAccessFilter: ({ getFilteredProductLinks: getFilteredProductLinks, limitToOnlyApsKeys: limitToOnlyApsKeys, visibleMenuIds: visibleMenuIds })=>{
                // Active in both modes — the cookie cache is kept warm as
                // a fallback against cohort flips / gate-off.
                if (!enabled) return;
                const access = (0, $58987587447d73e1$export$8ec65f29d950d5d3)({
                    getFilteredProductLinks: getFilteredProductLinks,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                const visibility = (0, $58987587447d73e1$export$a8f7dcbfec997a77)({
                    visibleMenuIds: visibleMenuIds,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                updateFromDynamicEligibility({
                    access: access,
                    visibility: visibility
                });
            },
            /**
       * Call this function when BFF yields a new version of the `getFilteredProductLinks` function.
       *
       * It will update our eligibility cache based on app access info from the BFF,
       * using that filter function.
       *
       * Depending on where you're calling the hook from (legacy GAS Nav or new GSN Nav), and the data available,
       * call EITHER `updateFromAppAccessFilter` OR `updateFromHydratedShortcuts`.
       *
       * This function should be removed when tidying up the A/A test for productionisation
       */ updateFromHydratedShortcuts: ({ shortcuts: shortcuts, limitToOnlyApsKeys: limitToOnlyApsKeys, visibleMenuIds: visibleMenuIds })=>{
                // Active in both modes — see `updateFromAppAccessFilter`.
                if (!enabled) return;
                const access = (0, $58987587447d73e1$export$ef01d2a4fe4032bb)({
                    shortcuts: shortcuts,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                const visibility = (0, $58987587447d73e1$export$a8f7dcbfec997a77)({
                    visibleMenuIds: visibleMenuIds,
                    limitToOnlyApsKeys: limitToOnlyApsKeys
                });
                updateFromDynamicEligibility({
                    access: access,
                    visibility: visibility
                });
            },
            /**
       * This function should be removed when tidying up the A/A test for productionisation
       */ updateHydratedProductLinks: (productLinks)=>{
                // Active in both modes — see `updateFromHydratedShortcuts`.
                if (!enabled) return;
                (0, $58987587447d73e1$export$a0ae147fc3589eac)({
                    productLinks: productLinks,
                    cache: cache
                });
            },
            /**
       * This function should be removed when tidying up the A/A test for productionisation
       */ getCachedProductLinks: ()=>{
                // No-op in `mode: 'productionisation'` — callers should read
                // product links from the Relay store seeded by
                // `InvitedAppShortcutsRecommendationsProvider`.
                if (!enabled || isProductionisation) return {};
                return (0, $58987587447d73e1$export$b58ff4178d893ad6)({
                    cache: cache
                });
            },
            /**
       * Call when the user has seen our invited app shortcut in the UI.
       *
       * Adds `firstImpressionAt` info to the cache. UI reads that to only
       * show the `Invited` lozenge animation once (when there hasn't been
       * a previous impression).
       *
       * This function should be removed when tidying up the A/A test for productionisation
       */ registerImpression: ({ products: products = getEligibleInvitedApps() } = {})=>{
                // Active in both modes — see `updateFromHydratedShortcuts`.
                if (enabled) (0, $58987587447d73e1$export$e238a4387f5f61d6)({
                    productsSeen: products,
                    cache: cache
                });
            },
            /**
       * Call when the user converted, i.e. clicked on our invited app shortcut
       * and went on to activate in the target product.
       *
       * Used to mark the user as ineligible so that the treatment does not
       * show up on the next visit, without having to wait for cache to expire.
       *
       * Active in both modes — the cookie cache is kept warm as a
       * fallback against cohort flips / gate-off.
       *
       * This function should be removed when tidying up the A/A test for
       * productionisation.
       */ registerActivation: (product)=>{
                if (enabled) (0, $58987587447d73e1$export$a3cc74cdee943c7f)({
                    product: product,
                    cache: cache
                });
            },
            /**
       * Fire exposure analytics (when the user is eligible).
       */ fireFeatureExposed: (input)=>{
                if (enabled) analytics.fireFeatureExposed({
                    ...input,
                    userId: userId,
                    cloudId: cloudId,
                    mode: mode
                });
            }
        };
    }, [
        cache,
        cached,
        enabled,
        isProductionisation,
        mode,
        userId,
        cloudId,
        sourceProduct,
        targetProducts,
        canWriteToCache,
        onCacheNeedsRefresh,
        fetchTraits,
        fetchTraitsPolicy,
        analytics
    ]);
};
/**
 * Main cache refresh flow.
 *
 * Triggers a deep cache refresh (fetch traits, collaborators), but only if
 * access/eligibility prefilters indicate possible eligibility, and cache is empty
 * or needs refresh.
 */ async function $e0f55f0500dfbf3c$var$maybeRefreshEligibility({ traitsDeferred: traitsDeferred, analytics: analytics, visibility: visibility, access: access, sourceProduct: sourceProduct, targetProducts: targetProducts, userId: userId, cloudId: cloudId, cache: cache, cached: cached, canWriteToCache: canWriteToCache, onCacheNeedsRefresh: onCacheNeedsRefresh, obtainRefreshLock: obtainRefreshLock, fetchTraits: fetchTraits, fetchTraitsPolicy: fetchTraitsPolicy }) {
    if ((0, $58987587447d73e1$export$8788f7a1e6d8fdb0)({
        targetProducts: targetProducts,
        sourceProduct: sourceProduct,
        dynamicEligibility: {
            visibility: visibility,
            access: access
        }
    })) {
        const cacheNeedsRefresh = doesCacheNeedRefresh();
        // XXX: The 'always-fetch' check was kept here to avoid runtime code changes before QA.
        // But we removed 'always-fetch' from the set of allowed values of fetchTraitsPolicy,
        // because it was dangerous: using it would put unnaceptable load on CollabGraph,
        // even though could be okay for Traits (because Traits are memoized in Jira & already fetched
        // by other experiences). The problem is that fetching collaborators is currently
        // coupled to fetching traits, and 'always-fetch' would also trigger fetching collaborators (!),
        // putting CollabGraph under unnaceptable load.
        // TODO: Remove 'always-fetch' from here, or decouple fetching Collabs from fetching Traits.
        const shouldRefresh = cacheNeedsRefresh || fetchTraits && fetchTraitsPolicy === 'always-fetch';
        if (shouldRefresh && await canWriteToCache({
            cache: cache
        }) && obtainRefreshLock()) {
            if (cacheNeedsRefresh) onCacheNeedsRefresh?.();
            await refreshEligibility();
        }
    }
    function doesCacheNeedRefresh() {
        return cached.eligibility.ineligibilityReason === (0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EMPTY || cached.eligibility.ineligibilityReason === (0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EMPTY_USER_MISMATCH || cached.eligibility.ineligibilityReason === (0, $74915a9b8039531c$export$130cf0f0f2a54797).CACHE_EXPIRED || (0, $58987587447d73e1$export$fe1089e917806f3c)(cached.state);
    }
    async function refreshEligibility() {
        try {
            const traits = await getTraits();
            const updatedCacheState = await (0, $58987587447d73e1$export$b97783bc9c26cb8b)({
                traits: traits,
                access: access,
                visibility: visibility,
                userId: userId,
                cache: cache
            });
            const updatedEligibility = (0, $58987587447d73e1$export$6d313cb53294e81)({
                sourceProduct: sourceProduct,
                targetProducts: targetProducts
            }, updatedCacheState);
            const willNowBeEligible = updatedEligibility.ineligibilityReason === null;
            if (willNowBeEligible && (0, $a834e0c1c192b1ad$export$9db1624a8af791a4)('twcg-460-personalised-invite-notifications-m2', 'isEnabled', false, {
                fireExperimentExposure: false
            })) {
                const products = (0, $1mG05.INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS);
                const collaboratorsAccess = await getCollaborators({
                    products: products
                });
                (0, $58987587447d73e1$export$606587d4eb77e23d)({
                    collaboratorsWithProducts: collaboratorsAccess,
                    products: products,
                    cache: cache
                });
            }
            analytics.fireEligibilityUpdateSucceeded({
                sourceApp: sourceProduct,
                targetApps: targetProducts
            });
        } catch (error) {
            analytics.fireEligibilityUpdateFailed({
                sourceApp: sourceProduct,
                targetApps: targetProducts,
                error: error instanceof Error ? error.message : `${error}`
            });
        }
    }
    async function getTraits() {
        if (traitsDeferred.status !== 'initial' || !fetchTraits) return traitsDeferred.promise;
        traitsDeferred.status = 'loading';
        try {
            const traitsPromise = fetchTraits({
                cloudId: cloudId,
                userId: userId
            });
            // Resolving with traitsPromise adopts traitsPromise's fulfillment/rejection:
            traitsDeferred.resolve(traitsPromise);
            const traits = await traitsDeferred.promise;
            traitsDeferred.status = 'fulfilled';
            analytics.fireFetchInvitedAppShortcutsTraitsSucceeded({
                sourceApp: sourceProduct,
                targetApps: targetProducts
            });
            return traits;
        } catch (error) {
            traitsDeferred.status = 'rejected';
            analytics.fireFetchInvitedAppShortcutsTraitsFailed({
                sourceApp: sourceProduct,
                targetApps: targetProducts
            });
            throw error;
        }
    }
    async function getCollaborators({ products: products }) {
        return (0, $3Zy9L.getCollaboratorsInProducts)({
            products: products,
            cloudId: cloudId,
            userId: userId
        }).then((collaboratorsAccess)=>{
            analytics.fireFetchCollaboratorsAccessSucceeded({
                sourceApp: sourceProduct,
                targetApps: targetProducts,
                collaborators: collaboratorsAccess.length
            });
            return collaboratorsAccess;
        }).catch((error)=>{
            analytics.fireFetchCollaboratorsAccessFailed({
                sourceApp: sourceProduct,
                targetApps: targetProducts,
                error: error instanceof Error ? error.message : `${error}`
            });
            // fallback to empty collaborators access rather than failing the whole process
            return [];
        });
    }
}



var $68uaC = parcelRequire("68uaC");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $gqypm = parcelRequire("gqypm");


var $1jJCz = parcelRequire("1jJCz");

const $082cea242d4d809f$var$targetProductsJira = [
    'jira'
];
const $082cea242d4d809f$var$targetProductsEmpty = [];
const $082cea242d4d809f$export$e6614be55e8365cd = ()=>{
    const $ = (0, $frIzR.c)(13);
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { hasJira: hasJira } = (0, $1jJCz.useLicensedProducts)();
    const [cacheNeedsRefresh, setCacheNeedsRefresh] = (0, $42omo.useState)(false);
    let t0;
    if ($[0] !== cacheNeedsRefresh) {
        t0 = (0, $9wGTI.fg)("twcg-460-personalised-invite-notifications-m2-gate") && cacheNeedsRefresh;
        $[0] = cacheNeedsRefresh;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !t0;
    const t2 = userId || "";
    let t3;
    if ($[2] !== cloudId || $[3] !== t2) {
        t3 = {
            cloudId: cloudId,
            userId: t2
        };
        $[2] = cloudId;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t1 || $[6] !== t3) {
        t4 = {
            skip: t1,
            variables: t3,
            fetchPolicy: (0, $6mKj3.expVal)("cc_ce_mau_deprecated_tap_wrappers_migration", "isEnabled", false) ? "cache-and-network" : undefined
        };
        $[5] = t1;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    const userTraits = (0, $gqypm.useExperimentalSiteUserPersonalization)(t4);
    let t5;
    if ($[8] !== cloudId || $[9] !== hasJira || $[10] !== userId || $[11] !== userTraits) {
        t5 = (0, $9wGTI.fg)("twcg-460-personalised-invite-notifications-m2-gate") ? {
            enabled: true,
            targetProducts: hasJira ? $082cea242d4d809f$var$targetProductsJira : $082cea242d4d809f$var$targetProductsEmpty,
            sourceProduct: "confluence",
            cloudId: cloudId,
            userId: userId,
            traits: userTraits.data?.experimentalSiteUserPersonalization?.attributes ?? null,
            cache: $082cea242d4d809f$export$5e0574c563aa74b8(),
            onCacheNeedsRefresh: ()=>{
                setCacheNeedsRefresh(true);
            }
        } : {
            enabled: false
        };
        $[8] = cloudId;
        $[9] = hasJira;
        $[10] = userId;
        $[11] = userTraits;
        $[12] = t5;
    } else t5 = $[12];
    return (0, $e0f55f0500dfbf3c$export$c2e2a02c27ed0bc1)(t5);
};
let $082cea242d4d809f$var$cache;
const $082cea242d4d809f$export$5e0574c563aa74b8 = ()=>{
    if (!$082cea242d4d809f$var$cache) $082cea242d4d809f$var$cache = new (0, $3438e954aa0087f3$export$7bddb475c47d45d)({
        setCookie: (0, $68uaC.Cookies).set,
        getCookie: (0, $68uaC.Cookies).get
    });
    return $082cea242d4d809f$var$cache;
};
module.exports["useResolveInvitedAppShortcuts"] = $082cea242d4d809f$export$e6614be55e8365cd;

});

parcelRegister("1jJCz", function(module, exports) {

var $aQN68 = parcelRequire("aQN68");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $jtuBN = parcelRequire("jtuBN");

const $fbb15aeb32df38cf$var$useLicensedProductsQueryForGlobalAppShortcuts = (0, $aQN68.default);
const $fbb15aeb32df38cf$export$54d534cc91e54850 = ()=>{
    const queryResult = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)($fbb15aeb32df38cf$var$useLicensedProductsQueryForGlobalAppShortcuts) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)($fbb15aeb32df38cf$var$useLicensedProductsQueryForGlobalAppShortcuts, {
        __callerPackage__: "@confluence/side-navigation"
    });
    const { data: data } = queryResult;
    return (0, $42omo.useMemo)(()=>{
        const licensedProducts = data?.confluence_tenantContext?.licensedProducts || [];
        return licensedProducts.reduce((acc, product)=>{
            if (product.licenseStatus !== 'ACTIVE') return acc;
            switch(product.productKey){
                case 'jira-software':
                    acc.hasJira = true;
                    break;
                case 'loom':
                    acc.hasLoom = true;
                    break;
                default:
                    break;
            }
            return acc;
        }, {
            hasJira: false,
            hasLoom: false
        });
    }, [
        data
    ]);
};
module.exports["useLicensedProducts"] = $fbb15aeb32df38cf$export$54d534cc91e54850;

});

parcelRegister("eI95o", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $eSLr0 = parcelRequire("eSLr0");


var $6ld6a = parcelRequire("6ld6a");


var $7CeAz = parcelRequire("7CeAz");


var $1ytiN = parcelRequire("1ytiN");


var $jyPfN = parcelRequire("jyPfN");

// TODO: there is a large useMenuItems.ts file that might need refactoring, but for the moment lets just duplicate the keys where they are needed
// to avoid coupling the new side navigation code with the old menu item code. We can look at unifying these in the future when we have more clarity on what the new side navigation needs to do.
const $b91cdc93c54e2058$var$SPACE_DIRECTORY_KEY = 'com.atlassian.confluence.plugins.confluence-space-ia:header-spaces-link';
const $b91cdc93c54e2058$var$PEOPLE_DIRECTORY_KEY = 'com.atlassian.confluence.plugins.confluence-space-ia:header-people-link';
const $b91cdc93c54e2058$export$4873f44d198fe46c = ()=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
            allowedWebItems: [
                $b91cdc93c54e2058$var$SPACE_DIRECTORY_KEY,
                $b91cdc93c54e2058$var$PEOPLE_DIRECTORY_KEY
            ]
        };
        $[0] = t0;
    } else t0 = $[0];
    const { loading: webItemsLoading, webItems: webItems } = (0, $6ld6a.useWebItemLocation)(t0);
    const { isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled } = (0, $7CeAz.useIsCompanyHubEnabled)();
    const { frontCoverState: frontCoverState, loading: loading } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    let t1;
    if ($[1] !== hasViewUserProfilePermission || $[2] !== webItems || $[3] !== webItemsLoading) {
        t1 = !webItemsLoading && (hasViewUserProfilePermission || !!webItems.find($b91cdc93c54e2058$var$_temp));
        $[1] = hasViewUserProfilePermission;
        $[2] = webItems;
        $[3] = webItemsLoading;
        $[4] = t1;
    } else t1 = $[4];
    const isPeopleVisible = t1;
    const isCompanyHubVisible = !loading && isCompanyHubEntryPointEnabled && !!frontCoverState;
    let t2;
    if ($[5] !== isCompanyHubVisible || $[6] !== isPeopleVisible) {
        t2 = {
            isPeopleVisible: isPeopleVisible,
            isCompanyHubVisible: isCompanyHubVisible
        };
        $[5] = isCompanyHubVisible;
        $[6] = isPeopleVisible;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
function $b91cdc93c54e2058$var$_temp(item) {
    return item.completeKey === $b91cdc93c54e2058$var$PEOPLE_DIRECTORY_KEY;
}
module.exports["useShortcutVisibilityOverrides"] = $b91cdc93c54e2058$export$4873f44d198fe46c;

});

parcelRegister("h7d8T", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $ay6Zz = parcelRequire("ay6Zz");


var $1NBp8 = parcelRequire("1NBp8");


var $bQm3c = parcelRequire("bQm3c");


var $5XsiK = parcelRequire("5XsiK");

const $3fcbe4d85cbec684$export$597036aedc68c98f = ()=>{
    const $ = (0, $frIzR.c)(8);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId || $[1] !== orgId) {
        t0 = (0, $ay6Zz.navigateToTeamsApp)({
            type: "LANDING",
            cloudId: cloudId,
            orgId: orgId,
            userHasNav4Enabled: true
        });
        $[0] = cloudId;
        $[1] = orgId;
        $[2] = t0;
    } else t0 = $[2];
    const { href: href } = t0;
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1NBp8.COMPANY_HUB).toUrl();
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== href) {
        t2 = (0, $5XsiK.isTeamsAppEnabled)() ? href : "";
        $[4] = href;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = {
            companyHubShortcut: t1,
            teamsShortcut: t2
        };
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["useFallbackUrls"] = $3fcbe4d85cbec684$export$597036aedc68c98f;

});

parcelRegister("7DAwP", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");





var $lAFHW = parcelRequire("lAFHW");


var $culkJ = parcelRequire("culkJ");


var $3v0xY = parcelRequire("3v0xY");


var $aXWIB = parcelRequire("aXWIB");

const $82db327e56ac3de4$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.company-hub",
        defaultMessage: "Company Hub"
    }
});


const $5a42c6aaec7538b2$var$icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.HubIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $5a42c6aaec7538b2$export$50e5fd99bfef1a4a = (fallbackUrl, options = {})=>(0, $3v0xY.useAppGlobalShortcutLinkItem)($5a42c6aaec7538b2$var$icon, (0, $82db327e56ac3de4$export$defe85febe8b728c).label, fallbackUrl, {
        analyticsName: (0, $culkJ.Products).ATLAS_HUB,
        ...options
    });



var $12t1c = parcelRequire("12t1c");
















const $e96a79584135f443$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.loom",
        defaultMessage: "Loom"
    }
});


const $4898362ef69c915e$var$icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.LoomIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $4898362ef69c915e$export$ef6b4021b8157342 = (fallbackUrl, options = {})=>(0, $3v0xY.useAppGlobalShortcutLinkItem)($4898362ef69c915e$var$icon, (0, $e96a79584135f443$export$defe85febe8b728c).label, fallbackUrl, {
        apsKey: (0, $culkJ.Products).LOOM,
        analyticsName: (0, $culkJ.Products).LOOM,
        ...options
    });



var $GEjfy = parcelRequire("GEjfy");


var $5XsiK = parcelRequire("5XsiK");


var $8dN99 = parcelRequire("8dN99");


var $eI95o = parcelRequire("eI95o");


var $h7d8T = parcelRequire("h7d8T");


var $1jJCz = parcelRequire("1jJCz");

const $f02b9571823f0450$export$ed2673425deb0c2f = (props)=>{
    const $ = (0, $frIzR.c)(21);
    const fallbackUrls = (0, $h7d8T.useFallbackUrls)();
    const { hasLoom: hasLoom, hasJira: hasJira } = (0, $1jJCz.useLicensedProducts)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $5XsiK.isTeamsAppEnabled)();
        $[0] = t0;
    } else t0 = $[0];
    const teamsAppEnabled = t0;
    const { isPeopleVisible: isPeopleVisible, isCompanyHubVisible: isCompanyHubVisible } = (0, $eI95o.useShortcutVisibilityOverrides)();
    const companyHubShortcutWithoutComponent = (0, $5a42c6aaec7538b2$export$50e5fd99bfef1a4a)(fallbackUrls.companyHubShortcut);
    const jiraShortcut = (0, $12t1c.useJira)("");
    const loomShortcut = (0, $4898362ef69c915e$export$ef6b4021b8157342)("");
    const teamsShortcut = (0, $GEjfy.useTeams)(fallbackUrls.teamsShortcut);
    props?.teamsShortcutConfig;
    let t1;
    if ($[1] !== companyHubShortcutWithoutComponent) {
        t1 = {
            ...companyHubShortcutWithoutComponent,
            menuItemId: "companyHubShortcut",
            type: "component",
            isReorderable: true,
            component: $f02b9571823f0450$var$_temp
        };
        $[1] = companyHubShortcutWithoutComponent;
        $[2] = t1;
    } else t1 = $[2];
    const companyHubShortcut = t1;
    let t2;
    if ($[3] !== companyHubShortcut || $[4] !== isCompanyHubVisible) {
        t2 = isCompanyHubVisible ? {
            companyHubShortcut: companyHubShortcut
        } : {};
        $[3] = companyHubShortcut;
        $[4] = isCompanyHubVisible;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== hasJira || $[7] !== jiraShortcut) {
        t3 = hasJira ? {
            jiraShortcut: jiraShortcut
        } : {};
        $[6] = hasJira;
        $[7] = jiraShortcut;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== hasLoom || $[10] !== loomShortcut) {
        t4 = hasLoom ? {
            loomShortcut: loomShortcut
        } : {};
        $[9] = hasLoom;
        $[10] = loomShortcut;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== isPeopleVisible || $[13] !== props?.teamsShortcutConfig || $[14] !== teamsShortcut) {
        t5 = isPeopleVisible && teamsAppEnabled ? {
            teamsShortcut: props?.teamsShortcutConfig ?? teamsShortcut
        } : {};
        $[12] = isPeopleVisible;
        $[13] = props?.teamsShortcutConfig;
        $[14] = teamsShortcut;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5) {
        t6 = {
            ...t2,
            ...t3,
            ...t4,
            ...t5
        };
        $[16] = t2;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
};
function $f02b9571823f0450$var$_temp(itemProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8dN99.CompanyHubItem), itemProps);
}
module.exports["useShortcutItemsConfig"] = $f02b9571823f0450$export$ed2673425deb0c2f;

});

parcelRegister("aGiXn", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $T1bCI = parcelRequire("T1bCI");


var $iXCQx = parcelRequire("iXCQx");


var $inPa6 = parcelRequire("inPa6");


var $GEjfy = parcelRequire("GEjfy");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $hSHWm = parcelRequire("hSHWm");


var $gqqjz = parcelRequire("gqqjz");


var $koZ31 = parcelRequire("koZ31");








var $6xdDU = parcelRequire("6xdDU");


var $g6zY9 = parcelRequire("g6zY9");


var $jmjWc = parcelRequire("jmjWc");





const $063311bef2820fe3$var$LazyTeamCreateDialog = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dULDy",
    name: "LazyTeamCreateDialog",
    loader: ()=>(parcelRequire("hv8RR")).then(({ TeamCreateDialog: TeamCreateDialog })=>TeamCreateDialog),
    loading: ()=>null
});
function $063311bef2820fe3$export$9169fd4d2562e042(t0) {
    const $ = (0, $frIzR.c)(10);
    const { isOpen: isOpen, onClose: onClose, addFlag: addFlag } = t0;
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] !== addFlag) {
        t1 = (flag)=>{
            const { title: title, description: description, appearance: appearance, actions: actions } = flag;
            addFlag({
                type: appearance === "success" || appearance === "normal" ? "success-circle" : appearance,
                title: title,
                description: description,
                close: "auto",
                actions: actions,
                id: flag.id
            });
        };
        $[0] = addFlag;
        $[1] = t1;
    } else t1 = $[1];
    const addFlagFn = t1;
    let t2;
    if ($[2] !== addFlagFn || $[3] !== cloudId || $[4] !== isOpen || $[5] !== onClose || $[6] !== orgId) {
        t2 = isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g6zY9.PeopleAndTeamsConfigurationProvider), {
            product: "confluence"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($063311bef2820fe3$var$LazyTeamCreateDialog, {
            cloudId: cloudId,
            product: "confluence",
            orgId: orgId,
            onClose: onClose,
            enableMembershipSettingsChoice: true,
            enableTeamPermissionCheck: true,
            onCreateTeamSuccess: onClose,
            onCreateTeamFailed: onClose,
            addFlag: addFlagFn
        }))) : null;
        $[2] = addFlagFn;
        $[3] = cloudId;
        $[4] = isOpen;
        $[5] = onClose;
        $[6] = orgId;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, t2);
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
}



var $h7d8T = parcelRequire("h7d8T");

const $276167d1ecf073e2$var$ACTION_SUBJECT_ID = 'teamsAppShortcut';
const $276167d1ecf073e2$var$CREATE_A_TEAM = 'createATeam';
const $276167d1ecf073e2$var$INVITE_PEOPLE = 'invitePeople';
const $276167d1ecf073e2$export$68b2e4594fafcb97 = ()=>{
    const $ = (0, $frIzR.c)(20);
    const hasFiredExposure = (0, $42omo.useRef)(false);
    const fallbackUrls = (0, $h7d8T.useFallbackUrls)();
    const shortcutUrl = fallbackUrls.teamsShortcut;
    const teamsShortcut = (0, $GEjfy.useTeams)(shortcutUrl);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { openCoreInvites: openCoreInvites } = (0, $42omo.useContext)((0, $hSHWm.CoreInvitesContext));
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $6mKj3.UNSAFE_noExposureExp)("confluence_global_nav_teams_app_with_actions");
        $[0] = t0;
    } else t0 = $[0];
    const [experimentConfig, fireExposure] = t0;
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = experimentConfig.get("cohort", "not-enrolled");
        $[1] = t1;
    } else t1 = $[1];
    const cohort = t1;
    const [isCreateTeamModalOpen, setCreateTeamModalOpen] = (0, $42omo.useState)(false);
    let t2;
    if ($[2] !== createAnalyticsEvent) {
        t2 = ()=>{
            if (!hasFiredExposure.current) {
                hasFiredExposure.current = true;
                fireExposure();
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        source: "globalNavigation",
                        action: "mouseEnter",
                        actionSubject: "navigationItem",
                        actionSubjectId: $276167d1ecf073e2$var$ACTION_SUBJECT_ID,
                        attributes: {
                            inviteFromTeamsAppCohort: cohort
                        }
                    }
                }).fire();
            }
        };
        $[2] = createAnalyticsEvent;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== cloudId || $[5] !== formatMessage || $[6] !== openCoreInvites) {
        t3 = cohort === "variation" ? {
            actions: [
                ...openCoreInvites ? [
                    {
                        onClick: ()=>{
                            openCoreInvites((0, $koZ31.CoreInvitesSource).PEOPLE_MENU, {
                                onModalClosed: $276167d1ecf073e2$var$_temp,
                                onInviteCompleted: $276167d1ecf073e2$var$_temp2
                            }, undefined, {
                                resourceAri: `ari:cloud:confluence::site/${cloudId}`,
                                source: $276167d1ecf073e2$var$ACTION_SUBJECT_ID
                            });
                        },
                        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($276167d1ecf073e2$var$messages.invitePeople)),
                        itemId: $276167d1ecf073e2$var$INVITE_PEOPLE
                    }
                ] : [],
                {
                    onClick: ()=>{
                        setCreateTeamModalOpen(true);
                    },
                    component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($276167d1ecf073e2$var$messages.createTeam)),
                    itemId: $276167d1ecf073e2$var$CREATE_A_TEAM
                }
            ]
        } : {};
        $[4] = cloudId;
        $[5] = formatMessage;
        $[6] = openCoreInvites;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t2 || $[9] !== t3 || $[10] !== teamsShortcut) {
        t4 = {
            ...teamsShortcut,
            onMouseEnter: t2,
            ...t3
        };
        $[8] = t2;
        $[9] = t3;
        $[10] = teamsShortcut;
        $[11] = t4;
    } else t4 = $[11];
    const config = t4;
    let t5;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== isCreateTeamModalOpen) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t5
        }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $063311bef2820fe3$export$9169fd4d2562e042), {
                isOpen: isCreateTeamModalOpen,
                onClose: ()=>setCreateTeamModalOpen(false),
                addFlag: flags.showFlag
            }));
        $[13] = isCreateTeamModalOpen;
        $[14] = t6;
    } else t6 = $[14];
    const createTeamModalComponent = t6;
    if (cohort !== "variation") {
        let t7;
        if ($[15] !== config) {
            t7 = {
                config: config,
                component: null
            };
            $[15] = config;
            $[16] = t7;
        } else t7 = $[16];
        return t7;
    }
    let t7;
    if ($[17] !== config || $[18] !== createTeamModalComponent) {
        t7 = {
            config: config,
            component: createTeamModalComponent
        };
        $[17] = config;
        $[18] = createTeamModalComponent;
        $[19] = t7;
    } else t7 = $[19];
    return t7;
};
const $276167d1ecf073e2$var$messages = (0, $aXWIB.defineMessages)({
    invitePeople: {
        id: "side-navigation.custom.teams-app-shortcut.invite-people",
        defaultMessage: "Invite people"
    },
    createTeam: {
        id: "side-navigation.custom.teams-app-shortcut.create-team",
        defaultMessage: "Create team"
    }
});
function $276167d1ecf073e2$var$_temp() {
    return null;
}
function $276167d1ecf073e2$var$_temp2() {
    return null;
}
module.exports["useTeamsAppShortcut"] = $276167d1ecf073e2$export$68b2e4594fafcb97;

});

parcelRegister("hv8RR", function(module, exports) {

let $cbdc35df084808f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cbdc35df084808f7$var$load("4qVsX"),
    $cbdc35df084808f7$var$load("jPZn6"),
    $cbdc35df084808f7$var$load("6wr18"),
    $cbdc35df084808f7$var$load("8b0Gw"),
    $cbdc35df084808f7$var$load("hga3v"),
    $cbdc35df084808f7$var$load("lTK3c"),
    $cbdc35df084808f7$var$load("1WXdc"),
    $cbdc35df084808f7$var$load("kHOMt"),
    $cbdc35df084808f7$var$load("ffEVr"),
    $cbdc35df084808f7$var$load("hhss7"),
    $cbdc35df084808f7$var$load("7EorR"),
    $cbdc35df084808f7$var$load("Wowvf"),
    $cbdc35df084808f7$var$load("cRtGo"),
    $cbdc35df084808f7$var$load("k7TXX")
]).then(()=>parcelRequire('hS9vX'));

});

parcelRegister("9vJRo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aDe4X = parcelRequire("aDe4X");

/* eslint-disable import/no-duplicates */ 



var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $2SvFZ = parcelRequire("2SvFZ");


var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fNcP1 = parcelRequire("fNcP1");

var $19Jj3 = parcelRequire("19Jj3");


var $ivb8S = parcelRequire("ivb8S");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $b3j2Y = parcelRequire("b3j2Y");


var $lsxnT = parcelRequire("lsxnT");


var $b4VFP = parcelRequire("b4VFP");














var $3SChL = parcelRequire("3SChL");

const $996603fe96782b8b$export$8f136d122118bae4 = ({ skip: skip = false } = {})=>{
    const isOnHomeOrWikiRouteArgs = {
        selector: (routeName)=>{
            if (!routeName) return false;
            return routeName === (0, $1NBp8.WIKI).name || routeName === (0, $1NBp8.HOME).name;
        }
    };
    const isOnHome = (0, $dPJCf.useRouteName)(isOnHomeOrWikiRouteArgs);
    const { active: isNthUserOrientationActive } = (0, $3SChL.useNthUserOrientationState)();
    const localSkip = skip || isOnHome || isNthUserOrientationActive;
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS)), localSkip);
    const { hasSeenHomeNudge: hasSeenHomeNudge, takeoverSeenAt: takeoverSeenAt, hasDismissedTakeover: hasDismissedTakeover, isHomeNudgeScheduledAt: isHomeNudgeScheduledAt } = (0, $ivb8S.deserializeState)(data);
    if (localSkip || loading || error) return {
        isEligibleForHomeNudge: false,
        isOnHome: isOnHome,
        loading: loading,
        error: error
    };
    return {
        isEligibleForHomeNudge: Boolean(!hasSeenHomeNudge && !takeoverSeenAt && !hasDismissedTakeover),
        isHomeNudgeScheduledAt: isHomeNudgeScheduledAt,
        isOnHome: isOnHome,
        loading: loading,
        error: error
    };
};


const $d3cc8422fc7cecaf$var$i18n = (0, $aXWIB.defineMessages)({
    homeSpotlightHeader: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.title",
        defaultMessage: "More ways to get started \uD83D\uDCA1"
    },
    homeSpotlightText: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.description",
        defaultMessage: "When you\u2019re ready, discover tailored onboarding suggestions in For You."
    },
    homeSpotlightCloseButtonText: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.button-got-it",
        defaultMessage: "Got it"
    },
    homeSpotlightTryItButtonText: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.button-go-to-for-you",
        defaultMessage: "Go to For You"
    }
});
const $d3cc8422fc7cecaf$export$8ee05f5dc902d0f5 = ({ children: children })=>{
    const [isHomeNudgeHidden, setIsHomeNudgeHidden] = (0, $42omo.useState)(true);
    const wasEligibleForOnboardingNudgeRef = (0, $42omo.useRef)(false);
    const timeoutRef = (0, $42omo.useRef)(undefined);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    // This is the onboarding state hidden
    const { isEligibleForHomeNudge: isEligibleForHomeNudge, isOnHome: isOnHome, error: error, isHomeNudgeScheduledAt: isHomeNudgeScheduledAt } = (0, $996603fe96782b8b$export$8f136d122118bae4)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const expandSideNav = (0, $2SvFZ.useExpandSideNav)();
    const transitionId = (0, $dPJCf.useTransitionId)();
    const transitionIdRef = (0, $42omo.useRef)(null);
    const { startMessage: startMessage, stopMessage: stopMessage } = useChoreographer('nth-user-home-onboarding-takeover-v2-home-nudge', {
        start: ()=>setIsHomeNudgeHidden(false),
        stop: ()=>setIsHomeNudgeHidden(true)
    });
    const handleDismiss = ()=>{
        setIsHomeNudgeHidden(true);
        stopMessage();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'nthUserHomeOnboardingTakeoverV2HomeNudgeDismiss',
                source: 'onboarding'
            }
        }).fire();
    };
    const handleGoHome = ()=>{
        push((0, $1NBp8.HOME).toUrl());
        stopMessage();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'nthUserHomeOnboardingTakeoverV2HomeNudgeGoHome',
                source: 'onboarding'
            }
        }).fire();
    };
    (0, $42omo.useEffect)(()=>{
        const showNudge = ()=>{
            setOnboardingState({
                key: (0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).hasSeenHomeNudge,
                value: 'true'
            });
            startMessage();
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    action: 'viewed',
                    name: 'nthUserHomeOnboardingTakeoverV2HomeNudge'
                }
            }).fire();
            expandSideNav();
        };
        if (isEligibleForHomeNudge && isHomeNudgeHidden && (!wasEligibleForOnboardingNudgeRef.current || transitionIdRef.current !== transitionId)) {
            // first time about to show nudge, wait 2mins seconds before showing
            // Upon subsequent reloads or navigation, show the nudge immediately
            if (!timeoutRef.current && !isHomeNudgeScheduledAt) {
                timeoutRef.current = setTimeout(()=>{
                    showNudge();
                    clearTimeout(timeoutRef.current);
                }, 120000);
                setOnboardingState({
                    key: (0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).isHomeNudgeScheduledAt,
                    value: new Date().toISOString()
                });
            } else if (isHomeNudgeScheduledAt && (transitionId === 0 || transitionIdRef.current !== transitionId)) {
                showNudge();
                clearTimeout(timeoutRef.current);
            }
            wasEligibleForOnboardingNudgeRef.current = true;
        }
        transitionIdRef.current = transitionId;
    }, [
        createAnalyticsEvent,
        isEligibleForHomeNudge,
        isHomeNudgeHidden,
        setOnboardingState,
        startMessage,
        stopMessage,
        expandSideNav,
        transitionId,
        isHomeNudgeScheduledAt
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    const isNudgeHidden = !isHomeNudgeHidden && (wasEligibleForOnboardingNudgeRef.current || isEligibleForHomeNudge);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        dismiss: handleDismiss,
        placement: "right-end",
        isVisible: isNudgeHidden && !isOnHome
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
        testId: "spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage($d3cc8422fc7cecaf$var$i18n.homeSpotlightHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), {
        onClick: handleDismiss
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, formatMessage($d3cc8422fc7cecaf$var$i18n.homeSpotlightText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
        onClick: handleGoHome
    }, formatMessage($d3cc8422fc7cecaf$var$i18n.homeSpotlightTryItButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $19Jj3.SpotlightSecondaryAction), {
        onClick: handleDismiss
    }, formatMessage($d3cc8422fc7cecaf$var$i18n.homeSpotlightCloseButtonText)))))), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }));
};


const $4ac6d1a639d952f5$export$7f711697718dffe7 = ({ children: children })=>{
    const { isEligible: v2NthUserEligible, loading: v2NthUserLoading } = (0, $aDe4X.useNthUserHomeOnboardingTakeoverV2Eligibility)();
    if (v2NthUserLoading) return children;
    if (v2NthUserEligible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d3cc8422fc7cecaf$export$8ee05f5dc902d0f5), {
        position: "bottom-start"
    }, children);
    return children;
};
module.exports["HomeOnboardingTakeoverV2HomeNudge"] = $4ac6d1a639d952f5$export$7f711697718dffe7;

});

parcelRegister("aKkeT", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6GD8y = parcelRequire("6GD8y");


var $dPJCf = parcelRequire("dPJCf");

const $d2fc0c31cdd9908e$export$65c30f73882c92dc = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { href: href, keyboardShortcut: keyboardShortcut, deprecatedKeyboardShortcut: deprecatedKeyboardShortcut, isAppNavigationShortcut: isAppNavigationShortcut, children: children, onShortcutTriggered: onShortcutTriggered } = t0;
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t1;
    if ($[0] !== href || $[1] !== onShortcutTriggered || $[2] !== push) {
        t1 = ()=>{
            onShortcutTriggered?.();
            href && push(href);
        };
        $[0] = href;
        $[1] = onShortcutTriggered;
        $[2] = push;
        $[3] = t1;
    } else t1 = $[3];
    const listenerCallback = t1;
    let t2;
    if ($[4] !== deprecatedKeyboardShortcut || $[5] !== isAppNavigationShortcut || $[6] !== keyboardShortcut || $[7] !== listenerCallback) {
        t2 = keyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: deprecatedKeyboardShortcut,
            accelerator: keyboardShortcut,
            listener: listenerCallback,
            isAppNavigationShortcut: isAppNavigationShortcut || false
        });
        $[4] = deprecatedKeyboardShortcut;
        $[5] = isAppNavigationShortcut;
        $[6] = keyboardShortcut;
        $[7] = listenerCallback;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== children || $[10] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children, t2);
        $[9] = children;
        $[10] = t2;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
});
module.exports["KeyboardShortcutWrapper"] = $d2fc0c31cdd9908e$export$65c30f73882c92dc;

});

parcelRegister("4ByCJ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $gnkil = parcelRequire("gnkil");


var $jmjWc = parcelRequire("jmjWc");


var $bQm3c = parcelRequire("bQm3c");


var $efvKr = parcelRequire("efvKr");


var $9vJRo = parcelRequire("9vJRo");


var $de2j9 = parcelRequire("de2j9");


var $166II = parcelRequire("166II");


var $irVI7 = parcelRequire("irVI7");


var $hjygH = parcelRequire("hjygH");

var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $aKkeT = parcelRequire("aKkeT");


var $eLFsG = parcelRequire("eLFsG");


var $XO4by = parcelRequire("XO4by");


var $iQcdJ = parcelRequire("iQcdJ");


var $26Pni = parcelRequire("26Pni");


var $hl4GB = parcelRequire("hl4GB");

const $b9f550940f484a79$var$recentAttributes = {
    navVersion: '4',
    dropdownType: 'recent'
};
const $b9f550940f484a79$var$starredAttributes = {
    navVersion: '4',
    dropdownType: 'starred'
};

const $b9f550940f484a79$export$17b89e6a36c6b530 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "RR3ov",
    name: "StarredContentMenuLoader",
    loader: async ()=>(await (parcelRequire("jGeq1"))).StarredContentMenu
});

const $b9f550940f484a79$export$af1f39df90a1145e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8g6fk",
    name: "RecentContentMenuLoader",
    loader: async ()=>(await (parcelRequire("lJsxB"))).RecentContentMenu
});
const $b9f550940f484a79$var$StopRecent = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
            name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
            attributes: $b9f550940f484a79$var$recentAttributes
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $b9f550940f484a79$var$StopStarred = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
            name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
            attributes: $b9f550940f484a79$var$starredAttributes
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $b9f550940f484a79$var$ForYouItemWrapper = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { children: children, homeUrl: homeUrl, deprecatedKeyboardShortcut: deprecatedKeyboardShortcut } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9vJRo.HomeOnboardingTakeoverV2HomeNudge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $166II.EditorForYouSpotlight), null, children));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== deprecatedKeyboardShortcut || $[3] !== homeUrl || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hl4GB.DiscoErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aKkeT.KeyboardShortcutWrapper), {
            href: homeUrl,
            deprecatedKeyboardShortcut: deprecatedKeyboardShortcut,
            keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_HOME_SHORTCUT),
            isAppNavigationShortcut: true
        }, t1));
        $[2] = deprecatedKeyboardShortcut;
        $[3] = homeUrl;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
const $b9f550940f484a79$var$GenericItemWrapper = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children, deprecatedKeyboardShortcut: deprecatedKeyboardShortcut, keyboardShortcut: keyboardShortcut, onMouseEnter: onMouseEnter, onShortcutTriggered: onShortcutTriggered } = t0;
    let t1;
    if ($[0] !== children || $[1] !== deprecatedKeyboardShortcut || $[2] !== keyboardShortcut || $[3] !== onShortcutTriggered) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aKkeT.KeyboardShortcutWrapper), {
            deprecatedKeyboardShortcut: deprecatedKeyboardShortcut,
            keyboardShortcut: keyboardShortcut,
            isAppNavigationShortcut: true,
            onShortcutTriggered: onShortcutTriggered
        }, children);
        $[0] = children;
        $[1] = deprecatedKeyboardShortcut;
        $[2] = keyboardShortcut;
        $[3] = onShortcutTriggered;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== onMouseEnter || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hl4GB.DiscoErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: onMouseEnter,
            onFocus: onMouseEnter
        }, t1));
        $[5] = onMouseEnter;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $b9f550940f484a79$export$f29dcc074aa4bb66 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const homeUrl = (0, $1NBp8.HOME).toUrl();
    const isHomeSelected = (0, $dPJCf.useRouteUrl)($b9f550940f484a79$var$isOnHomeSelector);
    const isRecentOpenRef = (0, $42omo.useRef)(false);
    const recentsFilterConfig = (0, $iQcdJ.useRecentsFilterConfig)();
    const recentViewAllUrl = (0, $1NBp8.HOME).toUrl({
        view: 'recent'
    });
    const [isRecentOpen, setIsRecentOpen] = (0, $42omo.useState)(false);
    const isRecentSelected = (0, $dPJCf.useRouteUrl)($b9f550940f484a79$var$isOnRecentRoute);
    const onRecentMouseEnter = (0, $42omo.useCallback)(()=>{
        if (!isRecentOpenRef.current) {
            $b9f550940f484a79$export$af1f39df90a1145e.preload();
            (0, $XO4by.preloadRecentContentMenu)(cloudId);
        }
    }, [
        cloudId
    ]);
    const onRecentShortcut = (0, $42omo.useCallback)(()=>{
        const next = !isRecentOpenRef.current;
        isRecentOpenRef.current = next;
        setIsRecentOpen(next);
        if (next) {
            isStarredOpenRef.current = false;
            setIsStarredOpen(false);
        }
    }, []);
    const isStarredOpenRef = (0, $42omo.useRef)(false);
    const starredViewAllUrl = (0, $1NBp8.HOME).toUrl({
        view: 'starred'
    });
    const [isStarredOpen, setIsStarredOpen] = (0, $42omo.useState)(false);
    const isStarredSelected = (0, $dPJCf.useRouteUrl)($b9f550940f484a79$var$isOnStarredRoute);
    const onStarredMouseEnter = (0, $42omo.useCallback)(()=>{
        if (!isStarredOpenRef.current) {
            $b9f550940f484a79$export$17b89e6a36c6b530.preload();
            (0, $eLFsG.preloadStarredContentMenu)();
        }
    }, []);
    const onStarredShortcut = (0, $42omo.useCallback)(()=>{
        const next_0 = !isStarredOpenRef.current;
        isStarredOpenRef.current = next_0;
        setIsStarredOpen(next_0);
        if (next_0) {
            isRecentOpenRef.current = false;
            setIsRecentOpen(false);
        }
    }, []);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const startExperienceTracker = (0, $42omo.useCallback)((experienceName)=>{
        experienceTracker.start({
            name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
            attributes: {
                navVersion: '4',
                dropdownType: experienceName
            }
        });
    }, [
        experienceTracker
    ]);
    const onRecentOpenChange = (0, $42omo.useCallback)((isOpen)=>{
        if (isOpen) startExperienceTracker('recent');
        isRecentOpenRef.current = isOpen;
        setIsRecentOpen(isOpen);
    }, [
        startExperienceTracker
    ]);
    const onStarredOpenChange = (0, $42omo.useCallback)((isOpen_0)=>{
        if (isOpen_0) startExperienceTracker('starred');
        isStarredOpenRef.current = isOpen_0;
        setIsStarredOpen(isOpen_0);
    }, [
        startExperienceTracker
    ]);
    const isKeyboardShortcutEnabled = !(isLiveEditMode || isOnEditRoute);
    const ForYouWrapper = (0, $42omo.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9f550940f484a79$var$ForYouItemWrapper, {
            ...props,
            homeUrl: homeUrl,
            deprecatedKeyboardShortcut: isKeyboardShortcutEnabled ? (0, $gnkil.GO_HOME_SHORTCUT) : undefined
        }), [
        homeUrl,
        isKeyboardShortcutEnabled
    ]);
    const RecentWrapper = (0, $42omo.useCallback)((props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9f550940f484a79$var$GenericItemWrapper, {
            ...props_0,
            deprecatedKeyboardShortcut: isKeyboardShortcutEnabled ? (0, $gnkil.GO_TO_RECENT_SHORTCUT) : undefined,
            keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_TO_RECENT_SHORTCUT),
            onMouseEnter: onRecentMouseEnter,
            onShortcutTriggered: onRecentShortcut
        }), [
        isKeyboardShortcutEnabled,
        onRecentMouseEnter,
        onRecentShortcut
    ]);
    const StarredWrapper = (0, $42omo.useCallback)((props_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9f550940f484a79$var$GenericItemWrapper, {
            ...props_1,
            deprecatedKeyboardShortcut: isKeyboardShortcutEnabled ? (0, $gnkil.GO_TO_STARRED_SHORTCUT) : undefined,
            keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_TO_STARRED_SHORTCUT),
            onMouseEnter: onStarredMouseEnter,
            onShortcutTriggered: onStarredShortcut
        }), [
        isKeyboardShortcutEnabled,
        onStarredMouseEnter,
        onStarredShortcut
    ]);
    return (0, $42omo.useMemo)(()=>({
            forYouItem: {
                type: 'link',
                menuItemId: 'yourWork',
                url: homeUrl,
                isSelected: isHomeSelected,
                ItemWrapper: ForYouWrapper
            },
            recent: {
                menuItemId: 'recent',
                useItems: (0, $iQcdJ.useRecentItems),
                viewAllUrl: recentViewAllUrl,
                isSearchable: true,
                filterConfig: recentsFilterConfig,
                isSelected: isRecentSelected,
                isOpen: isRecentOpen,
                children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9f550940f484a79$export$af1f39df90a1145e, null),
                experienceEndTracker: $b9f550940f484a79$var$StopRecent,
                onOpenChange: onRecentOpenChange,
                ItemWrapper: RecentWrapper
            },
            starred: {
                menuItemId: 'starred',
                useItems: (0, $26Pni.useStarredItems),
                viewAllUrl: starredViewAllUrl,
                isSearchable: true,
                isOpen: isStarredOpen,
                isSelected: isStarredSelected,
                children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9f550940f484a79$export$17b89e6a36c6b530, null),
                experienceEndTracker: $b9f550940f484a79$var$StopStarred,
                onOpenChange: onStarredOpenChange,
                ItemWrapper: StarredWrapper
            }
        }), [
        homeUrl,
        isHomeSelected,
        isRecentOpen,
        isRecentSelected,
        isStarredOpen,
        isStarredSelected,
        recentViewAllUrl,
        recentsFilterConfig,
        starredViewAllUrl,
        onRecentOpenChange,
        onStarredOpenChange,
        ForYouWrapper,
        RecentWrapper,
        StarredWrapper
    ]);
};
const $b9f550940f484a79$var$isOnHomeSelector = {
    selector: (routeUrl)=>{
        if (!routeUrl) return false;
        return routeUrl === (0, $1NBp8.HOME).toUrl() || routeUrl === (0, $1NBp8.WIKI).toUrl();
    }
};
const $b9f550940f484a79$var$isOnStarredRoute = {
    selector: (routeUrl)=>routeUrl === (0, $1NBp8.HOME).toUrl({
            view: 'starred'
        })
};
const $b9f550940f484a79$var$isOnRecentRoute = {
    selector: (routeUrl)=>routeUrl === (0, $1NBp8.HOME).toUrl({
            view: 'recent'
        })
};
module.exports["useForYouConfig"] = $b9f550940f484a79$export$f29dcc074aa4bb66;

});

parcelRegister("166II", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $jrref = parcelRequire("jrref");

var $iXCQx = parcelRequire("iXCQx");


var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fdtRy = parcelRequire("fdtRy");

var $fNcP1 = parcelRequire("fNcP1");

var $19Jj3 = parcelRequire("19Jj3");

var $aG6kF = parcelRequire("aG6kF");


var $gj7hi = parcelRequire("gj7hi");


var $fT2ta = parcelRequire("fT2ta");


var $dh538 = parcelRequire("dh538");


var $lsxnT = parcelRequire("lsxnT");

var $2ff731f9901765b7$exports = {};
$2ff731f9901765b7$exports = new URL("Home.eb3dbfc7.gif", import.meta.url).toString();


var $aaa2d9cdc909fccc$exports = {};
$aaa2d9cdc909fccc$exports = new URL("Home-dark.b4541437.gif", import.meta.url).toString();



var $3Awqk = parcelRequire("3Awqk");


var $3SChL = parcelRequire("3SChL");


var $2AgON = parcelRequire("2AgON");

var $45d79bcc480adcc3$exports = {};
$45d79bcc480adcc3$exports = new URL("Home-placeholder.72eb75ff.png", import.meta.url).toString();


var $43c7d0807c4785cf$exports = {};
$43c7d0807c4785cf$exports = new URL("Home-placeholder-dark.86521bfc.png", import.meta.url).toString();



var $35Nok = parcelRequire("35Nok");

const $3472cc1e48bf28c2$var$STEP_ID = 'nth-user-orientation-editor-for-you-spotlight';
const $3472cc1e48bf28c2$export$9cb1114290a9ed04 = ({ children: children })=>{
    const { reset: reset, next: next, back: back, currentStep: currentStep, progress: progress, hasInteracted: hasInteracted, active: active } = (0, $3SChL.useTour)($3472cc1e48bf28c2$var$STEP_ID);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isVisible = currentStep === $3472cc1e48bf28c2$var$STEP_ID;
    const { PopoverContent: PopoverContent } = (0, $lsxnT.useChoreographerAssets)();
    const currentSrc = (0, $35Nok.usePreloadGif)({
        gif: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($2ff731f9901765b7$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($aaa2d9cdc909fccc$exports)))
        },
        placeholder: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($45d79bcc480adcc3$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($43c7d0807c4785cf$exports)))
        },
        skip: !active
    });
    const { handleNext: handleNext, handleBack: handleBack, handleDismiss: handleDismiss } = (0, $2AgON.useSpotlightAnalytics)({
        spotlightId: $3472cc1e48bf28c2$var$STEP_ID,
        isVisible: isVisible,
        onNext: next,
        onBack: back,
        onDismiss: reset
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jrref.Hide), {
        below: "md"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PopoverContent, {
        shouldDismissOnClickOutside: false,
        next: handleNext,
        back: handleBack,
        dismiss: handleDismiss,
        placement: "right-end",
        offset: [
            0,
            24
        ],
        isVisible: isVisible,
        messageId: $3472cc1e48bf28c2$var$STEP_ID,
        messageType: hasInteracted ? 'transactional' : 'engagement'
    }, (()=>{
        const spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
            testId: $3472cc1e48bf28c2$var$STEP_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage((0, $3Awqk.editorForYouSpotlight).headline)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: currentSrc,
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage((0, $3Awqk.editorForYouSpotlight).body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aG6kF.SpotlightStepCount), null, formatMessage((0, $3Awqk.spotlight).progress, progress)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $19Jj3.SpotlightSecondaryAction), null, formatMessage((0, $3Awqk.spotlight).back)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), null, formatMessage((0, $3Awqk.spotlight).next)))));
        return (0, $dh538.fg)('platform-dst-motion-uplift-spotlight') ? spotlightCard : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: "left"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, spotlightCard));
    })())));
};
module.exports["EditorForYouSpotlight"] = $3472cc1e48bf28c2$export$9cb1114290a9ed04;

});

parcelRegister("eLFsG", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $gSytF = parcelRequire("gSytF");


var $6KZ8B = parcelRequire("6KZ8B");

function $db09a4ff30df6c3f$export$4c74f8426e49d30c() {
    return (0, $dYU3e.query)({
        query: (0, $gSytF.default),
        variables: (0, $6KZ8B.starredContentMenuQueryVars),
        fetchPolicy: 'network-only',
        __callerPackage__: "@confluence/side-navigation"
    });
}
module.exports["preloadStarredContentMenu"] = $db09a4ff30df6c3f$export$4c74f8426e49d30c;

});

parcelRegister("gSytF", function(module, exports) {
/**
 * @generated SignedSource<<339eec75f348e2a32fda637fa1a0b690>>
 * @relayHash 0913aa0e7f577fc63dfd041de0b5136e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ae0bd328ec8252dd2e2f88475c08a5447b0ace0d9051443e47deaca0e2dcd468
const $5baefebdfa73b4d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": 30,
            "kind": "LocalArgument",
            "name": "limit"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "start"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "status"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "limit",
                    "variableName": "limit"
                },
                {
                    "kind": "Variable",
                    "name": "start",
                    "variableName": "start"
                }
            ],
            "concreteType": "PaginatedContentList",
            "kind": "LinkedField",
            "name": "favoriteContent",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        },
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "editui"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "favouritedDate"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "ContributionStatusSummary",
                                            "kind": "LinkedField",
                                            "name": "lastcontributed",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "when"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "emoji",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published",
                                        "emoji-title-draft"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        }
                    ]
                },
                {
                    "concreteType": "ContentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "cursor"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "StarredContentMenuQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "StarredContentMenuQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "0913aa0e7f577fc63dfd041de0b5136e",
            "id": "ae0bd328ec8252dd2e2f88475c08a5447b0ace0d9051443e47deaca0e2dcd468",
            "metadata": {},
            "name": "StarredContentMenuQuery",
            "operationKind": "query",
            "text": "query StarredContentMenuQuery($limit:Int=30,$start:Int!){favoriteContent(limit:$limit,start:$start){nodes{id,type,subType,title,status,space{id,name},links{webui,editui},metadata{currentuser{favourited{isFavourite,favouritedDate},lastcontributed{status,when}}},emoji:properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}}},pageInfo{hasNextPage},edges{cursor}}}"
        }
    };
}();
$5baefebdfa73b4d2$var$node.hash = "d919f41ac18e2cfc51a95f7043552fc1";
var $5baefebdfa73b4d2$export$2e2bcd8739ae039 = $5baefebdfa73b4d2$var$node;
module.exports["default"] = $5baefebdfa73b4d2$export$2e2bcd8739ae039;

});

parcelRegister("6KZ8B", function(module, exports) {
/**
 * Shared constants for the Starred Content Menu.
 *
 * These are extracted into a separate lightweight file to avoid pulling the
 * full StarredContentMenu component into chunks that only need these constants
 * (e.g. preloaders and hooks). This prevents tree-shaking defeats where a
 * back-reference from a lazy-loaded child would drag in the parent's heavy
 * dependencies.
 */ const $b7ba8e1c5f70de6c$export$776b5788fd07993d = {
    start: 0
};
module.exports["starredContentMenuQueryVars"] = $b7ba8e1c5f70de6c$export$776b5788fd07993d;

});

parcelRegister("XO4by", function(module, exports) {

var $d4Pk4 = parcelRequire("d4Pk4");


var $dYU3e = parcelRequire("dYU3e");


var $2fgSf = parcelRequire("2fgSf");


var $36tM8 = parcelRequire("36tM8");


var $djzYv = parcelRequire("djzYv");

function $f64f22d885b98eec$export$603721ee0464e7fd(cloudId) {
    return ((0, $2fgSf.shouldUseAGGActivityV3)() ? (0, $dYU3e.queryAgg) : (0, $dYU3e.query))({
        query: (0, $djzYv.default),
        variables: {
            cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            after: '',
            first: (0, $36tM8.PAGE_SIZE),
            eventTypes: [],
            objectTypes: (0, $36tM8.objectTypes)()
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "@confluence/side-navigation"
    });
}
module.exports["preloadRecentContentMenu"] = $f64f22d885b98eec$export$603721ee0464e7fd;

});

parcelRegister("iQcdJ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6a9Hv = parcelRequire("6a9Hv");


var $6bJyJ = parcelRequire("6bJyJ");


var $1yB28 = parcelRequire("1yB28");


var $1Zr9M = parcelRequire("1Zr9M");


var $6767u = parcelRequire("6767u");


var $5nBzc = parcelRequire("5nBzc");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $1YXTQ = parcelRequire("1YXTQ");


var $2fgSf = parcelRequire("2fgSf");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $bCECL = parcelRequire("bCECL");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $WG1VM = parcelRequire("WG1VM");


var $5V1fS = parcelRequire("5V1fS");

const $1195428fc846c248$export$bc82a767d3a2a41 = (params)=>{
    const $ = (0, $frIzR.c)(16);
    const intl = (0, $aXWIB.useIntl)();
    const selectedFilter = params.selectedFilters?.[0] || "ALL";
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t0;
    if ($[0] !== params.searchText || $[1] !== selectedFilter) {
        t0 = {
            searchText: params.searchText,
            selectedFilter: selectedFilter
        };
        $[0] = params.searchText;
        $[1] = selectedFilter;
        $[2] = t0;
    } else t0 = $[2];
    const { data: data, loading: loading, error: error, isUnauthorized: isUnauthorized, sections: rawSections, hasNextPage: hasNextPage, loadMore: loadMore } = $1195428fc846c248$export$5b0ada08b9b7bd62(t0);
    let t1;
    bb0: {
        if (error) {
            let t2;
            if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                t2 = [];
                $[3] = t2;
            } else t2 = $[3];
            t1 = t2;
            break bb0;
        }
        let result;
        if ($[4] !== intl || $[5] !== rawSections || $[6] !== selectedFilter) {
            result = [];
            for (const section of rawSections){
                if (section.nodes.length === 0) continue;
                const items = [];
                for (const node of section.nodes){
                    const content = node?.object?.content;
                    const url = node?.object?.url || "";
                    const { emoji: emoji, title: title } = content ? (0, $5V1fS.getContentEmojiAndTitle)(content) : {
                        emoji: undefined,
                        title: undefined
                    };
                    const isDraft = content?.status === "draft";
                    items.push({
                        elemBefore: content?.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
                            type: content.type,
                            subType: content?.subType,
                            emoji: emoji
                        }) : null,
                        elemAfter: isDraft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
                            appearance: "default"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $9wGTI.fg)("confluence_lozenge_text_update") ? $1195428fc846c248$export$a7357cdd1f0b0168.draftLozengeTextUpdated : $1195428fc846c248$export$a7357cdd1f0b0168.draftLozengeText)),
                        primaryLabel: title || intl.formatMessage((0, $5V1fS.i18n).untitled),
                        secondaryLabel: content?.space?.name || "",
                        tertiaryLabel: node?.timestamp ? (0, $1YXTQ.formatTimeAgo)(intl, node?.timestamp) : undefined,
                        href: url,
                        extendedSubItemAnalyticsAttributes: content ? {
                            componentType: "customItem",
                            contentType: content.type ?? null,
                            contentId: content.id ?? null,
                            contentStatus: content.status ?? null,
                            section: intl.formatMessage(section.title),
                            selectedFilter: selectedFilter,
                            isLivePage: content.subType === "live"
                        } : undefined
                    });
                }
                result.push({
                    header: intl.formatMessage(section.title),
                    items: items
                });
            }
            $[4] = intl;
            $[5] = rawSections;
            $[6] = selectedFilter;
            $[7] = result;
        } else result = $[7];
        t1 = result;
    }
    const sections = t1;
    let t2;
    bb1: {
        if (isUnauthorized) {
            let t3;
            if ($[8] !== intl) {
                t3 = new Error(intl.formatMessage($1195428fc846c248$export$a7357cdd1f0b0168.authErrorMessageTitle));
                $[8] = intl;
                $[9] = t3;
            } else t3 = $[9];
            t2 = t3;
            break bb1;
        }
        if (error) experienceTracker.stopOnError({
            name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
            error: error,
            attributes: {
                navVersion: "4",
                dropdownType: "recent"
            }
        });
        t2 = error;
    }
    const returnError = t2;
    const t3 = loading && !data;
    let t4;
    if ($[10] !== hasNextPage || $[11] !== loadMore || $[12] !== returnError || $[13] !== sections || $[14] !== t3) {
        t4 = {
            sections: sections,
            hasMore: hasNextPage,
            isLoading: t3,
            loadMore: loadMore,
            error: returnError
        };
        $[10] = hasNextPage;
        $[11] = loadMore;
        $[12] = returnError;
        $[13] = sections;
        $[14] = t3;
        $[15] = t4;
    } else t4 = $[15];
    return t4;
};
const $1195428fc846c248$export$5b0ada08b9b7bd62 = (params)=>{
    const $ = (0, $frIzR.c)(36);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = (0, $WG1VM.getQueryOptions)(cloudId);
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const queryOptions = t0;
    const selectedFilter = params.selectedFilter || "ALL";
    const searchText = params.searchText || "";
    const t1 = queryOptions[selectedFilter].query;
    const t2 = queryOptions[selectedFilter];
    const t3 = t2.initialVars;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $2fgSf.shouldUseAGGActivityV3)();
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== params.onCompleted || $[4] !== params.onError || $[5] !== t2.initialVars) {
        t5 = {
            variables: t3,
            fetchPolicy: "cache-and-network",
            interopApolloAggClient: t4,
            onCompleted: params.onCompleted,
            onError: params.onError
        };
        $[3] = params.onCompleted;
        $[4] = params.onError;
        $[5] = t2.initialVars;
        $[6] = t5;
    } else t5 = $[6];
    const { data: data, loading: loading, error: error, fetchMore: fetchMore } = (0, $jMyy4.useQueryInterop)(t1, {
        ...t5,
        __callerPackage__: "@confluence/side-navigation"
    });
    let t6;
    if ($[7] !== error) {
        t6 = error && (0, $1uFM6.isUnauthorizedError)(error);
        $[7] = error;
        $[8] = t6;
    } else t6 = $[8];
    const isUnauthorized = !!t6;
    let t7;
    bb0: {
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            let t8;
            if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
                t8 = [];
                $[9] = t8;
            } else t8 = $[9];
            t7 = t8;
            break bb0;
        }
        let t8;
        if ($[10] !== data || $[11] !== queryOptions || $[12] !== searchText || $[13] !== selectedFilter) {
            const lowerFilterText = searchText.toLowerCase();
            const nodes = queryOptions[selectedFilter].transformNodes(data);
            t8 = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(nodes?.filter((node)=>!searchText || node?.object?.content?.title?.toLowerCase().includes(lowerFilterText)).filter($1195428fc846c248$var$_temp).filter($1195428fc846c248$var$_temp2), $1195428fc846c248$var$_temp3) ?? [];
            $[10] = data;
            $[11] = queryOptions;
            $[12] = searchText;
            $[13] = selectedFilter;
            $[14] = t8;
        } else t8 = $[14];
        t7 = t8;
    }
    const filteredNodes = t7;
    let t8;
    if ($[15] !== filteredNodes) {
        t8 = $1195428fc846c248$export$19e8d4a05b9bbef(filteredNodes);
        $[15] = filteredNodes;
        $[16] = t8;
    } else t8 = $[16];
    const sections = t8;
    const t9 = queryOptions[selectedFilter];
    let t10;
    if ($[17] !== data || $[18] !== t9) {
        t10 = t9.getPaginationParams(data);
        $[17] = data;
        $[18] = t9;
        $[19] = t10;
    } else t10 = $[19];
    const { endCursor: endCursor, hasNextPage: hasNextPage } = t10;
    let t11;
    if ($[20] !== endCursor || $[21] !== fetchMore || $[22] !== hasNextPage || $[23] !== loading || $[24] !== queryOptions || $[25] !== selectedFilter) {
        t11 = ()=>{
            if (hasNextPage && endCursor && !loading) fetchMore({
                variables: queryOptions[selectedFilter].fetchMoreVars(endCursor),
                updateQuery: (prev, t12)=>{
                    const { fetchMoreResult: fetchMoreResult } = t12;
                    if (!fetchMoreResult) return prev;
                    return queryOptions[selectedFilter].updatePaginationResults(prev, fetchMoreResult);
                }
            });
        };
        $[20] = endCursor;
        $[21] = fetchMore;
        $[22] = hasNextPage;
        $[23] = loading;
        $[24] = queryOptions;
        $[25] = selectedFilter;
        $[26] = t11;
    } else t11 = $[26];
    const loadMore = t11;
    let t12;
    if ($[27] !== data || $[28] !== error || $[29] !== filteredNodes || $[30] !== hasNextPage || $[31] !== isUnauthorized || $[32] !== loadMore || $[33] !== loading || $[34] !== sections) {
        t12 = {
            data: data,
            loading: loading,
            error: error,
            isUnauthorized: isUnauthorized,
            filteredNodes: filteredNodes,
            sections: sections,
            hasNextPage: hasNextPage,
            loadMore: loadMore
        };
        $[27] = data;
        $[28] = error;
        $[29] = filteredNodes;
        $[30] = hasNextPage;
        $[31] = isUnauthorized;
        $[32] = loadMore;
        $[33] = loading;
        $[34] = sections;
        $[35] = t12;
    } else t12 = $[35];
    return t12;
};
const $1195428fc846c248$export$bf18e6ec9b4e3f2e = ()=>{
    const $ = (0, $frIzR.c)(29);
    const intl = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            "ALL"
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== intl) {
        t1 = intl.formatMessage($1195428fc846c248$export$a7357cdd1f0b0168.all);
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
            label: ""
        });
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1) {
        t3 = {
            key: "ALL",
            label: t1,
            elemBefore: t2
        };
        $[4] = t1;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== intl) {
        t4 = intl.formatMessage($1195428fc846c248$export$a7357cdd1f0b0168.collaboratedOn);
        $[6] = intl;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
            label: ""
        });
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t4) {
        t6 = {
            key: "COLLABORATED_ON",
            label: t4,
            elemBefore: t5
        };
        $[9] = t4;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== intl) {
        t7 = intl.formatMessage($1195428fc846c248$export$a7357cdd1f0b0168.workedOn);
        $[11] = intl;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
            label: ""
        });
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== t7) {
        t9 = {
            key: "WORKED_ON",
            label: t7,
            elemBefore: t8
        };
        $[14] = t7;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== intl) {
        t10 = intl.formatMessage($1195428fc846c248$export$a7357cdd1f0b0168.ownedByMe);
        $[16] = intl;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
            label: ""
        });
        $[18] = t11;
    } else t11 = $[18];
    let t12;
    if ($[19] !== t10) {
        t12 = {
            key: "CREATED_BY_ME",
            label: t10,
            elemBefore: t11
        };
        $[19] = t10;
        $[20] = t12;
    } else t12 = $[20];
    let t13;
    if ($[21] !== t12 || $[22] !== t3 || $[23] !== t6 || $[24] !== t9) {
        t13 = [
            t3,
            t6,
            t9,
            t12
        ];
        $[21] = t12;
        $[22] = t3;
        $[23] = t6;
        $[24] = t9;
        $[25] = t13;
    } else t13 = $[25];
    let t14;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = [
            "ALL"
        ];
        $[26] = t14;
    } else t14 = $[26];
    let t15;
    if ($[27] !== t13) {
        t15 = {
            defaultSelected: t0,
            filters: t13,
            hideSelectedFilterTag: t14
        };
        $[27] = t13;
        $[28] = t15;
    } else t15 = $[28];
    return t15;
};
const $1195428fc846c248$export$19e8d4a05b9bbef = (nodes)=>{
    const sections = [
        {
            title: $1195428fc846c248$export$a7357cdd1f0b0168.today,
            daysAgo: 0,
            nodes: [],
            sectionId: 'today'
        },
        {
            title: $1195428fc846c248$export$a7357cdd1f0b0168.yesterday,
            daysAgo: 1,
            nodes: [],
            sectionId: 'yesterday'
        },
        {
            title: $1195428fc846c248$export$a7357cdd1f0b0168.lastWeek,
            daysAgo: 7,
            nodes: [],
            sectionId: 'lastWeek'
        },
        {
            title: $1195428fc846c248$export$a7357cdd1f0b0168.lastMonth,
            daysAgo: 30,
            nodes: [],
            sectionId: 'lastMonth'
        },
        {
            title: $1195428fc846c248$export$a7357cdd1f0b0168.moreThanMonth,
            daysAgo: -1,
            nodes: [],
            sectionId: 'moreThanMonth'
        }
    ];
    let sectionIndex = 0;
    const startOfToday = new Date().setHours(0, 0, 0, 0);
    nodes?.forEach((node)=>{
        if (!node?.timestamp) {
            sections[4].nodes.push(node);
            return;
        }
        const nodeDate = new Date(node.timestamp).getTime();
        const daysDiff = Math.floor((startOfToday - nodeDate) / (1000 * 60 * 60 * 24));
        // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
        while(sectionIndex < sections.length - 1 && daysDiff >= sections[sectionIndex].daysAgo)sectionIndex++;
        sections[sectionIndex].nodes.push(node);
    });
    return sections;
};
const $1195428fc846c248$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    today: {
        id: "side-navigation.recent-content-menu.section.today",
        defaultMessage: "Today"
    },
    yesterday: {
        id: "side-navigation.recent-content-menu.section.yesterday",
        defaultMessage: "Yesterday"
    },
    lastWeek: {
        id: "side-navigation.recent-content-menu.section.last-week",
        defaultMessage: "In the last week"
    },
    lastMonth: {
        id: "side-navigation.recent-content-menu.section.last-month",
        defaultMessage: "In the last month"
    },
    moreThanMonth: {
        id: "side-navigation.recent-content-menu.section.more-than-month",
        defaultMessage: "More than a month ago"
    },
    authErrorMessageTitle: {
        id: "side-navigation.recent-content-menu.auth-error-message.title",
        defaultMessage: "You are not authorized to load recent items"
    },
    all: {
        id: "side-navigation.recent-content-menu.filter.all",
        defaultMessage: "All"
    },
    collaboratedOn: {
        id: "side-navigation.recent-content-menu.filter.collaborated-on",
        defaultMessage: "Collaborated on"
    },
    workedOn: {
        id: "side-navigation.recent-content-menu.filter.worked-on",
        defaultMessage: "Worked on"
    },
    ownedByMe: {
        id: "side-navigation.recent-content-menu.filter.owned-by-me",
        defaultMessage: "Owned by me"
    },
    draftLozengeText: {
        id: "side-navigation.content-menu.lozenge.draft",
        defaultMessage: "DRAFT"
    },
    draftLozengeTextUpdated: {
        id: "side-navigation.content-menu.lozenge.draft.updated",
        defaultMessage: "Draft"
    }
});
function $1195428fc846c248$var$_temp(node_0) {
    return node_0?.object?.content?.status !== "archived";
}
function $1195428fc846c248$var$_temp2(node_1) {
    return node_1?.object?.content?.status !== "trashed";
}
function $1195428fc846c248$var$_temp3(node_2) {
    return node_2?.object?.content?.id;
}
module.exports["useRecentItems"] = $1195428fc846c248$export$bc82a767d3a2a41;
module.exports["useRecentData"] = $1195428fc846c248$export$5b0ada08b9b7bd62;
module.exports["groupNodesIntoSections"] = $1195428fc846c248$export$19e8d4a05b9bbef;
module.exports["useRecentsFilterConfig"] = $1195428fc846c248$export$bf18e6ec9b4e3f2e;

});

parcelRegister("WG1VM", function(module, exports) {
/**
 * @generated SignedSource<<03e39487ab2371ea3f12d944231882ee>>
 * @relayHash b0fcea74a8ae19aa6b20b42be161dd3e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fc06c660797b6f4f7ebfac9cdfb8833d0c29f622a7895591d06dadc7dea25ab8
const $fd8955b92689005e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cqlcontext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = [
        {
            "alias": "search",
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                },
                {
                    "kind": "Variable",
                    "name": "cql",
                    "variableName": "cql"
                },
                {
                    "kind": "Variable",
                    "name": "cqlcontext",
                    "variableName": "cqlcontext"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_search",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSearchResponse",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "subType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "alias"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "webui"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "editui"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ContentMetadata",
                                    "kind": "LinkedField",
                                    "name": "metadata",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                            "kind": "LinkedField",
                                            "name": "currentuser",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "FavouritedSummary",
                                                    "kind": "LinkedField",
                                                    "name": "favourited",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isFavourite"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "favouritedDate"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "ContributionStatusSummary",
                                                    "kind": "LinkedField",
                                                    "name": "lastcontributed",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "when"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "alias": "emoji",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "keys",
                                            "value": [
                                                "emoji-title-published",
                                                "emoji-title-draft"
                                            ]
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JsonContentProperty",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "recentQueryConfigRecentlyCreatedByMeQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "recentQueryConfigRecentlyCreatedByMeQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "b0fcea74a8ae19aa6b20b42be161dd3e",
            "id": "fc06c660797b6f4f7ebfac9cdfb8833d0c29f622a7895591d06dadc7dea25ab8",
            "metadata": {},
            "name": "recentQueryConfigRecentlyCreatedByMeQuery",
            "operationKind": "query",
            "text": "query recentQueryConfigRecentlyCreatedByMeQuery($cql:String!,$cqlcontext:String!,$first:Int,$after:String){search:confluence_search(cql:$cql,cqlcontext:$cqlcontext,first:$first,after:$after){nodes{url,content{id,type,subType,title,status,space{id,name,alias},links{webui,editui},metadata{currentuser{favourited{isFavourite,favouritedDate},lastcontributed{status,when}}},emoji:properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$fd8955b92689005e$var$node.hash = "8d6f55a785a0bac07fd806ea1896d868";
var $fd8955b92689005e$export$2e2bcd8739ae039 = $fd8955b92689005e$var$node;



var $abN8T = parcelRequire("abN8T");


var $d4Pk4 = parcelRequire("d4Pk4");


var $jlIaF = parcelRequire("jlIaF");


var $c7GB4 = parcelRequire("c7GB4");


var $yuLaV = parcelRequire("yuLaV");


var $djzYv = parcelRequire("djzYv");

const $87679b46728de696$export$a62e7697f515af4e = (0, $djzYv.default);



var $36tM8 = parcelRequire("36tM8");

const $c69e7b592fedb17e$var$transformActivityNodeLegacyUrl = (activitiesNode)=>{
    const transformedNode = $c69e7b592fedb17e$var$transformActivityData(activitiesNode?.node);
    if (!transformedNode?.object?.content?.links?.webui) return transformedNode;
    return {
        ...transformedNode,
        object: {
            ...transformedNode.object,
            url: `${0, $jlIaF.CONTEXT_PATH}${transformedNode.object.content.links.webui}`,
            content: {
                ...transformedNode.object.content
            }
        }
    };
};
const $c69e7b592fedb17e$var$transformActivityData = (recent)=>{
    if (recent?.object?.data?.commentId) {
        recent.event.eventType = 'commented';
        recent.object.data = recent?.object?.data?.container;
    }
    // V3 -> V2 transformation widens strict GraphQL enum values (e.g. ConfluenceContentType,
    // ConfluenceContentStatus) to lowercase strings consumed by legacy V2 callers. The narrow
    // generated types reject these mutations, so we treat `content` as loosely typed here.
    // See TODO below — this whole block goes away in DISCO-4281.
    const content = recent?.object?.data;
    if (content) {
        content.type = content.type?.toLowerCase() === 'blog_post' ? 'blogpost' : content.type?.toLowerCase();
        content.subtype = content.subtype?.toLowerCase();
        // The "status" field is ConfluencePage/ConfluenceBlogPost type for pages/blogs but is
        // ConfluenceContentStatus type for all other content types. To prevent the GraphQL
        // "returns different types" error, we are using the aliases "pageStatus" and "blogStatus"
        content.status = [
            content.status,
            content.pageStatus,
            content.blogStatus
        ].find((status)=>status)?.toLowerCase();
        // FE workaround for activity query returning "status: DRAFT" for published content with unpublished changes
        if (content.status === 'draft' && content.createdAt) content.status = 'current';
    }
    if (recent?.event) recent.event.eventType = recent.event.eventType?.toUpperCase();
    const transformedId = content?.id && (0, $c7GB4.getIdFromConfluenceContentAri)({
        ari: content.id,
        resourceType: content.type
    });
    const recentData = recent?.object?.data;
    // TODO: This is currently transforming activity V3 data into activity V2 format. This
    // tranformation will be simplified in DISCO-4281
    const transformedContent = {
        ...recentData,
        id: transformedId,
        metadata: {
            ...recentData?.metadata,
            currentuser: {
                favourited: {
                    isFavourite: recentData?.viewer?.favoritedSummary?.isFavorite
                }
            }
        },
        links: {
            webui: recentData?.links?.webUi,
            editui: recentData?.links?.editUi
        },
        subType: recentData?.subtype,
        emoji: {
            nodes: [
                {
                    key: 'emoji-title-published',
                    value: recentData?.metadata?.titleEmojiPublished?.value
                },
                {
                    key: 'emoji-title-draft',
                    value: recentData?.metadata?.titleEmojiDraft?.value
                }
            ]
        }
    };
    return {
        ...recent,
        id: transformedId,
        timestamp: recent?.event?.timestamp,
        object: {
            ...recent?.object,
            content: transformedContent
        }
    };
};
const $c69e7b592fedb17e$var$mergeActivityMyActivityAllEdges = (prev, fetchMoreResult)=>{
    const prevNodes = prev.activity?.myActivity?.all?.edges || [];
    const fetchMoreNodes = fetchMoreResult.activity?.myActivity?.all?.edges || [];
    const mergedNodes = [
        ...prevNodes,
        ...fetchMoreNodes
    ];
    const result = {
        ...fetchMoreResult
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(result, 'activity.myActivity.all.edges', mergedNodes);
    return result;
};
const $c69e7b592fedb17e$var$getMyActivityAllPaginationParams = (data)=>{
    const allActivity = data?.activity?.myActivity?.all;
    return {
        endCursor: allActivity?.pageInfo?.endCursor || '',
        hasNextPage: allActivity?.pageInfo?.hasNextPage || false
    };
};
const $c69e7b592fedb17e$var$getAllRecentQueryOptions = (cloudId)=>({
        query: (0, $87679b46728de696$export$a62e7697f515af4e),
        initialVars: {
            cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            after: '',
            first: (0, $36tM8.PAGE_SIZE),
            eventTypes: [],
            objectTypes: (0, $36tM8.objectTypes)()
        },
        fetchMoreVars: (endCursor)=>({
                cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                    siteId: cloudId
                }).toString(),
                after: endCursor
            }),
        transformNodes: (data)=>(data?.activity?.myActivity?.all?.edges || []).map($c69e7b592fedb17e$var$transformActivityNodeLegacyUrl),
        getPaginationParams: $c69e7b592fedb17e$var$getMyActivityAllPaginationParams,
        updatePaginationResults: $c69e7b592fedb17e$var$mergeActivityMyActivityAllEdges
    });
const $c69e7b592fedb17e$var$getCollaboratedOnQueryOptions = (cloudId)=>({
        query: (0, $87679b46728de696$export$a62e7697f515af4e),
        initialVars: {
            cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            after: '',
            first: (0, $36tM8.PAGE_SIZE),
            eventTypes: (0, $36tM8.WORKED_ON_EVENT_TYPES),
            objectTypes: [
                ...(0, $36tM8.objectTypes)(),
                (0, $36tM8.ActivityObjectType).COMMENT
            ]
        },
        fetchMoreVars: (endCursor)=>({
                cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                    siteId: cloudId
                }).toString(),
                after: endCursor
            }),
        transformNodes: (data)=>(data?.activity?.myActivity?.all?.edges || []).map($c69e7b592fedb17e$var$transformActivityNodeLegacyUrl),
        getPaginationParams: $c69e7b592fedb17e$var$getMyActivityAllPaginationParams,
        updatePaginationResults: $c69e7b592fedb17e$var$mergeActivityMyActivityAllEdges
    });
const $c69e7b592fedb17e$var$getWorkedOnQueryOptions = (cloudId)=>({
        query: (0, $87679b46728de696$export$a62e7697f515af4e),
        initialVars: {
            cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            after: '',
            first: (0, $36tM8.PAGE_SIZE),
            eventTypes: (0, $36tM8.WORKED_ON_EVENT_TYPES),
            objectTypes: (0, $36tM8.objectTypes)()
        },
        fetchMoreVars: (endCursor)=>({
                cloudId: (0, $d4Pk4.PlatformSiteAri).create({
                    siteId: cloudId
                }).toString(),
                after: endCursor
            }),
        transformNodes: (data)=>(data?.activity?.myActivity?.all?.edges || []).map($c69e7b592fedb17e$var$transformActivityNodeLegacyUrl),
        getPaginationParams: $c69e7b592fedb17e$var$getMyActivityAllPaginationParams,
        updatePaginationResults: $c69e7b592fedb17e$var$mergeActivityMyActivityAllEdges
    });
const $c69e7b592fedb17e$var$mapCreatedByMeTabNodes = (node)=>{
    return {
        ...node,
        timestamp: node?.content?.metadata?.currentuser?.lastcontributed?.when,
        object: {
            url: `${0, $jlIaF.CONTEXT_PATH}${node.url}`,
            content: node.content
        }
    };
};
const $c69e7b592fedb17e$var$getCreatedByMeQueryOptions = ()=>{
    return {
        query: (0, $fd8955b92689005e$export$2e2bcd8739ae039),
        initialVars: {
            cql: `type in (page, blogpost, embed, whiteboard, database${(0, $yuLaV.isContentTypeEnabledInCurrentEnv)('slide') ? ', slide' : ''}) and owner=currentUser() and created >= startOfDay("-90d") order by created desc`,
            cqlcontext: `{"contentStatuses":["draft", "current"]}`,
            after: '',
            first: (0, $36tM8.PAGE_SIZE)
        },
        fetchMoreVars: (endCursor)=>({
                after: endCursor
            }),
        transformNodes: (data)=>(data?.search?.nodes || []).map($c69e7b592fedb17e$var$mapCreatedByMeTabNodes),
        getPaginationParams: (data)=>({
                endCursor: data?.search?.pageInfo?.endCursor || '',
                hasNextPage: data?.search?.pageInfo?.hasNextPage || false
            }),
        updatePaginationResults: (prev, fetchMoreResult)=>{
            const prevNodes = prev.search?.nodes || [];
            const fetchMoreNodes = fetchMoreResult.search?.nodes || [];
            const mergedNodes = [
                ...prevNodes,
                ...fetchMoreNodes
            ];
            const result = {
                ...fetchMoreResult
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(result, 'search.nodes', mergedNodes);
            return result;
        }
    };
};
const $c69e7b592fedb17e$export$175d7f1f999191e6 = (cloudId)=>{
    const queryOptions = {
        ALL: $c69e7b592fedb17e$var$getAllRecentQueryOptions(cloudId),
        COLLABORATED_ON: $c69e7b592fedb17e$var$getCollaboratedOnQueryOptions(cloudId),
        WORKED_ON: $c69e7b592fedb17e$var$getWorkedOnQueryOptions(cloudId),
        CREATED_BY_ME: $c69e7b592fedb17e$var$getCreatedByMeQueryOptions()
    };
    return queryOptions;
};
module.exports["getQueryOptions"] = $c69e7b592fedb17e$export$175d7f1f999191e6;

});

parcelRegister("26Pni", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $abN8T = parcelRequire("abN8T");


var $6a9Hv = parcelRequire("6a9Hv");


var $inPa6 = parcelRequire("inPa6");


var $5T18X = parcelRequire("5T18X");


var $jMyy4 = parcelRequire("jMyy4");


var $1YXTQ = parcelRequire("1YXTQ");


var $bCECL = parcelRequire("bCECL");


var $eFm27 = parcelRequire("eFm27");


var $jlIaF = parcelRequire("jlIaF");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $6KZ8B = parcelRequire("6KZ8B");


var $gSytF = parcelRequire("gSytF");


var $6y3LW = parcelRequire("6y3LW");


var $5V1fS = parcelRequire("5V1fS");

const $17ab53893dbb998b$export$9a473b3d087f0f67 = (params)=>{
    const $ = (0, $frIzR.c)(12);
    const intl = (0, $aXWIB.useIntl)();
    let t0;
    if ($[0] !== params.searchText) {
        t0 = {
            searchText: params.searchText
        };
        $[0] = params.searchText;
        $[1] = t0;
    } else t0 = $[1];
    const { data: data, loading: loading, error: error, filteredNodes: filteredNodes, hasNextPage: hasNextPage, loadMore: loadMore } = $17ab53893dbb998b$export$e3e9588fd2c1abdd(t0);
    let t1;
    bb0: {
        if (error) {
            let t2;
            if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
                t2 = [];
                $[2] = t2;
            } else t2 = $[2];
            t1 = t2;
            break bb0;
        }
        let t2;
        if ($[3] !== filteredNodes || $[4] !== intl) {
            const items = [];
            for (const node of filteredNodes){
                if (!node) continue;
                const { emoji: emoji, title: title } = (0, $5V1fS.getContentEmojiAndTitle)(node);
                items.push({
                    elemBefore: node.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bCECL.ContentIcon), {
                        type: node.type,
                        subType: node.subType,
                        emoji: emoji
                    }) : null,
                    elemAfter: node.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($17ab53893dbb998b$var$StarButton, {
                        contentId: node.id,
                        contentType: node.type,
                        isStarred: node.metadata?.currentuser?.favourited?.isFavourite || false
                    }) : undefined,
                    primaryLabel: title || intl.formatMessage((0, $5V1fS.i18n).untitled),
                    secondaryLabel: node.space?.name || "",
                    tertiaryLabel: node.metadata?.currentuser?.favourited?.favouritedDate ? (0, $1YXTQ.formatTimeAgo)(intl, node.metadata.currentuser.favourited.favouritedDate) : undefined,
                    href: `${(0, $jlIaF.CONTEXT_PATH)}${node.links?.webui || ""}`,
                    extendedSubItemAnalyticsAttributes: {
                        componentType: "customItem",
                        contentType: node.type ?? null,
                        contentId: node.id ?? null,
                        contentStatus: node.status ?? null,
                        isLivePage: node.subType === "live"
                    }
                });
            }
            t2 = items.length > 0 ? [
                {
                    header: "",
                    items: items
                }
            ] : [];
            $[3] = filteredNodes;
            $[4] = intl;
            $[5] = t2;
        } else t2 = $[5];
        t1 = t2;
    }
    const sections = t1;
    const t2 = loading && !data;
    const t3 = error || undefined;
    let t4;
    if ($[6] !== hasNextPage || $[7] !== loadMore || $[8] !== sections || $[9] !== t2 || $[10] !== t3) {
        t4 = {
            sections: sections,
            hasMore: hasNextPage,
            isLoading: t2,
            loadMore: loadMore,
            error: t3
        };
        $[6] = hasNextPage;
        $[7] = loadMore;
        $[8] = sections;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
};
const $17ab53893dbb998b$export$e3e9588fd2c1abdd = (params)=>{
    const $ = (0, $frIzR.c)(17);
    const searchText = params.searchText || "";
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            variables: (0, $6KZ8B.starredContentMenuQueryVars),
            fetchPolicy: "cache-and-network"
        };
        $[0] = t0;
    } else t0 = $[0];
    const { data: data, loading: loading, error: error, fetchMore: fetchMore, networkStatus: networkStatus } = (0, $jMyy4.useQueryInterop)((0, $gSytF.default), {
        ...t0,
        __callerPackage__: "@confluence/side-navigation"
    });
    const hasNextPage = data?.favoriteContent?.pageInfo?.hasNextPage || false;
    let t1;
    bb0: {
        if (error) {
            let t2;
            if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
                t2 = [];
                $[1] = t2;
            } else t2 = $[1];
            t1 = t2;
            break bb0;
        }
        let t2;
        if ($[2] !== data?.favoriteContent?.nodes || $[3] !== searchText) {
            const lowerFilterText = searchText.toLowerCase();
            t2 = (0, (/*@__PURE__*/$parcel$interopDefault($6a9Hv)))(data?.favoriteContent?.nodes?.filter((content)=>content !== null && content !== undefined && (!searchText || (content.title?.toLowerCase() || "").includes(lowerFilterText))), $17ab53893dbb998b$var$_temp) ?? [];
            $[2] = data?.favoriteContent?.nodes;
            $[3] = searchText;
            $[4] = t2;
        } else t2 = $[4];
        t1 = t2;
    }
    const filteredNodes = t1;
    let t2;
    if ($[5] !== data?.favoriteContent?.nodes?.length || $[6] !== fetchMore || $[7] !== hasNextPage || $[8] !== networkStatus) {
        t2 = ()=>{
            if (networkStatus === (0, $5T18X.NetworkStatus).ready && hasNextPage) $17ab53893dbb998b$export$102f63446941fd83(fetchMore, data?.favoriteContent?.nodes?.length || 0);
        };
        $[5] = data?.favoriteContent?.nodes?.length;
        $[6] = fetchMore;
        $[7] = hasNextPage;
        $[8] = networkStatus;
        $[9] = t2;
    } else t2 = $[9];
    data?.favoriteContent?.nodes;
    const loadMore = t2;
    if (error) experienceTracker.stopOnError({
        name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
        error: error,
        attributes: {
            navVersion: "4",
            dropdownType: "starred"
        }
    });
    let t3;
    if ($[10] !== data || $[11] !== error || $[12] !== filteredNodes || $[13] !== hasNextPage || $[14] !== loadMore || $[15] !== loading) {
        t3 = {
            data: data,
            loading: loading,
            error: error,
            filteredNodes: filteredNodes,
            hasNextPage: hasNextPage,
            loadMore: loadMore
        };
        $[10] = data;
        $[11] = error;
        $[12] = filteredNodes;
        $[13] = hasNextPage;
        $[14] = loadMore;
        $[15] = loading;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
};
const $17ab53893dbb998b$export$102f63446941fd83 = (fetchMore, start)=>{
    fetchMore({
        variables: {
            start: start
        },
        updateQuery: (prev, { fetchMoreResult: fetchMoreResult })=>{
            if (!fetchMoreResult) return prev;
            const prevEdges = prev.favoriteContent?.nodes || [];
            const fetchMoreEdges = fetchMoreResult.favoriteContent?.nodes || [];
            const mergedEdges = [
                ...prevEdges,
                ...fetchMoreEdges
            ];
            const result = {
                ...fetchMoreResult
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(result, 'favoriteContent.nodes', mergedEdges);
            return result;
        }
    });
};
const $17ab53893dbb998b$var$StarButton = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { contentId: contentId, contentType: contentType, isStarred: isStarred } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== contentId || $[1] !== contentType || $[2] !== createAnalyticsEvent) {
        t1 = ()=>{
            (0, $6y3LW.fireContentMenuItemClickedAnalytics)(createAnalyticsEvent, "starredNavigationMenuItem", {
                componentType: "customItemAction",
                itemId: "star",
                parentContentType: contentType,
                parentContentId: contentId
            })();
        };
        $[0] = contentId;
        $[1] = contentType;
        $[2] = createAnalyticsEvent;
        $[3] = t1;
    } else t1 = $[3];
    const onStar = t1;
    let t2;
    if ($[4] !== contentId || $[5] !== contentType || $[6] !== createAnalyticsEvent) {
        t2 = ()=>{
            (0, $6y3LW.fireContentMenuItemClickedAnalytics)(createAnalyticsEvent, "starredNavigationMenuItem", {
                componentType: "customItemAction",
                itemId: "unstar",
                parentContentType: contentType,
                parentContentId: contentId
            })();
        };
        $[4] = contentId;
        $[5] = contentType;
        $[6] = createAnalyticsEvent;
        $[7] = t2;
    } else t2 = $[7];
    const onUnstar = t2;
    let t3;
    if ($[8] !== contentId || $[9] !== isStarred || $[10] !== onStar || $[11] !== onUnstar) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eFm27.PageStarButton), {
            contentId: contentId,
            isStarred: isStarred,
            size: "small",
            tooltipPosition: "top",
            onStar: onStar,
            onUnstar: onUnstar,
            spacing: "none"
        });
        $[8] = contentId;
        $[9] = isStarred;
        $[10] = onStar;
        $[11] = onUnstar;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
};
function $17ab53893dbb998b$var$_temp(content_0) {
    return content_0?.id;
}
module.exports["useStarredItems"] = $17ab53893dbb998b$export$9a473b3d087f0f67;
module.exports["useStarredData"] = $17ab53893dbb998b$export$e3e9588fd2c1abdd;
module.exports["fetchMoreStarredContent"] = $17ab53893dbb998b$export$102f63446941fd83;

});

parcelRegister("6y3LW", function(module, exports) {
const $aac5b14b108aa083$export$744f6d2ef9fc49d7 = (createAnalyticsEvent, actionSubjectId, options)=>()=>{
        const { componentType: componentType, itemId: itemId, contentType: contentType, contentId: contentId, contentStatus: contentStatus, section: section, selectedFilter: selectedFilter, parentContentType: parentContentType, parentContentId: parentContentId } = options;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: actionSubjectId,
                source: 'globalNavigation',
                attributes: {
                    navigationLayer: 'global',
                    navigationContainer: 'sidebar',
                    navVersion: '4',
                    componentType: componentType,
                    itemId: itemId,
                    contentType: contentType,
                    contentId: contentId,
                    contentStatus: contentStatus,
                    section: section,
                    selectedFilter: selectedFilter,
                    parentContentType: parentContentType,
                    parentContentId: parentContentId
                }
            }
        }).fire();
    };
module.exports["fireContentMenuItemClickedAnalytics"] = $aac5b14b108aa083$export$744f6d2ef9fc49d7;

});

parcelRegister("hl4GB", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4PPzL = parcelRequire("4PPzL");


var $3IBnw = parcelRequire("3IBnw");

const $c6d4cc9cc1625e13$export$4af2c0efbfc684e8 = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            errorBoundaryId: "sideNavigation-globalNavigation"
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO,
            attributes: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
module.exports["DiscoErrorBoundary"] = $c6d4cc9cc1625e13$export$4af2c0efbfc684e8;

});

parcelRegister("jGeq1", function(module, exports) {

let $e53d1fd0e94a7b3e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e53d1fd0e94a7b3e$var$load("arKPj"),
    $e53d1fd0e94a7b3e$var$load("Wowvf"),
    $e53d1fd0e94a7b3e$var$load("1cMUZ")
]).then(()=>parcelRequire('1IQhI'));

});

parcelRegister("lJsxB", function(module, exports) {

let $fd23f0970e482406$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fd23f0970e482406$var$load("cRtGo"),
    $fd23f0970e482406$var$load("arKPj"),
    $fd23f0970e482406$var$load("3Bbwl"),
    $fd23f0970e482406$var$load("Wowvf"),
    $fd23f0970e482406$var$load("2yM8Y")
]).then(()=>parcelRequire('kIWbA'));

});

parcelRegister("1mG05", function(module, exports) {
const $0968601a95585f25$export$f817d2300729b821 = [
    'jira',
    'confluence'
];
const $0968601a95585f25$export$180016b363be5dc = [
    'confluence',
    'jira',
    'home'
];
const $0968601a95585f25$export$cebe16b091a89fcc = [
    'JIRA_SOFTWARE',
    'CONFLUENCE'
];
module.exports["INVITED_APP_SHORTCUTS_ALLOWED_TARGET_APPS"] = $0968601a95585f25$export$f817d2300729b821;
module.exports["INVITED_APP_SHORTCUTS_ALLOWED_SOURCE_APPS"] = $0968601a95585f25$export$180016b363be5dc;
module.exports["INVITED_APP_SHORTCUTS_ALLOWED_APS_KEYS"] = $0968601a95585f25$export$cebe16b091a89fcc;

});

parcelRegister("3Zy9L", function(module, exports) {

var $69QGC = parcelRequire("69QGC");


var $1gfUY = parcelRequire("1gfUY");

const $dd5e2face8bc024d$export$5391c0e0cb095e8a = async ({ cloudId: cloudId, products: products, userId: userId })=>{
    const collaborators = await (0, $69QGC.getUsersFromCollaborationGraph)('invitedAppShortcuts', cloudId, userId);
    if (collaborators.length === 0) return [];
    const collabsInProducts = await (0, $1gfUY.getPermittedUsersWithProducts)(products, cloudId, collaborators.map((c)=>c.id));
    return $dd5e2face8bc024d$var$mapToCollaboratorsWithProducts(collaborators, collabsInProducts);
};
const $dd5e2face8bc024d$var$mapToCollaboratorsWithProducts = (collaborators, usersWithProducts)=>collaborators.flatMap((collaborator)=>{
        const userWithProducts = usersWithProducts[collaborator.id];
        if (!(userWithProducts && userWithProducts.length > 0)) return [];
        return {
            collaborator: collaborator,
            products: userWithProducts
        };
    });
module.exports["getCollaboratorsInProducts"] = $dd5e2face8bc024d$export$5391c0e0cb095e8a;

});

parcelRegister("3v0xY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");

function $b3ea6dd191ed3e50$export$7613f0bd7ffe380c(icon, label, fallbackUrl, options) {
    const { labelElem: labelElem, apsKey: apsKey, ref: ref, analyticsName: analyticsName, menuItemId: menuItemId } = options ?? {};
    // Resolve the `MessageDescriptor` label up-front against the
    // `IntlProvider` in scope. The hook is called during render, so the
    // result tracks the active locale and re-resolves on locale change.
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const labelText = formatMessage(label);
    return (0, $42omo.useMemo)(()=>({
            type: 'link',
            icon: icon,
            label: labelText,
            labelElem: labelElem,
            apsKey: apsKey,
            fallbackUrl: fallbackUrl,
            ref: ref,
            analyticsName: analyticsName,
            ...menuItemId ? {
                menuItemId: menuItemId
            } : {}
        }), // Intentionally remove the ref, as it isn't needed by useMemo, and can cause extra rendering.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        analyticsName,
        apsKey,
        fallbackUrl,
        icon,
        labelElem,
        labelText,
        menuItemId
    ]);
}
module.exports["useAppGlobalShortcutLinkItem"] = $b3ea6dd191ed3e50$export$7613f0bd7ffe380c;

});

parcelRegister("GEjfy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAFHW = parcelRequire("lAFHW");


var $culkJ = parcelRequire("culkJ");


var $3v0xY = parcelRequire("3v0xY");


var $1EsaG = parcelRequire("1EsaG");

const $3dab1474f6c2c995$var$icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.TeamsIcon), {
    size: "xsmall",
    shouldUseNewLogoDesign: true,
    label: ""
});
const $3dab1474f6c2c995$export$6fe02dcc2001dcb0 = (fallbackUrl, options = {})=>(0, $3v0xY.useAppGlobalShortcutLinkItem)($3dab1474f6c2c995$var$icon, (0, $1EsaG.messages).label, fallbackUrl, {
        apsKey: (0, $culkJ.Products).ATLAS_TEAMS,
        analyticsName: (0, $culkJ.Products).ATLAS_TEAMS,
        ...options
    });
module.exports["useTeams"] = $3dab1474f6c2c995$export$6fe02dcc2001dcb0;

});

parcelRegister("djzYv", function(module, exports) {
/**
 * @generated SignedSource<<ddfc63ec73c6caadbc23beb8526520e6>>
 * @relayHash 9e08e7760b40221bcb9a0f22914592cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 13d357d5508b58b6109bb3a8a72939d1f174b8e1998c8f52583485f1631551ef
const $a9c4878f84ab4b9b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "eventTypes"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "objectTypes"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "eventTypes",
                            "variableName": "eventTypes"
                        },
                        {
                            "kind": "Variable",
                            "name": "objectTypes",
                            "variableName": "objectTypes"
                        },
                        {
                            "kind": "Literal",
                            "name": "products",
                            "value": [
                                "CONFLUENCE"
                            ]
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "arguments"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "rootContainerIds.0",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "rootContainerIds"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "AND"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v11 = {
        "kind": "ScalarField",
        "name": "webUi"
    }, v12 = [
        v11 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "editUi"
        }
    ], v13 = [
        {
            "concreteType": "ConfluenceFavoritedSummary",
            "kind": "LinkedField",
            "name": "favoritedSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavorite"
                }
            ]
        }
    ], v14 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v15 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v16 = {
        "concreteType": "ConfluenceContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ConfluenceContentTitleEmoji",
                "kind": "LinkedField",
                "name": "titleEmojiDraft",
                "plural": false,
                "selections": v15 /*: any*/ 
            },
            {
                "concreteType": "ConfluenceContentTitleEmoji",
                "kind": "LinkedField",
                "name": "titleEmojiPublished",
                "plural": false,
                "selections": v15 /*: any*/ 
            }
        ]
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "subtype"
            },
            {
                "alias": "pageStatus",
                "kind": "ScalarField",
                "name": "status"
            },
            v10 /*: any*/ ,
            {
                "concreteType": "ConfluencePageLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v12 /*: any*/ 
            },
            {
                "concreteType": "ConfluencePageViewerSummary",
                "kind": "LinkedField",
                "name": "viewer",
                "plural": false,
                "selections": v13 /*: any*/ 
            },
            v14 /*: any*/ ,
            v16 /*: any*/ 
        ],
        "type": "ConfluencePage"
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "alias": "blogStatus",
                "kind": "ScalarField",
                "name": "status"
            },
            v10 /*: any*/ ,
            {
                "concreteType": "ConfluenceBlogPostLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v12 /*: any*/ 
            },
            {
                "concreteType": "ConfluenceBlogPostViewerSummary",
                "kind": "LinkedField",
                "name": "viewer",
                "plural": false,
                "selections": v13 /*: any*/ 
            },
            v14 /*: any*/ ,
            v16 /*: any*/ 
        ],
        "type": "ConfluenceBlogPost"
    }, v19 = {
        "kind": "ScalarField",
        "name": "status"
    }, v20 = [
        v11 /*: any*/ 
    ], v21 = {
        "concreteType": "ConfluenceContentViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v13 /*: any*/ 
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v19 /*: any*/ ,
            {
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v20 /*: any*/ 
            },
            v21 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "ConfluenceWhiteboard"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v19 /*: any*/ ,
            {
                "concreteType": "ConfluenceDatabaseLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v20 /*: any*/ 
            },
            v21 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "ConfluenceDatabase"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v19 /*: any*/ ,
            {
                "concreteType": "ConfluenceSlideLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v20 /*: any*/ 
            },
            v21 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "ConfluenceSlide"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v19 /*: any*/ ,
            {
                "concreteType": "ConfluenceEmbedLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v20 /*: any*/ 
            },
            v21 /*: any*/ ,
            v14 /*: any*/ ,
            v16 /*: any*/ 
        ],
        "type": "ConfluenceEmbed"
    }, v26 = {
        "kind": "ScalarField",
        "name": "commentId"
    }, v27 = [
        v7 /*: any*/ ,
        v26 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v22 /*: any*/ 
            ]
        }
    ], v28 = {
        "concreteType": "ActivityEvent",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "timestamp"
            },
            {
                "kind": "ScalarField",
                "name": "eventType"
            }
        ]
    }, v29 = {
        "concreteType": "ActivityPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v30 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v31 = [
        v7 /*: any*/ 
    ], v32 = {
        "kind": "InlineFragment",
        "selections": v31 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v33 = [
        v7 /*: any*/ ,
        v26 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v30 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v22 /*: any*/ ,
                v32 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RecentContentMenuQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "all",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v25 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v27 /*: any*/ ,
                                                                            "type": "ConfluenceInlineComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v27 /*: any*/ ,
                                                                            "type": "ConfluenceFooterComment"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v28 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v29 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RecentContentMenuQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v5 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "all",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v30 /*: any*/ ,
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v25 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v33 /*: any*/ ,
                                                                            "type": "ConfluenceInlineComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v33 /*: any*/ ,
                                                                            "type": "ConfluenceFooterComment"
                                                                        },
                                                                        v32 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v31 /*: any*/ ,
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v31 /*: any*/ ,
                                                                            "type": "MercuryPortfolio"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v28 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v29 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "9e08e7760b40221bcb9a0f22914592cf",
            "id": "13d357d5508b58b6109bb3a8a72939d1f174b8e1998c8f52583485f1631551ef",
            "metadata": {},
            "name": "RecentContentMenuQuery",
            "operationKind": "query",
            "text": "query RecentContentMenuQuery($cloudId:ID!,$first:Int,$after:String,$eventTypes:[String!],$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND,rootContainerIds:[$cloudId],arguments:{products:[\"CONFLUENCE\"],objectTypes:$objectTypes,eventTypes:$eventTypes}},first:$first,after:$after){edges{cursor,node{id,object{id,data{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,createdAt,links{webUi,editUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name}},...on ConfluenceDatabase{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name}},...on ConfluenceSlide{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name}},...on ConfluenceEmbed{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceInlineComment{id,commentId,container{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,createdAt,links{webUi,editUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name}},...on Node{__isNode:__typename,id}}},...on ConfluenceFooterComment{id,commentId,container{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,createdAt,links{webUi,editUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},space{id,alias,key,name}},...on Node{__isNode:__typename,id}}},...on Node{__isNode:__typename,id},...on DevOpsPullRequestDetails{id},...on MercuryPortfolio{id}}},event{id,timestamp,eventType}}},pageInfo{hasNextPage,endCursor}}}}}"
        }
    };
}();
$a9c4878f84ab4b9b$var$node.hash = "f9585d13f5d9c4885250268904a58e2a";
var $a9c4878f84ab4b9b$export$2e2bcd8739ae039 = $a9c4878f84ab4b9b$var$node;
module.exports["default"] = $a9c4878f84ab4b9b$export$2e2bcd8739ae039;

});

parcelRegister("36tM8", function(module, exports) {
/**
 * Shared constants for the Recent Content Menu.
 *
 * These are extracted into a separate lightweight file to avoid pulling the
 * full recentQueryConfig module (which contains heavy query-building logic,
 * data transforms, and GraphQL queries) into chunks that only need these
 * constants (e.g. the preloader). This prevents tree-shaking defeats.
 */ 
var $yuLaV = parcelRequire("yuLaV");

var $aae031cb24e89c49$export$132f858337fea016 = /*#__PURE__*/ function(ActivityEventType) {
    ActivityEventType["ASSIGNED"] = "ASSIGNED";
    ActivityEventType["COMMENTED"] = "COMMENTED";
    ActivityEventType["CREATED"] = "CREATED";
    ActivityEventType["EDITED"] = "EDITED";
    ActivityEventType["LIKED"] = "LIKED";
    ActivityEventType["PUBLISHED"] = "PUBLISHED";
    ActivityEventType["SNAPSHOTTED"] = "SNAPSHOTTED";
    ActivityEventType["STARTED"] = "STARTED";
    ActivityEventType["TRANSITIONED"] = "TRANSITIONED";
    ActivityEventType["UNASSIGNED"] = "UNASSIGNED";
    ActivityEventType["UPDATED"] = "UPDATED";
    ActivityEventType["VIEWED"] = "VIEWED";
    return ActivityEventType;
}({});
var $aae031cb24e89c49$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["WHITEBOARD"] = "WHITEBOARD";
    ActivityObjectType["DATABASE"] = "DATABASE";
    ActivityObjectType["SLIDE"] = "SLIDE";
    ActivityObjectType["EMBED"] = "EMBED";
    ActivityObjectType["CONTENT"] = "CONTENT";
    ActivityObjectType["COMMENT"] = "COMMENT";
    return ActivityObjectType;
}({});
const $aae031cb24e89c49$export$8ec3d08588d2eeda = 30;
const $aae031cb24e89c49$export$c49cfb2681596b20 = [
    "PAGE",
    "BLOGPOST",
    "WHITEBOARD",
    "DATABASE",
    "SLIDE",
    "EMBED",
    "CONTENT"
];
function $aae031cb24e89c49$export$e0c1f83af18ea809() {
    return $aae031cb24e89c49$export$c49cfb2681596b20.filter((t)=>t !== "SLIDE" || (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('slide'));
}
const $aae031cb24e89c49$export$507c2df9171a0432 = [
    "EDITED",
    "PUBLISHED",
    "UPDATED",
    "CREATED",
    "STARTED",
    "SNAPSHOTTED"
];
module.exports["ActivityObjectType"] = $aae031cb24e89c49$export$d02a56686be43f69;
module.exports["PAGE_SIZE"] = $aae031cb24e89c49$export$8ec3d08588d2eeda;
module.exports["objectTypes"] = $aae031cb24e89c49$export$e0c1f83af18ea809;
module.exports["WORKED_ON_EVENT_TYPES"] = $aae031cb24e89c49$export$507c2df9171a0432;

});

parcelRegister("5V1fS", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $8rneB = parcelRequire("8rneB");


var $brn6e = parcelRequire("brn6e");


var $9wGTI = parcelRequire("9wGTI");

const $ae7788d51c7989c6$var$getEmoji = (content)=>{
    const emojiPropertyPublished = (0, $8rneB.getEmojiPublishedFromProperties)(content);
    const emojiPropertyDraft = (0, $8rneB.getEmojiDraftFromProperties)(content);
    const emoji = emojiPropertyPublished || emojiPropertyDraft || (0, $brn6e.getEmojiFromTitle)(content.title);
    return {
        hasEmojiProperty: Boolean(emojiPropertyPublished || emojiPropertyDraft),
        emoji: emoji
    };
};
const $ae7788d51c7989c6$var$isEmojiSupportedType = (type)=>!!type && (type !== 'whiteboard' || (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles'));
const $ae7788d51c7989c6$var$getTitle = (title, hasEmojiProperty)=>hasEmojiProperty ? title : (0, $brn6e.removeEmojiFromTitle)(title);
const $ae7788d51c7989c6$export$1d1036e75f38035e = (content)=>{
    if ($ae7788d51c7989c6$var$isEmojiSupportedType(content.type)) {
        const { emoji: emoji, hasEmojiProperty: hasEmojiProperty } = $ae7788d51c7989c6$var$getEmoji(content);
        return {
            emoji: emoji,
            title: $ae7788d51c7989c6$var$getTitle(content.title, hasEmojiProperty)
        };
    }
    return {
        emoji: undefined,
        title: content.title
    };
};
const $ae7788d51c7989c6$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    untitled: {
        id: "side-navigation.content-menu.untitled",
        defaultMessage: "Untitled"
    }
});
module.exports["getContentEmojiAndTitle"] = $ae7788d51c7989c6$export$1d1036e75f38035e;
module.exports["i18n"] = $ae7788d51c7989c6$export$a7357cdd1f0b0168;

});

parcelRegister("1gfUY", function(module, exports) {
const $87431fe3ef192df3$export$c25eadb566c78ee = async (products, cloudId, accountIds)=>{
    const response = await fetch('/gateway/api/growth/invite-notify-1p/get-permitted-users-with-products', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            cloudId: cloudId,
            products: products,
            accountIds: accountIds
        })
    });
    return await response.json();
};
module.exports["getPermittedUsersWithProducts"] = $87431fe3ef192df3$export$c25eadb566c78ee;

});

parcelRegister("1EsaG", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $6e45175315a8a66e$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    label: {
        id: "navigation.global-shortcuts.apps.teams",
        defaultMessage: "Teams"
    }
});
module.exports["messages"] = $6e45175315a8a66e$export$defe85febe8b728c;

});


//# sourceMappingURL=GlobalNavigationComponent.858b3cf7.js.map
